/* eslint-disable */
import { getLocale, experimentalStaticLocale } from "../runtime.js"

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} ActiveInputs */
/** @typedef {{}} Active_SubInputs */
/** @typedef {{}} ActivityInputs */
/** @typedef {{}} Activity_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Activity_Empty_PersonInputs */
/** @typedef {{}} Add_ChoreInputs */
/** @typedef {{}} Add_Home_FirstInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_DaysInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_HoursInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_MinutesInputs */
/** @typedef {{}} Ago_NowInputs */
/** @typedef {{}} AnyoneInputs */
/** @typedef {{}} App_TaglineInputs */
/** @typedef {{}} BackInputs */
/** @typedef {{}} Badge_Bonus10_DescInputs */
/** @typedef {{}} Badge_Bonus10_NameInputs */
/** @typedef {{}} Badge_Bonus_DescInputs */
/** @typedef {{}} Badge_Bonus_NameInputs */
/** @typedef {{}} Badge_Done10_DescInputs */
/** @typedef {{}} Badge_Done10_NameInputs */
/** @typedef {{}} Badge_Done250_DescInputs */
/** @typedef {{}} Badge_Done250_NameInputs */
/** @typedef {{}} Badge_Done50_DescInputs */
/** @typedef {{}} Badge_Done50_NameInputs */
/** @typedef {{}} Badge_Early_DescInputs */
/** @typedef {{}} Badge_Early_NameInputs */
/** @typedef {{}} Badge_First_DescInputs */
/** @typedef {{}} Badge_First_NameInputs */
/** @typedef {{}} Badge_Freeze_DescInputs */
/** @typedef {{}} Badge_Freeze_NameInputs */
/** @typedef {{}} Badge_Level10_DescInputs */
/** @typedef {{}} Badge_Level10_NameInputs */
/** @typedef {{}} Badge_Level5_DescInputs */
/** @typedef {{}} Badge_Level5_NameInputs */
/** @typedef {{}} Badge_Night_DescInputs */
/** @typedef {{}} Badge_Night_NameInputs */
/** @typedef {{}} Badge_Rare_DescInputs */
/** @typedef {{}} Badge_Rare_NameInputs */
/** @typedef {{}} Badge_Rescue_DescInputs */
/** @typedef {{}} Badge_Rescue_NameInputs */
/** @typedef {{}} Badge_Room_DescInputs */
/** @typedef {{}} Badge_Room_NameInputs */
/** @typedef {{}} Badge_Stickers10_DescInputs */
/** @typedef {{}} Badge_Stickers10_NameInputs */
/** @typedef {{}} Badge_Streak100_DescInputs */
/** @typedef {{}} Badge_Streak100_NameInputs */
/** @typedef {{}} Badge_Streak30_DescInputs */
/** @typedef {{}} Badge_Streak30_NameInputs */
/** @typedef {{}} Badge_Streak3_DescInputs */
/** @typedef {{}} Badge_Streak3_NameInputs */
/** @typedef {{}} Badge_Streak7_DescInputs */
/** @typedef {{}} Badge_Streak7_NameInputs */
/** @typedef {{}} Badge_Team_DescInputs */
/** @typedef {{}} Badge_Team_NameInputs */
/** @typedef {{}} BadgesInputs */
/** @typedef {{}} Big_JobInputs */
/** @typedef {{}} Big_JobsInputs */
/** @typedef {{}} BonusInputs */
/** @typedef {{}} Break_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Break_DaysInputs */
/** @typedef {{}} Break_EndInputs */
/** @typedef {{ date: NonNullable<unknown> }} Break_EndsInputs */
/** @typedef {{}} Break_How_LongInputs */
/** @typedef {{}} Break_ReassureInputs */
/** @typedef {{}} Break_SickInputs */
/** @typedef {{}} Break_Sick_TitleInputs */
/** @typedef {{}} Break_TitleInputs */
/** @typedef {{}} Break_TodayInputs */
/** @typedef {{}} Break_Two_WeeksInputs */
/** @typedef {{ date: NonNullable<unknown> }} Break_UntilInputs */
/** @typedef {{}} Break_VacationInputs */
/** @typedef {{}} Break_WeekInputs */
/** @typedef {{}} Break_WeekendInputs */
/** @typedef {{}} BuyInputs */
/** @typedef {{ price: NonNullable<unknown>, pet: NonNullable<unknown> }} Buy_Confirm_BodyInputs */
/** @typedef {{ item: NonNullable<unknown> }} Buy_Confirm_TitleInputs */
/** @typedef {{}} Calendar_BreakInputs */
/** @typedef {{}} Calendar_CopiedInputs */
/** @typedef {{}} Calendar_CopyInputs */
/** @typedef {{}} Calendar_CreateInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Calendar_DoneInputs */
/** @typedef {{}} Calendar_GoogleInputs */
/** @typedef {{}} Calendar_GuestsInputs */
/** @typedef {{}} Calendar_IntroInputs */
/** @typedef {{}} Calendar_LinkedInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Calendar_MinutesInputs */
/** @typedef {{ household: NonNullable<unknown> }} Calendar_NameInputs */
/** @typedef {{}} Calendar_OpenInputs */
/** @typedef {{}} Calendar_PrivateInputs */
/** @typedef {{}} Calendar_ResetInputs */
/** @typedef {{}} Calendar_Row_OnInputs */
/** @typedef {{}} Calendar_Row_SubInputs */
/** @typedef {{}} Calendar_StopInputs */
/** @typedef {{}} Calendar_TitleInputs */
/** @typedef {{}} Calendar_YoursInputs */
/** @typedef {{}} CancelInputs */
/** @typedef {{}} Chore_AddedInputs */
/** @typedef {{}} Chore_AquariumInputs */
/** @typedef {{}} Chore_BalconyInputs */
/** @typedef {{}} Chore_Bath_MatsInputs */
/** @typedef {{}} Chore_Bathroom_FloorInputs */
/** @typedef {{}} Chore_Bathroom_SinkInputs */
/** @typedef {{}} Chore_BathtubInputs */
/** @typedef {{}} Chore_BinInputs */
/** @typedef {{}} Chore_Bird_CageInputs */
/** @typedef {{}} Chore_CabinetsInputs */
/** @typedef {{}} Chore_CageInputs */
/** @typedef {{}} Chore_CurtainsInputs */
/** @typedef {{}} Chore_Descale_KettleInputs */
/** @typedef {{}} Chore_DeskInputs */
/** @typedef {{}} Chore_Dining_TableInputs */
/** @typedef {{}} Chore_Dishwasher_FilterInputs */
/** @typedef {{}} Chore_DoorsInputs */
/** @typedef {{}} Chore_DrawerInputs */
/** @typedef {{}} Chore_Dryer_LintInputs */
/** @typedef {{}} Chore_DustInputs */
/** @typedef {{}} Chore_FansInputs */
/** @typedef {{}} Chore_FreezerInputs */
/** @typedef {{}} Chore_Fridge_ClearoutInputs */
/** @typedef {{}} Chore_Fridge_DeepInputs */
/** @typedef {{}} Chore_GarageInputs */
/** @typedef {{}} Chore_Garden_FurnitureInputs */
/** @typedef {{}} Chore_GroutInputs */
/** @typedef {{}} Chore_Guest_RoomInputs */
/** @typedef {{}} Chore_GuttersInputs */
/** @typedef {{}} Chore_HallwayInputs */
/** @typedef {{}} Chore_Hood_FilterInputs */
/** @typedef {{}} Chore_Kitchen_SinkInputs */
/** @typedef {{}} Chore_Laundry_RoomInputs */
/** @typedef {{}} Chore_Litter_BoxInputs */
/** @typedef {{}} Chore_MattressInputs */
/** @typedef {{}} Chore_MicrowaveInputs */
/** @typedef {{}} Chore_Mop_KitchenInputs */
/** @typedef {{ n: NonNullable<unknown>, total: NonNullable<unknown> }} Chore_N_OfInputs */
/** @typedef {{}} Chore_Name_LabelInputs */
/** @typedef {{}} Chore_NightstandInputs */
/** @typedef {{}} Chore_OvenInputs */
/** @typedef {{}} Chore_PantryInputs */
/** @typedef {{}} Chore_Pet_BedInputs */
/** @typedef {{}} Chore_Pet_BowlsInputs */
/** @typedef {{}} Chore_Pet_HairInputs */
/** @typedef {{}} Chore_Pet_ToysInputs */
/** @typedef {{}} Chore_PillowsInputs */
/** @typedef {{}} Chore_PlaceholderInputs */
/** @typedef {{}} Chore_Plant_LeavesInputs */
/** @typedef {{}} Chore_PlantsInputs */
/** @typedef {{}} Chore_RadiatorsInputs */
/** @typedef {{}} Chore_RugsInputs */
/** @typedef {{}} Chore_ScreensInputs */
/** @typedef {{}} Chore_SheetsInputs */
/** @typedef {{}} Chore_ShowerInputs */
/** @typedef {{}} Chore_Shower_CurtainInputs */
/** @typedef {{}} Chore_ShowerheadInputs */
/** @typedef {{}} Chore_SkirtingInputs */
/** @typedef {{}} Chore_Smoke_AlarmsInputs */
/** @typedef {{}} Chore_SofaInputs */
/** @typedef {{}} Chore_StairsInputs */
/** @typedef {{}} Chore_StovetopInputs */
/** @typedef {{}} Chore_SwitchesInputs */
/** @typedef {{}} Chore_ToiletInputs */
/** @typedef {{}} Chore_Toilet_BasinInputs */
/** @typedef {{}} Chore_Under_BedInputs */
/** @typedef {{}} Chore_Vacuum_FilterInputs */
/** @typedef {{}} Chore_Vacuum_LivingInputs */
/** @typedef {{}} Chore_WardrobeInputs */
/** @typedef {{}} Chore_Washing_MachineInputs */
/** @typedef {{}} Chore_WeedingInputs */
/** @typedef {{}} Chore_Windows_InsideInputs */
/** @typedef {{}} Chore_Windows_OutsideInputs */
/** @typedef {{ count: NonNullable<unknown> }} Chores_CountInputs */
/** @typedef {{ count: NonNullable<unknown> }} Chores_OnInputs */
/** @typedef {{}} CleanlinessInputs */
/** @typedef {{}} CloseInputs */
/** @typedef {{}} Coins_LabelInputs */
/** @typedef {{ count: NonNullable<unknown> }} Coins_NInputs */
/** @typedef {{}} ColourInputs */
/** @typedef {{}} CompanionInputs */
/** @typedef {{}} Confirm_Delete_ChoreInputs */
/** @typedef {{ household: NonNullable<unknown> }} Confirm_LeaveInputs */
/** @typedef {{}} Confirm_Sign_OutInputs */
/** @typedef {{}} _ContinueInputs */
/** @typedef {{}} Copy_CodeInputs */
/** @typedef {{}} Crash_BodyInputs */
/** @typedef {{}} Crash_TitleInputs */
/** @typedef {{}} Create_HouseholdInputs */
/** @typedef {{}} Daily_TimeInputs */
/** @typedef {{}} Daily_Time_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Days_OverdueInputs */
/** @typedef {{}} _DeleteInputs */
/** @typedef {{}} Delete_ChoreInputs */
/** @typedef {{ os: NonNullable<unknown> }} Device_AppInputs */
/** @typedef {{}} Device_CodeInputs */
/** @typedef {{}} Device_GenericInputs */
/** @typedef {{ browser: NonNullable<unknown>, os: NonNullable<unknown> }} Device_NameInputs */
/** @typedef {{}} DoneInputs */
/** @typedef {{}} Done_ButtonInputs */
/** @typedef {{}} Done_For_TodayInputs */
/** @typedef {{}} Dry_DayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Due_In_DaysInputs */
/** @typedef {{}} Due_TodayInputs */
/** @typedef {{}} Due_TomorrowInputs */
/** @typedef {{ hours: NonNullable<unknown> }} Duration_HInputs */
/** @typedef {{ hours: NonNullable<unknown>, minutes: NonNullable<unknown> }} Duration_H_MInputs */
/** @typedef {{}} Easier_OneInputs */
/** @typedef {{}} Edit_ChoreInputs */
/** @typedef {{}} EffortInputs */
/** @typedef {{}} Effort_1Inputs */
/** @typedef {{}} Effort_2Inputs */
/** @typedef {{}} Effort_3Inputs */
/** @typedef {{}} Err_Already_DoneInputs */
/** @typedef {{}} Err_Assignment_Not_FoundInputs */
/** @typedef {{}} Err_AvatarInputs */
/** @typedef {{}} Err_Bonus_Needs_DailyInputs */
/** @typedef {{}} Err_Bonus_NoneInputs */
/** @typedef {{}} Err_Bonus_PendingInputs */
/** @typedef {{}} Err_Chore_NameInputs */
/** @typedef {{}} Err_Chore_Not_FoundInputs */
/** @typedef {{}} Err_CodeInputs */
/** @typedef {{}} Err_ForbiddenInputs */
/** @typedef {{}} Err_Freezes_FullInputs */
/** @typedef {{}} Err_FreqInputs */
/** @typedef {{}} Err_GenericInputs */
/** @typedef {{}} Err_Guests_DateInputs */
/** @typedef {{}} Err_High_Five_SelfInputs */
/** @typedef {{}} Err_Household_NameInputs */
/** @typedef {{ count: NonNullable<unknown> }} Err_Household_Too_SmallInputs */
/** @typedef {{}} Err_InvalidInputs */
/** @typedef {{}} Err_Invite_CodeInputs */
/** @typedef {{}} Err_Invite_Not_FoundInputs */
/** @typedef {{}} Err_Item_OwnedInputs */
/** @typedef {{}} Err_Link_InvalidInputs */
/** @typedef {{}} Err_Member_Not_FoundInputs */
/** @typedef {{}} Err_No_ConnectionInputs */
/** @typedef {{}} Err_No_Swap_OptionInputs */
/** @typedef {{}} Err_Not_Enough_CoinsInputs */
/** @typedef {{}} Err_Not_FoundInputs */
/** @typedef {{}} Err_Nothing_To_SwapInputs */
/** @typedef {{}} Err_OfflineInputs */
/** @typedef {{}} Err_OwnerInputs */
/** @typedef {{}} Err_Pause_PastInputs */
/** @typedef {{}} Err_Pause_Too_LongInputs */
/** @typedef {{}} Err_People_MaxInputs */
/** @typedef {{}} Err_People_MinInputs */
/** @typedef {{}} Err_Pet_NameInputs */
/** @typedef {{}} Err_Photo_InvalidInputs */
/** @typedef {{}} Err_Photo_Too_BigInputs */
/** @typedef {{}} Err_Places_UnavailableInputs */
/** @typedef {{}} Err_Project_Last_StepInputs */
/** @typedef {{}} Err_Project_NameInputs */
/** @typedef {{}} Err_Project_StepsInputs */
/** @typedef {{}} Err_Push_SubscriptionInputs */
/** @typedef {{}} Err_Rate_LimitedInputs */
/** @typedef {{}} Err_RoomInputs */
/** @typedef {{}} Err_Schedule_EmptyInputs */
/** @typedef {{}} Err_ServerInputs */
/** @typedef {{}} Err_Sign_InInputs */
/** @typedef {{}} Err_Sign_In_AgainInputs */
/** @typedef {{}} Err_Step_NameInputs */
/** @typedef {{}} Err_Supplies_FullInputs */
/** @typedef {{}} Err_Supply_NameInputs */
/** @typedef {{}} Err_Swap_UsedInputs */
/** @typedef {{}} Err_Time_FormatInputs */
/** @typedef {{}} Err_TimeoutInputs */
/** @typedef {{}} Err_Timer_MinutesInputs */
/** @typedef {{}} Err_Timers_FullInputs */
/** @typedef {{}} Err_Too_LargeInputs */
/** @typedef {{}} Err_Too_LongInputs */
/** @typedef {{}} Err_Trade_GoneInputs */
/** @typedef {{}} Err_Trade_NothingInputs */
/** @typedef {{}} Err_Trade_OwnedInputs */
/** @typedef {{}} Err_Treat_NameInputs */
/** @typedef {{}} Err_Treat_PriceInputs */
/** @typedef {{}} Err_Treats_FullInputs */
/** @typedef {{}} Err_TzInputs */
/** @typedef {{}} Err_Your_NameInputs */
/** @typedef {{}} Every_How_Many_DaysInputs */
/** @typedef {{}} EveryoneInputs */
/** @typedef {{}} ExpiredInputs */
/** @typedef {{ time: NonNullable<unknown> }} Expires_InInputs */
/** @typedef {{}} Fair_ShareInputs */
/** @typedef {{}} Fair_Share_EmptyInputs */
/** @typedef {{ days: NonNullable<unknown> }} Fair_Share_HintInputs */
/** @typedef {{}} First_Badge_HintInputs */
/** @typedef {{ sticker: NonNullable<unknown> }} Found_StickerInputs */
/** @typedef {{}} Freeze_BoughtInputs */
/** @typedef {{ price: NonNullable<unknown> }} Freeze_Confirm_BodyInputs */
/** @typedef {{}} Freeze_Confirm_TitleInputs */
/** @typedef {{}} Freeze_CoveredInputs */
/** @typedef {{}} Freeze_EarnedInputs */
/** @typedef {{}} Freeze_Earned_SubInputs */
/** @typedef {{}} Freeze_FullInputs */
/** @typedef {{}} Freeze_ItemInputs */
/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Freeze_Item_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freezes_CountInputs */
/** @typedef {{}} Freq_2monthsInputs */
/** @typedef {{}} Freq_2weeksInputs */
/** @typedef {{}} Freq_3monthsInputs */
/** @typedef {{}} Freq_CustomInputs */
/** @typedef {{}} Freq_DailyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freq_Every_DaysInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freq_Every_WeeksInputs */
/** @typedef {{}} Freq_MonthlyInputs */
/** @typedef {{}} Freq_Twice_YearInputs */
/** @typedef {{}} Freq_WeeklyInputs */
/** @typedef {{}} Freq_YearlyInputs */
/** @typedef {{}} Fully_GrownInputs */
/** @typedef {{}} Furniture_AquariumInputs */
/** @typedef {{}} Furniture_BookcaseInputs */
/** @typedef {{}} Furniture_ClockInputs */
/** @typedef {{}} Furniture_CushionInputs */
/** @typedef {{}} Furniture_Disco_BallInputs */
/** @typedef {{}} Furniture_DotsInputs */
/** @typedef {{}} Furniture_Fairy_LightsInputs */
/** @typedef {{}} Furniture_Floor_LampInputs */
/** @typedef {{}} Furniture_PaintingInputs */
/** @typedef {{ pet: NonNullable<unknown>, item: NonNullable<unknown> }} Furniture_PermissionInputs */
/** @typedef {{}} Furniture_PlantInputs */
/** @typedef {{}} Furniture_RugInputs */
/** @typedef {{}} Furniture_ShelfInputs */
/** @typedef {{}} Furniture_StripesInputs */
/** @typedef {{}} Furniture_WindowInputs */
/** @typedef {{ date: NonNullable<unknown> }} Guests_BannerInputs */
/** @typedef {{}} Guests_ClearInputs */
/** @typedef {{}} Guests_IntroInputs */
/** @typedef {{ date: NonNullable<unknown> }} Guests_OnInputs */
/** @typedef {{}} Guests_PickInputs */
/** @typedef {{}} Guests_RowInputs */
/** @typedef {{}} Guests_Row_SubInputs */
/** @typedef {{}} Guests_TitleInputs */
/** @typedef {{}} Guests_TomorrowInputs */
/** @typedef {{ count: NonNullable<unknown> }} Hide_InactiveInputs */
/** @typedef {{}} High_FiveInputs */
/** @typedef {{}} High_FivedInputs */
/** @typedef {{}} HistoryInputs */
/** @typedef {{}} History_EmptyInputs */
/** @typedef {{}} Home_IntroInputs */
/** @typedef {{}} Home_Pet_BirdInputs */
/** @typedef {{}} Home_Pet_CatInputs */
/** @typedef {{}} Home_Pet_DogInputs */
/** @typedef {{}} Home_Pet_FishInputs */
/** @typedef {{}} Home_Pet_Small_PetInputs */
/** @typedef {{}} Home_SavedInputs */
/** @typedef {{}} Home_Space_BalconyInputs */
/** @typedef {{}} Home_Space_DiningInputs */
/** @typedef {{}} Home_Space_GarageInputs */
/** @typedef {{}} Home_Space_GardenInputs */
/** @typedef {{}} Home_Space_Guest_RoomInputs */
/** @typedef {{}} Home_Space_LaundryInputs */
/** @typedef {{}} Home_Space_OfficeInputs */
/** @typedef {{}} Home_Space_StairsInputs */
/** @typedef {{}} Home_Thing_BathtubInputs */
/** @typedef {{}} Home_Thing_DishwasherInputs */
/** @typedef {{}} Home_Thing_DryerInputs */
/** @typedef {{}} Home_Thing_PlantsInputs */
/** @typedef {{}} Home_TitleInputs */
/** @typedef {{}} Home_Type_ApartmentInputs */
/** @typedef {{}} Home_Type_HouseInputs */
/** @typedef {{}} HouseholdInputs */
/** @typedef {{}} Household_NameInputs */
/** @typedef {{}} Household_Name_PlaceholderInputs */
/** @typedef {{ months: NonNullable<unknown> }} In_SeasonInputs */
/** @typedef {{}} Install_BodyInputs */
/** @typedef {{}} Install_ButtonInputs */
/** @typedef {{}} Install_Done_BodyInputs */
/** @typedef {{}} Install_Done_TitleInputs */
/** @typedef {{}} Install_Invite_NoteInputs */
/** @typedef {{}} Install_Ios_1Inputs */
/** @typedef {{}} Install_Ios_2Inputs */
/** @typedef {{}} Install_OpenInputs */
/** @typedef {{}} Install_Other_1Inputs */
/** @typedef {{}} Install_Other_2Inputs */
/** @typedef {{}} Install_SkipInputs */
/** @typedef {{}} Install_TitleInputs */
/** @typedef {{}} Invite_CodeInputs */
/** @typedef {{ code: NonNullable<unknown> }} Invite_Code_ToastInputs */
/** @typedef {{}} Invite_CopiedInputs */
/** @typedef {{ household: NonNullable<unknown>, code: NonNullable<unknown> }} Invite_TextInputs */
/** @typedef {{}} Invite_WarningInputs */
/** @typedef {{}} Ios_Home_ScreenInputs */
/** @typedef {{}} Item_BeanieInputs */
/** @typedef {{}} Item_BikiniInputs */
/** @typedef {{}} Item_BowInputs */
/** @typedef {{}} Item_BroomInputs */
/** @typedef {{}} Item_FlowerInputs */
/** @typedef {{}} Item_GlassesInputs */
/** @typedef {{}} Item_Party_HatInputs */
/** @typedef {{ pet: NonNullable<unknown>, item: NonNullable<unknown> }} Item_PermissionInputs */
/** @typedef {{}} Item_ScarfInputs */
/** @typedef {{}} Item_SunglassesInputs */
/** @typedef {{}} Item_SunhatInputs */
/** @typedef {{}} JoinInputs */
/** @typedef {{}} Join_HouseholdInputs */
/** @typedef {{}} Keep_ListInputs */
/** @typedef {{}} LanguageInputs */
/** @typedef {{ language: NonNullable<unknown> }} Language_AutoInputs */
/** @typedef {{}} Last_7_DaysInputs */
/** @typedef {{ when: NonNullable<unknown> }} Last_ActiveInputs */
/** @typedef {{}} Last_DoneInputs */
/** @typedef {{ when: NonNullable<unknown>, name: NonNullable<unknown> }} Last_Done_ByInputs */
/** @typedef {{ count: NonNullable<unknown> }} Last_Done_DaysInputs */
/** @typedef {{}} Last_Done_TodayInputs */
/** @typedef {{}} Last_Done_YesterdayInputs */
/** @typedef {{}} Ld_Few_DaysInputs */
/** @typedef {{}} Ld_Few_MonthsInputs */
/** @typedef {{}} Ld_MonthInputs */
/** @typedef {{}} Ld_TodayInputs */
/** @typedef {{}} Ld_Two_WeeksInputs */
/** @typedef {{}} Ld_WeekInputs */
/** @typedef {{}} Ld_YearInputs */
/** @typedef {{}} Ld_YesterdayInputs */
/** @typedef {{}} Leave_HouseholdInputs */
/** @typedef {{ level: NonNullable<unknown> }} Level_NInputs */
/** @typedef {{}} Level_Title_0Inputs */
/** @typedef {{}} Level_Title_1Inputs */
/** @typedef {{}} Level_Title_10Inputs */
/** @typedef {{}} Level_Title_2Inputs */
/** @typedef {{}} Level_Title_3Inputs */
/** @typedef {{}} Level_Title_4Inputs */
/** @typedef {{}} Level_Title_5Inputs */
/** @typedef {{}} Level_Title_6Inputs */
/** @typedef {{}} Level_Title_7Inputs */
/** @typedef {{}} Level_Title_8Inputs */
/** @typedef {{}} Level_Title_9Inputs */
/** @typedef {{ title: NonNullable<unknown> }} Level_Up_SubInputs */
/** @typedef {{}} Link_DeviceInputs */
/** @typedef {{}} Link_Device_SubInputs */
/** @typedef {{}} Link_IntroInputs */
/** @typedef {{}} Link_Sheet_BodyInputs */
/** @typedef {{}} Link_TitleInputs */
/** @typedef {{}} Load_Error_TitleInputs */
/** @typedef {{}} LoadingInputs */
/** @typedef {{}} Mark_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Mark_X_DoneInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Minutes_ShortInputs */
/** @typedef {{}} Mood_GrumpyInputs */
/** @typedef {{}} Mood_HappyInputs */
/** @typedef {{}} Mood_MehInputs */
/** @typedef {{}} Mood_SadInputs */
/** @typedef {{}} Mood_ThrivingInputs */
/** @typedef {{}} NameInputs */
/** @typedef {{}} Never_MindInputs */
/** @typedef {{}} New_ChoreInputs */
/** @typedef {{}} New_CodeInputs */
/** @typedef {{}} New_HouseholdInputs */
/** @typedef {{}} New_RoomInputs */
/** @typedef {{}} Next_BadgesInputs */
/** @typedef {{}} No_Chores_AvailableInputs */
/** @typedef {{}} No_StreakInputs */
/** @typedef {{}} Not_Done_YetInputs */
/** @typedef {{}} Not_NowInputs */
/** @typedef {{}} Not_SureInputs */
/** @typedef {{}} NotesInputs */
/** @typedef {{}} Notes_HintInputs */
/** @typedef {{}} Notes_PlaceholderInputs */
/** @typedef {{}} Nothing_PickedInputs */
/** @typedef {{}} Notif_DailyInputs */
/** @typedef {{}} Notif_Daily_SubInputs */
/** @typedef {{}} Notif_RecapInputs */
/** @typedef {{}} Notif_Recap_SubInputs */
/** @typedef {{}} Notif_StreakInputs */
/** @typedef {{}} Notif_Streak_SubInputs */
/** @typedef {{}} Notif_TeamInputs */
/** @typedef {{}} Notif_Team_SubInputs */
/** @typedef {{}} NotificationsInputs */
/** @typedef {{}} OffInputs */
/** @typedef {{}} Off_This_DeviceInputs */
/** @typedef {{}} Offline_BannerInputs */
/** @typedef {{}} On_A_BreakInputs */
/** @typedef {{ count: NonNullable<unknown> }} Overdue_CountInputs */
/** @typedef {{}} PeopleInputs */
/** @typedef {{ count: NonNullable<unknown> }} People_CountInputs */
/** @typedef {{}} People_HintInputs */
/** @typedef {{}} People_QuestionInputs */
/** @typedef {{}} People_SubInputs */
/** @typedef {{ perDay: NonNullable<unknown> }} Per_Day_NeededInputs */
/** @typedef {{}} Pet_Bunny_Stage_0Inputs */
/** @typedef {{}} Pet_Bunny_Stage_1Inputs */
/** @typedef {{}} Pet_Bunny_Stage_2Inputs */
/** @typedef {{}} Pet_Bunny_Stage_3Inputs */
/** @typedef {{}} Pet_Bunny_Stage_4Inputs */
/** @typedef {{}} Pet_Bunny_Stage_5Inputs */
/** @typedef {{}} Pet_Cat_Stage_0Inputs */
/** @typedef {{}} Pet_Cat_Stage_1Inputs */
/** @typedef {{}} Pet_Cat_Stage_2Inputs */
/** @typedef {{}} Pet_Cat_Stage_3Inputs */
/** @typedef {{}} Pet_Cat_Stage_4Inputs */
/** @typedef {{}} Pet_Cat_Stage_5Inputs */
/** @typedef {{}} Pet_Chick_Stage_0Inputs */
/** @typedef {{}} Pet_Chick_Stage_1Inputs */
/** @typedef {{}} Pet_Chick_Stage_2Inputs */
/** @typedef {{}} Pet_Chick_Stage_3Inputs */
/** @typedef {{}} Pet_Chick_Stage_4Inputs */
/** @typedef {{}} Pet_Chick_Stage_5Inputs */
/** @typedef {{}} Pet_Fox_Stage_0Inputs */
/** @typedef {{}} Pet_Fox_Stage_1Inputs */
/** @typedef {{}} Pet_Fox_Stage_2Inputs */
/** @typedef {{}} Pet_Fox_Stage_3Inputs */
/** @typedef {{}} Pet_Fox_Stage_4Inputs */
/** @typedef {{}} Pet_Fox_Stage_5Inputs */
/** @typedef {{ name: NonNullable<unknown>, stage: NonNullable<unknown> }} Pet_Grew_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_Grew_TitleInputs */
/** @typedef {{}} Pet_IntroInputs */
/** @typedef {{}} Pet_Kind_BunnyInputs */
/** @typedef {{}} Pet_Kind_CatInputs */
/** @typedef {{}} Pet_Kind_ChickInputs */
/** @typedef {{}} Pet_Kind_FoxInputs */
/** @typedef {{}} Pet_Kind_PupInputs */
/** @typedef {{}} Pet_Kind_SproutInputs */
/** @typedef {{}} Pet_Name_IdeasInputs */
/** @typedef {{}} Pet_Name_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_OwnerInputs */
/** @typedef {{}} Pet_Pup_Stage_0Inputs */
/** @typedef {{}} Pet_Pup_Stage_1Inputs */
/** @typedef {{}} Pet_Pup_Stage_2Inputs */
/** @typedef {{}} Pet_Pup_Stage_3Inputs */
/** @typedef {{}} Pet_Pup_Stage_4Inputs */
/** @typedef {{}} Pet_Pup_Stage_5Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_SavedInputs */
/** @typedef {{}} Pet_ShuffleInputs */
/** @typedef {{}} Pet_Sprout_Stage_0Inputs */
/** @typedef {{}} Pet_Sprout_Stage_1Inputs */
/** @typedef {{}} Pet_Sprout_Stage_2Inputs */
/** @typedef {{}} Pet_Sprout_Stage_3Inputs */
/** @typedef {{}} Pet_Sprout_Stage_4Inputs */
/** @typedef {{}} Pet_Sprout_Stage_5Inputs */
/** @typedef {{}} Pet_TitleInputs */
/** @typedef {{}} Pets_TitleInputs */
/** @typedef {{}} Photo_AddInputs */
/** @typedef {{}} Photo_LabelInputs */
/** @typedef {{}} Photo_Read_ErrorInputs */
/** @typedef {{}} Photo_RemoveInputs */
/** @typedef {{}} Photo_ReplaceInputs */
/** @typedef {{ count: NonNullable<unknown> }} Plus_BonusInputs */
/** @typedef {{ coins: NonNullable<unknown> }} Project_BonusInputs */
/** @typedef {{}} Project_CreateInputs */
/** @typedef {{}} Project_DeleteInputs */
/** @typedef {{}} Project_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Project_Delete_TitleInputs */
/** @typedef {{}} Project_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Project_FinishedInputs */
/** @typedef {{}} Project_IntroInputs */
/** @typedef {{}} Project_NameInputs */
/** @typedef {{}} Project_NewInputs */
/** @typedef {{}} Project_New_SubInputs */
/** @typedef {{}} Project_PaceInputs */
/** @typedef {{}} Project_Pace_1Inputs */
/** @typedef {{}} Project_Pace_3Inputs */
/** @typedef {{}} Project_Pace_7Inputs */
/** @typedef {{}} Project_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown>, done: NonNullable<unknown>, total: NonNullable<unknown> }} Project_ProgressInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Project_Row_SubInputs */
/** @typedef {{ project: NonNullable<unknown>, step: NonNullable<unknown>, total: NonNullable<unknown> }} Project_Step_OfInputs */
/** @typedef {{}} Project_StepsInputs */
/** @typedef {{}} Project_Steps_HintInputs */
/** @typedef {{}} Push_BlockedInputs */
/** @typedef {{}} Push_Blocked_HereInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Push_Daily_Body_StartInputs */
/** @typedef {{ minutes: NonNullable<unknown>, streak: NonNullable<unknown> }} Push_Daily_Body_StreakInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Daily_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_High_Five_TitleInputs */
/** @typedef {{}} Push_Ios_FirstInputs */
/** @typedef {{}} Push_OnInputs */
/** @typedef {{ count: NonNullable<unknown> }} Push_On_DevicesInputs */
/** @typedef {{ mine: NonNullable<unknown>, total: NonNullable<unknown> }} Push_Recap_BodyInputs */
/** @typedef {{ mine: NonNullable<unknown> }} Push_Recap_Body_SoloInputs */
/** @typedef {{}} Push_Recap_TitleInputs */
/** @typedef {{}} Push_Streak_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Push_Streak_Body_FreezesInputs */
/** @typedef {{ streak: NonNullable<unknown> }} Push_Streak_TitleInputs */
/** @typedef {{ chore: NonNullable<unknown>, xp: NonNullable<unknown> }} Push_Team_BodyInputs */
/** @typedef {{ chore: NonNullable<unknown>, xp: NonNullable<unknown>, level: NonNullable<unknown> }} Push_Team_Body_LevelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Team_TitleInputs */
/** @typedef {{}} Push_Test_BodyInputs */
/** @typedef {{}} Push_Test_TitleInputs */
/** @typedef {{}} Push_Timer_Dishwasher_BodyInputs */
/** @typedef {{}} Push_Timer_Dishwasher_TitleInputs */
/** @typedef {{}} Push_Timer_Dryer_BodyInputs */
/** @typedef {{}} Push_Timer_Dryer_TitleInputs */
/** @typedef {{}} Push_Timer_Other_BodyInputs */
/** @typedef {{}} Push_Timer_Other_TitleInputs */
/** @typedef {{}} Push_Timer_Oven_BodyInputs */
/** @typedef {{}} Push_Timer_Oven_TitleInputs */
/** @typedef {{}} Push_Timer_Washer_BodyInputs */
/** @typedef {{}} Push_Timer_Washer_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_AcceptedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Trade_Accepted_BodyInputs */
/** @typedef {{ give: NonNullable<unknown>, get: NonNullable<unknown> }} Push_Trade_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_DeclinedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Trade_Declined_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_TitleInputs */
/** @typedef {{}} Push_UnsupportedInputs */
/** @typedef {{}} Push_Unsupported_HereInputs */
/** @typedef {{}} Q_BathroomsInputs */
/** @typedef {{}} Q_Home_TypeInputs */
/** @typedef {{}} Q_PetsInputs */
/** @typedef {{}} Q_SpacesInputs */
/** @typedef {{}} Q_ThingsInputs */
/** @typedef {{}} Q_ToiletInputs */
/** @typedef {{}} Rarity_CommonInputs */
/** @typedef {{}} Rarity_EpicInputs */
/** @typedef {{}} Rarity_LegendaryInputs */
/** @typedef {{}} Rarity_RareInputs */
/** @typedef {{}} RebalanceInputs */
/** @typedef {{}} Rebalance_Confirm_TitleInputs */
/** @typedef {{ people: NonNullable<unknown> }} Rebalance_SubInputs */
/** @typedef {{}} Rebalance_TitleInputs */
/** @typedef {{}} Recap_Household_ChoresInputs */
/** @typedef {{ total: NonNullable<unknown>, mine: NonNullable<unknown> }} Recap_RowInputs */
/** @typedef {{ mine: NonNullable<unknown> }} Recap_Row_SoloInputs */
/** @typedef {{}} Recap_SubtitleInputs */
/** @typedef {{}} Recap_TitleInputs */
/** @typedef {{ count: NonNullable<unknown>, name: NonNullable<unknown> }} Recap_TopInputs */
/** @typedef {{}} Recap_Your_ChoresInputs */
/** @typedef {{}} ReloadInputs */
/** @typedef {{}} Remind_Me_AtInputs */
/** @typedef {{}} Reminder_BodyInputs */
/** @typedef {{}} Reminder_CtaInputs */
/** @typedef {{}} Reminder_Cta_SubInputs */
/** @typedef {{ time: NonNullable<unknown> }} Reminder_SetInputs */
/** @typedef {{}} Reminder_TitleInputs */
/** @typedef {{}} RemindersInputs */
/** @typedef {{}} RemoveInputs */
/** @typedef {{}} RepeatsInputs */
/** @typedef {{}} Rescue_BonusInputs */
/** @typedef {{}} Rest_Day_BodyInputs */
/** @typedef {{}} Rest_Day_TitleInputs */
/** @typedef {{}} Review_ChoresInputs */
/** @typedef {{}} Rhythm_ChangeInputs */
/** @typedef {{ chore: NonNullable<unknown>, freq: NonNullable<unknown> }} Rhythm_ChangedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Rhythm_EarlyInputs */
/** @typedef {{}} Rhythm_KeepInputs */
/** @typedef {{}} Rhythm_LabelInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Rhythm_LateInputs */
/** @typedef {{ new: NonNullable<unknown>, old: NonNullable<unknown> }} Rhythm_QuestionInputs */
/** @typedef {{ count: NonNullable<unknown>, chore: NonNullable<unknown> }} Rhythm_SkippedInputs */
/** @typedef {{}} RoomInputs */
/** @typedef {{}} Room_BathroomInputs */
/** @typedef {{}} Room_Bathroom_2Inputs */
/** @typedef {{}} Room_Bathroom_3Inputs */
/** @typedef {{}} Room_BedroomInputs */
/** @typedef {{ price: NonNullable<unknown>, pet: NonNullable<unknown> }} Room_Buy_BodyInputs */
/** @typedef {{}} Room_Dining_RoomInputs */
/** @typedef {{}} Room_GarageInputs */
/** @typedef {{}} Room_Guest_RoomInputs */
/** @typedef {{}} Room_HallwayInputs */
/** @typedef {{}} Room_IntroInputs */
/** @typedef {{}} Room_KitchenInputs */
/** @typedef {{}} Room_Laundry_RoomInputs */
/** @typedef {{}} Room_Living_RoomInputs */
/** @typedef {{}} Room_NameInputs */
/** @typedef {{}} Room_OfficeInputs */
/** @typedef {{}} Room_OutdoorsInputs */
/** @typedef {{}} Room_PetsInputs */
/** @typedef {{}} Room_PlacedInputs */
/** @typedef {{}} Room_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Room_Row_SubInputs */
/** @typedef {{}} Room_Tap_To_PlaceInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Room_TitleInputs */
/** @typedef {{}} Room_ToiletInputs */
/** @typedef {{}} Room_Whole_HouseInputs */
/** @typedef {{}} SaveInputs */
/** @typedef {{}} Save_DateInputs */
/** @typedef {{}} SavedInputs */
/** @typedef {{}} Schedule_HintInputs */
/** @typedef {{}} Schedule_SavedInputs */
/** @typedef {{}} SeasonalInputs */
/** @typedef {{}} Seasonal_SubInputs */
/** @typedef {{}} SectionsInputs */
/** @typedef {{ count: NonNullable<unknown> }} See_AllInputs */
/** @typedef {{}} Select_All_That_ApplyInputs */
/** @typedef {{}} SettingsInputs */
/** @typedef {{ people: NonNullable<unknown>, active: NonNullable<unknown>, perDay: NonNullable<unknown>, more: NonNullable<unknown> }} Setup_BodyInputs */
/** @typedef {{ active: NonNullable<unknown>, perDay: NonNullable<unknown>, more: NonNullable<unknown> }} Setup_Body_SoloInputs */
/** @typedef {{}} Setup_TitleInputs */
/** @typedef {{}} Share_InviteInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Shop_IntroInputs */
/** @typedef {{}} Shop_OutfitsInputs */
/** @typedef {{}} Shop_OwnedInputs */
/** @typedef {{}} Shop_Row_SubInputs */
/** @typedef {{}} Shop_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shop_To_GoInputs */
/** @typedef {{}} Shop_WearingInputs */
/** @typedef {{}} Show_EarnedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Show_InactiveInputs */
/** @typedef {{}} Show_MoreInputs */
/** @typedef {{}} Sign_InInputs */
/** @typedef {{}} Sign_Out_DeviceInputs */
/** @typedef {{}} Sign_Out_HereInputs */
/** @typedef {{}} Signed_InInputs */
/** @typedef {{ name: NonNullable<unknown> }} Slip_BodyInputs */
/** @typedef {{}} Slip_OkInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Slip_SignedInputs */
/** @typedef {{}} Slip_TitleInputs */
/** @typedef {{}} SomeoneInputs */
/** @typedef {{}} Start_BreakInputs */
/** @typedef {{}} Stat_ChoresInputs */
/** @typedef {{}} Stat_FreezesInputs */
/** @typedef {{ best: NonNullable<unknown> }} Stat_StreakInputs */
/** @typedef {{}} Step_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Step_DeleteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Step_Done_ByInputs */
/** @typedef {{ n: NonNullable<unknown> }} Step_NInputs */
/** @typedef {{ step: NonNullable<unknown>, total: NonNullable<unknown> }} Step_OfInputs */
/** @typedef {{}} Step_PlaceholderInputs */
/** @typedef {{ n: NonNullable<unknown> }} Step_RemoveInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Step_Up_NextInputs */
/** @typedef {{}} Sticker_BirdInputs */
/** @typedef {{}} Sticker_BucketInputs */
/** @typedef {{}} Sticker_CatInputs */
/** @typedef {{}} Sticker_CrownInputs */
/** @typedef {{}} Sticker_FishInputs */
/** @typedef {{}} Sticker_FlowerInputs */
/** @typedef {{ rarity: NonNullable<unknown> }} Sticker_LabelInputs */
/** @typedef {{}} Sticker_LampInputs */
/** @typedef {{}} Sticker_LemonInputs */
/** @typedef {{}} Sticker_PlantInputs */
/** @typedef {{}} Sticker_RainbowInputs */
/** @typedef {{}} Sticker_RobotInputs */
/** @typedef {{}} Sticker_ShirtInputs */
/** @typedef {{}} Sticker_SoapInputs */
/** @typedef {{}} Sticker_SparklesInputs */
/** @typedef {{}} Sticker_SpongeInputs */
/** @typedef {{}} Sticker_SprayInputs */
/** @typedef {{}} Sticker_TeaInputs */
/** @typedef {{}} Sticker_WandInputs */
/** @typedef {{}} Sticker_WasherInputs */
/** @typedef {{}} StickersInputs */
/** @typedef {{ owned: NonNullable<unknown>, total: NonNullable<unknown> }} Stickers_FoundInputs */
/** @typedef {{}} Stickers_HintInputs */
/** @typedef {{ count: NonNullable<unknown> }} Streak_DaysInputs */
/** @typedef {{}} SuppliesInputs */
/** @typedef {{}} Supplies_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Supplies_Added_ByInputs */
/** @typedef {{}} Supplies_BoughtInputs */
/** @typedef {{}} Supplies_ClearInputs */
/** @typedef {{}} Supplies_EmptyInputs */
/** @typedef {{}} Supplies_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Supplies_SubInputs */
/** @typedef {{}} Supplies_Sub_EmptyInputs */
/** @typedef {{}} SwapInputs */
/** @typedef {{}} SwappedInputs */
/** @typedef {{}} Switched_Off_BodyInputs */
/** @typedef {{}} Switched_Off_EmptyInputs */
/** @typedef {{}} Switched_Off_TitleInputs */
/** @typedef {{}} Tab_ChoresInputs */
/** @typedef {{}} Tab_HouseInputs */
/** @typedef {{}} Tab_ProfileInputs */
/** @typedef {{}} Tab_TodayInputs */
/** @typedef {{}} Take_BonusInputs */
/** @typedef {{}} Take_BreakInputs */
/** @typedef {{}} Take_Break_SubInputs */
/** @typedef {{}} Takes_AboutInputs */
/** @typedef {{}} Tap_To_ContinueInputs */
/** @typedef {{}} TestInputs */
/** @typedef {{}} Test_NoneInputs */
/** @typedef {{}} Test_SentInputs */
/** @typedef {{}} This_DeviceInputs */
/** @typedef {{}} TimerInputs */
/** @typedef {{}} Timer_ClearInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Done_AtInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Finished_AtInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Timer_GoInputs */
/** @typedef {{}} Timer_How_LongInputs */
/** @typedef {{}} Timer_IntroInputs */
/** @typedef {{}} Timer_Intro_No_PushInputs */
/** @typedef {{}} Timer_Kind_DishwasherInputs */
/** @typedef {{}} Timer_Kind_DryerInputs */
/** @typedef {{}} Timer_Kind_OtherInputs */
/** @typedef {{}} Timer_Kind_OvenInputs */
/** @typedef {{}} Timer_Kind_WasherInputs */
/** @typedef {{}} Timer_MachineInputs */
/** @typedef {{}} Timer_MinutesInputs */
/** @typedef {{}} Timer_NewInputs */
/** @typedef {{}} Timer_New_SubInputs */
/** @typedef {{}} Timer_PauseInputs */
/** @typedef {{}} Timer_RestartInputs */
/** @typedef {{}} Timer_ResumeInputs */
/** @typedef {{}} Timer_StartInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Start_AtInputs */
/** @typedef {{}} Timer_StopInputs */
/** @typedef {{}} Timers_TitleInputs */
/** @typedef {{}} Times_UpInputs */
/** @typedef {{}} TodayInputs */
/** @typedef {{}} Toilet_In_BathroomInputs */
/** @typedef {{}} Toilet_SeparateInputs */
/** @typedef {{}} TradeInputs */
/** @typedef {{}} Trade_AcceptInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_AskInputs */
/** @typedef {{}} Trade_DeclineInputs */
/** @typedef {{}} Trade_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_IncomingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_SentInputs */
/** @typedef {{}} Trade_TheirsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_WaitingInputs */
/** @typedef {{}} Trade_You_GetInputs */
/** @typedef {{}} Trade_You_GiveInputs */
/** @typedef {{}} Trade_YoursInputs */
/** @typedef {{}} Treat_AddInputs */
/** @typedef {{}} Treat_Name_LabelInputs */
/** @typedef {{}} Treat_Name_PlaceholderInputs */
/** @typedef {{}} Treat_Price_LabelInputs */
/** @typedef {{}} Treat_RedeemInputs */
/** @typedef {{}} Treats_EarnedInputs */
/** @typedef {{}} Treats_EmptyInputs */
/** @typedef {{}} Treats_IntroInputs */
/** @typedef {{}} Treats_Row_SubInputs */
/** @typedef {{}} Treats_TitleInputs */
/** @typedef {{}} Try_AgainInputs */
/** @typedef {{}} Turn_OnInputs */
/** @typedef {{}} Turn_On_RemindersInputs */
/** @typedef {{ tz: NonNullable<unknown> }} Tz_NoteInputs */
/** @typedef {{ tz: NonNullable<unknown> }} Tz_SwitchInputs */
/** @typedef {{}} Verdict_BalancedInputs */
/** @typedef {{}} Verdict_TightInputs */
/** @typedef {{}} Verdict_Too_MuchInputs */
/** @typedef {{}} WeatherInputs */
/** @typedef {{}} Weather_IntroInputs */
/** @typedef {{}} Weather_NoneInputs */
/** @typedef {{}} Weather_RemoveInputs */
/** @typedef {{}} Weather_SearchInputs */
/** @typedef {{}} Weather_Sub_OffInputs */
/** @typedef {{ place: NonNullable<unknown> }} Weather_Sub_OnInputs */
/** @typedef {{}} Weather_TitleInputs */
/** @typedef {{}} Welcome_CreateInputs */
/** @typedef {{}} Welcome_JoinInputs */
/** @typedef {{}} Welcome_LinkInputs */
/** @typedef {{}} Who_Does_ItInputs */
/** @typedef {{}} Who_Does_It_HintInputs */
/** @typedef {{ xp: NonNullable<unknown>, next: NonNullable<unknown>, name: NonNullable<unknown> }} Xp_Until_GrowsInputs */
/** @typedef {{}} YayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Year_DaysInputs */
/** @typedef {{}} Year_EmptyInputs */
/** @typedef {{}} Year_EndInputs */
/** @typedef {{}} Year_FavInputs */
/** @typedef {{}} Year_High_FivesInputs */
/** @typedef {{ year: NonNullable<unknown> }} Year_IntroInputs */
/** @typedef {{}} Year_Intro_SubInputs */
/** @typedef {{ month: NonNullable<unknown> }} Year_MonthInputs */
/** @typedef {{ pet: NonNullable<unknown>, stage: NonNullable<unknown> }} Year_PetInputs */
/** @typedef {{}} Year_RoomInputs */
/** @typedef {{ year: NonNullable<unknown> }} Year_RowInputs */
/** @typedef {{}} Year_Row_SubInputs */
/** @typedef {{}} Year_RunInputs */
/** @typedef {{}} Year_Run_SubInputs */
/** @typedef {{}} Year_ShareInputs */
/** @typedef {{ count: NonNullable<unknown> }} Year_TimesInputs */
/** @typedef {{}} Year_TotalInputs */
/** @typedef {{}} YesterdayInputs */
/** @typedef {{}} YouInputs */
/** @typedef {{}} You_SuffixInputs */
/** @typedef {{}} Your_ColourInputs */
/** @typedef {{}} Your_CompanionInputs */
/** @typedef {{}} Your_DevicesInputs */
/** @typedef {{}} Your_HomeInputs */
/** @typedef {{}} Your_Home_SubInputs */
/** @typedef {{}} Your_Home_UnsetInputs */
/** @typedef {{}} Your_NameInputs */
/** @typedef {{}} Your_WeekInputs */
import * as __en from "./en.js"
import * as __nl from "./nl.js"
/**
* | output |
* | --- |
* | "Active" |
*
* @param {ActiveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const active = /** @type {((inputs?: ActiveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActiveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.active(inputs)
	return __en.active(inputs)
});
/**
* | output |
* | --- |
* | "Switched-off chores are never picked" |
*
* @param {Active_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const active_sub = /** @type {((inputs?: Active_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Active_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.active_sub(inputs)
	return __en.active_sub(inputs)
});
/**
* | output |
* | --- |
* | "Activity" |
*
* @param {ActivityInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const activity = /** @type {((inputs?: ActivityInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActivityInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.activity(inputs)
	return __en.activity(inputs)
});
/**
* | output |
* | --- |
* | "Finished chores will show up here." |
*
* @param {Activity_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const activity_empty = /** @type {((inputs?: Activity_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.activity_empty(inputs)
	return __en.activity_empty(inputs)
});
/**
* | output |
* | --- |
* | "{name} hasn't done any chores yet." |
*
* @param {Activity_Empty_PersonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const activity_empty_person = /** @type {((inputs: Activity_Empty_PersonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Empty_PersonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.activity_empty_person(inputs)
	return __en.activity_empty_person(inputs)
});
/**
* | output |
* | --- |
* | "Add chore" |
*
* @param {Add_ChoreInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const add_chore = /** @type {((inputs?: Add_ChoreInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_ChoreInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.add_chore(inputs)
	return __en.add_chore(inputs)
});
/**
* | output |
* | --- |
* | "Add to Home Screen first" |
*
* @param {Add_Home_FirstInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const add_home_first = /** @type {((inputs?: Add_Home_FirstInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Home_FirstInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.add_home_first(inputs)
	return __en.add_home_first(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} day ago" |
* | * | "{count} days ago" |
*
* @param {Ago_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ago_days = /** @type {((inputs: Ago_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ago_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ago_days(inputs)
	return __en.ago_days(inputs)
});
/**
* | output |
* | --- |
* | "{count} h ago" |
*
* @param {Ago_HoursInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ago_hours = /** @type {((inputs: Ago_HoursInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ago_HoursInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ago_hours(inputs)
	return __en.ago_hours(inputs)
});
/**
* | output |
* | --- |
* | "{count} min ago" |
*
* @param {Ago_MinutesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ago_minutes = /** @type {((inputs: Ago_MinutesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ago_MinutesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ago_minutes(inputs)
	return __en.ago_minutes(inputs)
});
/**
* | output |
* | --- |
* | "just now" |
*
* @param {Ago_NowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ago_now = /** @type {((inputs?: Ago_NowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ago_NowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ago_now(inputs)
	return __en.ago_now(inputs)
});
/**
* | output |
* | --- |
* | "Anyone" |
*
* @param {AnyoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const anyone = /** @type {((inputs?: AnyoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AnyoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.anyone(inputs)
	return __en.anyone(inputs)
});
/**
* | output |
* | --- |
* | "One small chore a day keeps the whole house in shape." |
*
* @param {App_TaglineInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const app_tagline = /** @type {((inputs?: App_TaglineInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_TaglineInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.app_tagline(inputs)
	return __en.app_tagline(inputs)
});
/**
* | output |
* | --- |
* | "Back" |
*
* @param {BackInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const back = /** @type {((inputs?: BackInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BackInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.back(inputs)
	return __en.back(inputs)
});
/**
* | output |
* | --- |
* | "Finish 10 bonus chores" |
*
* @param {Badge_Bonus10_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_bonus10_desc = /** @type {((inputs?: Badge_Bonus10_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Bonus10_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_bonus10_desc(inputs)
	return __en.badge_bonus10_desc(inputs)
});
/**
* | output |
* | --- |
* | "Overachiever" |
*
* @param {Badge_Bonus10_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_bonus10_name = /** @type {((inputs?: Badge_Bonus10_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Bonus10_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_bonus10_name(inputs)
	return __en.badge_bonus10_name(inputs)
});
/**
* | output |
* | --- |
* | "Finish a bonus chore" |
*
* @param {Badge_Bonus_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_bonus_desc = /** @type {((inputs?: Badge_Bonus_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Bonus_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_bonus_desc(inputs)
	return __en.badge_bonus_desc(inputs)
});
/**
* | output |
* | --- |
* | "Extra Mile" |
*
* @param {Badge_Bonus_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_bonus_name = /** @type {((inputs?: Badge_Bonus_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Bonus_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_bonus_name(inputs)
	return __en.badge_bonus_name(inputs)
});
/**
* | output |
* | --- |
* | "Complete 10 chores" |
*
* @param {Badge_Done10_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_done10_desc = /** @type {((inputs?: Badge_Done10_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Done10_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_done10_desc(inputs)
	return __en.badge_done10_desc(inputs)
});
/**
* | output |
* | --- |
* | "Getting the Hang of It" |
*
* @param {Badge_Done10_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_done10_name = /** @type {((inputs?: Badge_Done10_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Done10_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_done10_name(inputs)
	return __en.badge_done10_name(inputs)
});
/**
* | output |
* | --- |
* | "Complete 250 chores" |
*
* @param {Badge_Done250_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_done250_desc = /** @type {((inputs?: Badge_Done250_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Done250_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_done250_desc(inputs)
	return __en.badge_done250_desc(inputs)
});
/**
* | output |
* | --- |
* | "Keeper of the Castle" |
*
* @param {Badge_Done250_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_done250_name = /** @type {((inputs?: Badge_Done250_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Done250_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_done250_name(inputs)
	return __en.badge_done250_name(inputs)
});
/**
* | output |
* | --- |
* | "Complete 50 chores" |
*
* @param {Badge_Done50_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_done50_desc = /** @type {((inputs?: Badge_Done50_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Done50_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_done50_desc(inputs)
	return __en.badge_done50_desc(inputs)
});
/**
* | output |
* | --- |
* | "Habit Formed" |
*
* @param {Badge_Done50_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_done50_name = /** @type {((inputs?: Badge_Done50_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Done50_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_done50_name(inputs)
	return __en.badge_done50_name(inputs)
});
/**
* | output |
* | --- |
* | "Finish a chore before 8am" |
*
* @param {Badge_Early_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_early_desc = /** @type {((inputs?: Badge_Early_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Early_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_early_desc(inputs)
	return __en.badge_early_desc(inputs)
});
/**
* | output |
* | --- |
* | "Early Bird" |
*
* @param {Badge_Early_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_early_name = /** @type {((inputs?: Badge_Early_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Early_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_early_name(inputs)
	return __en.badge_early_name(inputs)
});
/**
* | output |
* | --- |
* | "Complete your first chore" |
*
* @param {Badge_First_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_first_desc = /** @type {((inputs?: Badge_First_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_First_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_first_desc(inputs)
	return __en.badge_first_desc(inputs)
});
/**
* | output |
* | --- |
* | "Fresh Start" |
*
* @param {Badge_First_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_first_name = /** @type {((inputs?: Badge_First_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_First_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_first_name(inputs)
	return __en.badge_first_name(inputs)
});
/**
* | output |
* | --- |
* | "Have a streak freeze save your streak" |
*
* @param {Badge_Freeze_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_freeze_desc = /** @type {((inputs?: Badge_Freeze_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Freeze_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_freeze_desc(inputs)
	return __en.badge_freeze_desc(inputs)
});
/**
* | output |
* | --- |
* | "Saved by the Ice" |
*
* @param {Badge_Freeze_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_freeze_name = /** @type {((inputs?: Badge_Freeze_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Freeze_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_freeze_name(inputs)
	return __en.badge_freeze_name(inputs)
});
/**
* | output |
* | --- |
* | "Reach level 10" |
*
* @param {Badge_Level10_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_level10_desc = /** @type {((inputs?: Badge_Level10_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Level10_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_level10_desc(inputs)
	return __en.badge_level10_desc(inputs)
});
/**
* | output |
* | --- |
* | "Superstar" |
*
* @param {Badge_Level10_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_level10_name = /** @type {((inputs?: Badge_Level10_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Level10_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_level10_name(inputs)
	return __en.badge_level10_name(inputs)
});
/**
* | output |
* | --- |
* | "Reach level 5" |
*
* @param {Badge_Level5_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_level5_desc = /** @type {((inputs?: Badge_Level5_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Level5_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_level5_desc(inputs)
	return __en.badge_level5_desc(inputs)
});
/**
* | output |
* | --- |
* | "Rising Star" |
*
* @param {Badge_Level5_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_level5_name = /** @type {((inputs?: Badge_Level5_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Level5_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_level5_name(inputs)
	return __en.badge_level5_name(inputs)
});
/**
* | output |
* | --- |
* | "Finish a chore after 10pm" |
*
* @param {Badge_Night_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_night_desc = /** @type {((inputs?: Badge_Night_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Night_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_night_desc(inputs)
	return __en.badge_night_desc(inputs)
});
/**
* | output |
* | --- |
* | "Night Owl" |
*
* @param {Badge_Night_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_night_name = /** @type {((inputs?: Badge_Night_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Night_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_night_name(inputs)
	return __en.badge_night_name(inputs)
});
/**
* | output |
* | --- |
* | "Complete a chore that comes up twice a year or less" |
*
* @param {Badge_Rare_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_rare_desc = /** @type {((inputs?: Badge_Rare_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Rare_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_rare_desc(inputs)
	return __en.badge_rare_desc(inputs)
});
/**
* | output |
* | --- |
* | "Rare Find" |
*
* @param {Badge_Rare_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_rare_name = /** @type {((inputs?: Badge_Rare_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Rare_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_rare_name(inputs)
	return __en.badge_rare_name(inputs)
});
/**
* | output |
* | --- |
* | "Do a chore that was a whole period overdue" |
*
* @param {Badge_Rescue_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_rescue_desc = /** @type {((inputs?: Badge_Rescue_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Rescue_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_rescue_desc(inputs)
	return __en.badge_rescue_desc(inputs)
});
/**
* | output |
* | --- |
* | "Rescue Mission" |
*
* @param {Badge_Rescue_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_rescue_name = /** @type {((inputs?: Badge_Rescue_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Rescue_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_rescue_name(inputs)
	return __en.badge_rescue_name(inputs)
});
/**
* | output |
* | --- |
* | "Get every chore in a room (3+ chores) up to date" |
*
* @param {Badge_Room_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_room_desc = /** @type {((inputs?: Badge_Room_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Room_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_room_desc(inputs)
	return __en.badge_room_desc(inputs)
});
/**
* | output |
* | --- |
* | "Room Hero" |
*
* @param {Badge_Room_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_room_name = /** @type {((inputs?: Badge_Room_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Room_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_room_name(inputs)
	return __en.badge_room_name(inputs)
});
/**
* | output |
* | --- |
* | "Collect 10 different stickers" |
*
* @param {Badge_Stickers10_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_stickers10_desc = /** @type {((inputs?: Badge_Stickers10_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Stickers10_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_stickers10_desc(inputs)
	return __en.badge_stickers10_desc(inputs)
});
/**
* | output |
* | --- |
* | "Collector" |
*
* @param {Badge_Stickers10_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_stickers10_name = /** @type {((inputs?: Badge_Stickers10_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Stickers10_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_stickers10_name(inputs)
	return __en.badge_stickers10_name(inputs)
});
/**
* | output |
* | --- |
* | "Reach a 100-day streak" |
*
* @param {Badge_Streak100_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak100_desc = /** @type {((inputs?: Badge_Streak100_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak100_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak100_desc(inputs)
	return __en.badge_streak100_desc(inputs)
});
/**
* | output |
* | --- |
* | "Centurion" |
*
* @param {Badge_Streak100_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak100_name = /** @type {((inputs?: Badge_Streak100_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak100_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak100_name(inputs)
	return __en.badge_streak100_name(inputs)
});
/**
* | output |
* | --- |
* | "Reach a 30-day streak" |
*
* @param {Badge_Streak30_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak30_desc = /** @type {((inputs?: Badge_Streak30_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak30_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak30_desc(inputs)
	return __en.badge_streak30_desc(inputs)
});
/**
* | output |
* | --- |
* | "Month of Magic" |
*
* @param {Badge_Streak30_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak30_name = /** @type {((inputs?: Badge_Streak30_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak30_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak30_name(inputs)
	return __en.badge_streak30_name(inputs)
});
/**
* | output |
* | --- |
* | "Reach a 3-day streak" |
*
* @param {Badge_Streak3_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak3_desc = /** @type {((inputs?: Badge_Streak3_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak3_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak3_desc(inputs)
	return __en.badge_streak3_desc(inputs)
});
/**
* | output |
* | --- |
* | "Warming Up" |
*
* @param {Badge_Streak3_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak3_name = /** @type {((inputs?: Badge_Streak3_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak3_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak3_name(inputs)
	return __en.badge_streak3_name(inputs)
});
/**
* | output |
* | --- |
* | "Reach a 7-day streak" |
*
* @param {Badge_Streak7_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak7_desc = /** @type {((inputs?: Badge_Streak7_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak7_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak7_desc(inputs)
	return __en.badge_streak7_desc(inputs)
});
/**
* | output |
* | --- |
* | "Week Warrior" |
*
* @param {Badge_Streak7_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_streak7_name = /** @type {((inputs?: Badge_Streak7_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Streak7_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_streak7_name(inputs)
	return __en.badge_streak7_name(inputs)
});
/**
* | output |
* | --- |
* | "Everyone in the household finished their chore on the same day" |
*
* @param {Badge_Team_DescInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_team_desc = /** @type {((inputs?: Badge_Team_DescInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Team_DescInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_team_desc(inputs)
	return __en.badge_team_desc(inputs)
});
/**
* | output |
* | --- |
* | "Dream Team" |
*
* @param {Badge_Team_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badge_team_name = /** @type {((inputs?: Badge_Team_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_Team_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badge_team_name(inputs)
	return __en.badge_team_name(inputs)
});
/**
* | output |
* | --- |
* | "Badges" |
*
* @param {BadgesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const badges = /** @type {((inputs?: BadgesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BadgesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.badges(inputs)
	return __en.badges(inputs)
});
/**
* | output |
* | --- |
* | "Big job" |
*
* @param {Big_JobInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const big_job = /** @type {((inputs?: Big_JobInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Big_JobInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.big_job(inputs)
	return __en.big_job(inputs)
});
/**
* | output |
* | --- |
* | "Big jobs" |
*
* @param {Big_JobsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const big_jobs = /** @type {((inputs?: Big_JobsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Big_JobsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.big_jobs(inputs)
	return __en.big_jobs(inputs)
});
/**
* | output |
* | --- |
* | "Bonus" |
*
* @param {BonusInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const bonus = /** @type {((inputs?: BonusInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BonusInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.bonus(inputs)
	return __en.bonus(inputs)
});
/**
* | output |
* | --- |
* | "No chores and no reminders until then. Your streak is paused, not lost." |
*
* @param {Break_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_body = /** @type {((inputs?: Break_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_body(inputs)
	return __en.break_body(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} day" |
* | * | "{count} days" |
*
* @param {Break_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_days = /** @type {((inputs: Break_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_days(inputs)
	return __en.break_days(inputs)
});
/**
* | output |
* | --- |
* | "End break" |
*
* @param {Break_EndInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_end = /** @type {((inputs?: Break_EndInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_EndInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_end(inputs)
	return __en.break_end(inputs)
});
/**
* | output |
* | --- |
* | "Ends on {date}" |
*
* @param {Break_EndsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_ends = /** @type {((inputs: Break_EndsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_EndsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_ends(inputs)
	return __en.break_ends(inputs)
});
/**
* | output |
* | --- |
* | "How long will you be away?" |
*
* @param {Break_How_LongInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_how_long = /** @type {((inputs?: Break_How_LongInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_How_LongInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_how_long(inputs)
	return __en.break_how_long(inputs)
});
/**
* | output |
* | --- |
* | "Your streak is paused and kept. No chores or reminders, and your housemates' lists don't change." |
*
* @param {Break_ReassureInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_reassure = /** @type {((inputs?: Break_ReassureInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_ReassureInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_reassure(inputs)
	return __en.break_reassure(inputs)
});
/**
* | output |
* | --- |
* | "Sick" |
*
* @param {Break_SickInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_sick = /** @type {((inputs?: Break_SickInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_SickInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_sick(inputs)
	return __en.break_sick(inputs)
});
/**
* | output |
* | --- |
* | "Get well soon" |
*
* @param {Break_Sick_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_sick_title = /** @type {((inputs?: Break_Sick_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_Sick_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_sick_title(inputs)
	return __en.break_sick_title(inputs)
});
/**
* | output |
* | --- |
* | "Enjoy your break" |
*
* @param {Break_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_title = /** @type {((inputs?: Break_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_title(inputs)
	return __en.break_title(inputs)
});
/**
* | output |
* | --- |
* | "Just today" |
*
* @param {Break_TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_today = /** @type {((inputs?: Break_TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_today(inputs)
	return __en.break_today(inputs)
});
/**
* | output |
* | --- |
* | "2 weeks" |
*
* @param {Break_Two_WeeksInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_two_weeks = /** @type {((inputs?: Break_Two_WeeksInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_Two_WeeksInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_two_weeks(inputs)
	return __en.break_two_weeks(inputs)
});
/**
* | output |
* | --- |
* | "Until {date}" |
*
* @param {Break_UntilInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_until = /** @type {((inputs: Break_UntilInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_UntilInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_until(inputs)
	return __en.break_until(inputs)
});
/**
* | output |
* | --- |
* | "Vacation" |
*
* @param {Break_VacationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_vacation = /** @type {((inputs?: Break_VacationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_VacationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_vacation(inputs)
	return __en.break_vacation(inputs)
});
/**
* | output |
* | --- |
* | "1 week" |
*
* @param {Break_WeekInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_week = /** @type {((inputs?: Break_WeekInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_WeekInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_week(inputs)
	return __en.break_week(inputs)
});
/**
* | output |
* | --- |
* | "Until Sunday" |
*
* @param {Break_WeekendInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const break_weekend = /** @type {((inputs?: Break_WeekendInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Break_WeekendInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.break_weekend(inputs)
	return __en.break_weekend(inputs)
});
/**
* | output |
* | --- |
* | "Buy" |
*
* @param {BuyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const buy = /** @type {((inputs?: BuyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BuyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.buy(inputs)
	return __en.buy(inputs)
});
/**
* | output |
* | --- |
* | "{price} coins. {pet} puts it on straight away." |
*
* @param {Buy_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const buy_confirm_body = /** @type {((inputs: Buy_Confirm_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buy_Confirm_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.buy_confirm_body(inputs)
	return __en.buy_confirm_body(inputs)
});
/**
* | output |
* | --- |
* | "Buy the {item}?" |
*
* @param {Buy_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const buy_confirm_title = /** @type {((inputs: Buy_Confirm_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buy_Confirm_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.buy_confirm_title(inputs)
	return __en.buy_confirm_title(inputs)
});
/**
* | output |
* | --- |
* | "Break from chores" |
*
* @param {Calendar_BreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_break = /** @type {((inputs?: Calendar_BreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_BreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_break(inputs)
	return __en.calendar_break(inputs)
});
/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Calendar_CopiedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_copied = /** @type {((inputs?: Calendar_CopiedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_CopiedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_copied(inputs)
	return __en.calendar_copied(inputs)
});
/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Calendar_CopyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_copy = /** @type {((inputs?: Calendar_CopyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_CopyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_copy(inputs)
	return __en.calendar_copy(inputs)
});
/**
* | output |
* | --- |
* | "Create my calendar link" |
*
* @param {Calendar_CreateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_create = /** @type {((inputs?: Calendar_CreateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_CreateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_create(inputs)
	return __en.calendar_create(inputs)
});
/**
* | output |
* | --- |
* | "Done: {chore}" |
*
* @param {Calendar_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_done = /** @type {((inputs: Calendar_DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_done(inputs)
	return __en.calendar_done(inputs)
});
/**
* | output |
* | --- |
* | "Google Calendar: Other calendars, From URL, then paste the link." |
*
* @param {Calendar_GoogleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_google = /** @type {((inputs?: Calendar_GoogleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_GoogleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_google(inputs)
	return __en.calendar_google(inputs)
});
/**
* | output |
* | --- |
* | "Guests coming" |
*
* @param {Calendar_GuestsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_guests = /** @type {((inputs?: Calendar_GuestsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_GuestsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_guests(inputs)
	return __en.calendar_guests(inputs)
});
/**
* | output |
* | --- |
* | "Subscribe once and your calendar shows today's chore, the chores that are yours, breaks and guests. It updates by itself every few hours." |
*
* @param {Calendar_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_intro = /** @type {((inputs?: Calendar_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_intro(inputs)
	return __en.calendar_intro(inputs)
});
/**
* | output |
* | --- |
* | "Your calendar link is active. For safety it's only shown once: get a new one if you need it again." |
*
* @param {Calendar_LinkedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_linked = /** @type {((inputs?: Calendar_LinkedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_LinkedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_linked(inputs)
	return __en.calendar_linked(inputs)
});
/**
* | output |
* | --- |
* | "About {minutes} minutes" |
*
* @param {Calendar_MinutesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_minutes = /** @type {((inputs: Calendar_MinutesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_MinutesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_minutes(inputs)
	return __en.calendar_minutes(inputs)
});
/**
* | output |
* | --- |
* | "{household} chores" |
*
* @param {Calendar_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_name = /** @type {((inputs: Calendar_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_name(inputs)
	return __en.calendar_name(inputs)
});
/**
* | output |
* | --- |
* | "Open in Calendar" |
*
* @param {Calendar_OpenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_open = /** @type {((inputs?: Calendar_OpenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_OpenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_open(inputs)
	return __en.calendar_open(inputs)
});
/**
* | output |
* | --- |
* | "Anyone with this link can see your chores, so keep it to yourself." |
*
* @param {Calendar_PrivateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_private = /** @type {((inputs?: Calendar_PrivateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_PrivateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_private(inputs)
	return __en.calendar_private(inputs)
});
/**
* | output |
* | --- |
* | "Get a new link" |
*
* @param {Calendar_ResetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_reset = /** @type {((inputs?: Calendar_ResetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_ResetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_reset(inputs)
	return __en.calendar_reset(inputs)
});
/**
* | output |
* | --- |
* | "Your calendar is linked" |
*
* @param {Calendar_Row_OnInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_row_on = /** @type {((inputs?: Calendar_Row_OnInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Row_OnInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_row_on(inputs)
	return __en.calendar_row_on(inputs)
});
/**
* | output |
* | --- |
* | "See today's chore next to your plans" |
*
* @param {Calendar_Row_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_row_sub = /** @type {((inputs?: Calendar_Row_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Row_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_row_sub(inputs)
	return __en.calendar_row_sub(inputs)
});
/**
* | output |
* | --- |
* | "Stop the calendar" |
*
* @param {Calendar_StopInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_stop = /** @type {((inputs?: Calendar_StopInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_StopInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_stop(inputs)
	return __en.calendar_stop(inputs)
});
/**
* | output |
* | --- |
* | "Chores in your calendar" |
*
* @param {Calendar_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_title = /** @type {((inputs?: Calendar_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_title(inputs)
	return __en.calendar_title(inputs)
});
/**
* | output |
* | --- |
* | "Your chore" |
*
* @param {Calendar_YoursInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const calendar_yours = /** @type {((inputs?: Calendar_YoursInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_YoursInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.calendar_yours(inputs)
	return __en.calendar_yours(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {CancelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const cancel = /** @type {((inputs?: CancelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CancelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.cancel(inputs)
	return __en.cancel(inputs)
});
/**
* | output |
* | --- |
* | "Chore added" |
*
* @param {Chore_AddedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_added = /** @type {((inputs?: Chore_AddedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_AddedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_added(inputs)
	return __en.chore_added(inputs)
});
/**
* | output |
* | --- |
* | "Change some aquarium water and wipe the glass" |
*
* @param {Chore_AquariumInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_aquarium = /** @type {((inputs?: Chore_AquariumInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_AquariumInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_aquarium(inputs)
	return __en.chore_aquarium(inputs)
});
/**
* | output |
* | --- |
* | "Sweep the balcony / patio" |
*
* @param {Chore_BalconyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_balcony = /** @type {((inputs?: Chore_BalconyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_BalconyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_balcony(inputs)
	return __en.chore_balcony(inputs)
});
/**
* | output |
* | --- |
* | "Wash bath mats and swap towels" |
*
* @param {Chore_Bath_MatsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_bath_mats = /** @type {((inputs?: Chore_Bath_MatsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Bath_MatsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_bath_mats(inputs)
	return __en.chore_bath_mats(inputs)
});
/**
* | output |
* | --- |
* | "Mop the bathroom floor" |
*
* @param {Chore_Bathroom_FloorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_bathroom_floor = /** @type {((inputs?: Chore_Bathroom_FloorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Bathroom_FloorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_bathroom_floor(inputs)
	return __en.chore_bathroom_floor(inputs)
});
/**
* | output |
* | --- |
* | "Clean the sink and mirror" |
*
* @param {Chore_Bathroom_SinkInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_bathroom_sink = /** @type {((inputs?: Chore_Bathroom_SinkInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Bathroom_SinkInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_bathroom_sink(inputs)
	return __en.chore_bathroom_sink(inputs)
});
/**
* | output |
* | --- |
* | "Scrub the bathtub" |
*
* @param {Chore_BathtubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_bathtub = /** @type {((inputs?: Chore_BathtubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_BathtubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_bathtub(inputs)
	return __en.chore_bathtub(inputs)
});
/**
* | output |
* | --- |
* | "Wash out the bin" |
*
* @param {Chore_BinInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_bin = /** @type {((inputs?: Chore_BinInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_BinInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_bin(inputs)
	return __en.chore_bin(inputs)
});
/**
* | output |
* | --- |
* | "Clean the bird cage" |
*
* @param {Chore_Bird_CageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_bird_cage = /** @type {((inputs?: Chore_Bird_CageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Bird_CageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_bird_cage(inputs)
	return __en.chore_bird_cage(inputs)
});
/**
* | output |
* | --- |
* | "Wipe cabinet fronts and handles" |
*
* @param {Chore_CabinetsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_cabinets = /** @type {((inputs?: Chore_CabinetsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_CabinetsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_cabinets(inputs)
	return __en.chore_cabinets(inputs)
});
/**
* | output |
* | --- |
* | "Clean out the cage" |
*
* @param {Chore_CageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_cage = /** @type {((inputs?: Chore_CageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_CageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_cage(inputs)
	return __en.chore_cage(inputs)
});
/**
* | output |
* | --- |
* | "Wash the curtains" |
*
* @param {Chore_CurtainsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_curtains = /** @type {((inputs?: Chore_CurtainsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_CurtainsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_curtains(inputs)
	return __en.chore_curtains(inputs)
});
/**
* | output |
* | --- |
* | "Descale the kettle / coffee machine" |
*
* @param {Chore_Descale_KettleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_descale_kettle = /** @type {((inputs?: Chore_Descale_KettleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Descale_KettleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_descale_kettle(inputs)
	return __en.chore_descale_kettle(inputs)
});
/**
* | output |
* | --- |
* | "Clear and wipe the desk" |
*
* @param {Chore_DeskInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_desk = /** @type {((inputs?: Chore_DeskInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_DeskInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_desk(inputs)
	return __en.chore_desk(inputs)
});
/**
* | output |
* | --- |
* | "Wipe the dining table and chairs" |
*
* @param {Chore_Dining_TableInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_dining_table = /** @type {((inputs?: Chore_Dining_TableInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Dining_TableInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_dining_table(inputs)
	return __en.chore_dining_table(inputs)
});
/**
* | output |
* | --- |
* | "Clean the dishwasher filter" |
*
* @param {Chore_Dishwasher_FilterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_dishwasher_filter = /** @type {((inputs?: Chore_Dishwasher_FilterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Dishwasher_FilterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_dishwasher_filter(inputs)
	return __en.chore_dishwasher_filter(inputs)
});
/**
* | output |
* | --- |
* | "Wipe down all the doors and frames" |
*
* @param {Chore_DoorsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_doors = /** @type {((inputs?: Chore_DoorsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_DoorsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_doors(inputs)
	return __en.chore_doors(inputs)
});
/**
* | output |
* | --- |
* | "Declutter one drawer" |
*
* @param {Chore_DrawerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_drawer = /** @type {((inputs?: Chore_DrawerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_DrawerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_drawer(inputs)
	return __en.chore_drawer(inputs)
});
/**
* | output |
* | --- |
* | "Clean the dryer's lint filter and condenser" |
*
* @param {Chore_Dryer_LintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_dryer_lint = /** @type {((inputs?: Chore_Dryer_LintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Dryer_LintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_dryer_lint(inputs)
	return __en.chore_dryer_lint(inputs)
});
/**
* | output |
* | --- |
* | "Dust surfaces and shelves" |
*
* @param {Chore_DustInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_dust = /** @type {((inputs?: Chore_DustInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_DustInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_dust(inputs)
	return __en.chore_dust(inputs)
});
/**
* | output |
* | --- |
* | "Dust ceiling fans and light fixtures" |
*
* @param {Chore_FansInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_fans = /** @type {((inputs?: Chore_FansInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_FansInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_fans(inputs)
	return __en.chore_fans(inputs)
});
/**
* | output |
* | --- |
* | "Defrost the freezer" |
*
* @param {Chore_FreezerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_freezer = /** @type {((inputs?: Chore_FreezerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_FreezerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_freezer(inputs)
	return __en.chore_freezer(inputs)
});
/**
* | output |
* | --- |
* | "Clear out the fridge (toss old food, wipe spills)" |
*
* @param {Chore_Fridge_ClearoutInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_fridge_clearout = /** @type {((inputs?: Chore_Fridge_ClearoutInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Fridge_ClearoutInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_fridge_clearout(inputs)
	return __en.chore_fridge_clearout(inputs)
});
/**
* | output |
* | --- |
* | "Deep clean the fridge shelves" |
*
* @param {Chore_Fridge_DeepInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_fridge_deep = /** @type {((inputs?: Chore_Fridge_DeepInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Fridge_DeepInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_fridge_deep(inputs)
	return __en.chore_fridge_deep(inputs)
});
/**
* | output |
* | --- |
* | "Sweep and tidy the garage" |
*
* @param {Chore_GarageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_garage = /** @type {((inputs?: Chore_GarageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_GarageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_garage(inputs)
	return __en.chore_garage(inputs)
});
/**
* | output |
* | --- |
* | "Clean the garden furniture" |
*
* @param {Chore_Garden_FurnitureInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_garden_furniture = /** @type {((inputs?: Chore_Garden_FurnitureInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Garden_FurnitureInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_garden_furniture(inputs)
	return __en.chore_garden_furniture(inputs)
});
/**
* | output |
* | --- |
* | "Scrub the grout" |
*
* @param {Chore_GroutInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_grout = /** @type {((inputs?: Chore_GroutInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_GroutInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_grout(inputs)
	return __en.chore_grout(inputs)
});
/**
* | output |
* | --- |
* | "Dust and air the guest room" |
*
* @param {Chore_Guest_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_guest_room = /** @type {((inputs?: Chore_Guest_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Guest_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_guest_room(inputs)
	return __en.chore_guest_room(inputs)
});
/**
* | output |
* | --- |
* | "Clear the gutters" |
*
* @param {Chore_GuttersInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_gutters = /** @type {((inputs?: Chore_GuttersInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_GuttersInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_gutters(inputs)
	return __en.chore_gutters(inputs)
});
/**
* | output |
* | --- |
* | "Sweep the hallway and shake out the doormat" |
*
* @param {Chore_HallwayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_hallway = /** @type {((inputs?: Chore_HallwayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_HallwayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_hallway(inputs)
	return __en.chore_hallway(inputs)
});
/**
* | output |
* | --- |
* | "Degrease the extractor hood filter" |
*
* @param {Chore_Hood_FilterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_hood_filter = /** @type {((inputs?: Chore_Hood_FilterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Hood_FilterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_hood_filter(inputs)
	return __en.chore_hood_filter(inputs)
});
/**
* | output |
* | --- |
* | "Scrub the sink and drain" |
*
* @param {Chore_Kitchen_SinkInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_kitchen_sink = /** @type {((inputs?: Chore_Kitchen_SinkInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Kitchen_SinkInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_kitchen_sink(inputs)
	return __en.chore_kitchen_sink(inputs)
});
/**
* | output |
* | --- |
* | "Tidy and wipe the laundry room" |
*
* @param {Chore_Laundry_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_laundry_room = /** @type {((inputs?: Chore_Laundry_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Laundry_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_laundry_room(inputs)
	return __en.chore_laundry_room(inputs)
});
/**
* | output |
* | --- |
* | "Refresh the whole litter box" |
*
* @param {Chore_Litter_BoxInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_litter_box = /** @type {((inputs?: Chore_Litter_BoxInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Litter_BoxInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_litter_box(inputs)
	return __en.chore_litter_box(inputs)
});
/**
* | output |
* | --- |
* | "Rotate / flip the mattress" |
*
* @param {Chore_MattressInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_mattress = /** @type {((inputs?: Chore_MattressInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_MattressInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_mattress(inputs)
	return __en.chore_mattress(inputs)
});
/**
* | output |
* | --- |
* | "Clean the microwave" |
*
* @param {Chore_MicrowaveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_microwave = /** @type {((inputs?: Chore_MicrowaveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_MicrowaveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_microwave(inputs)
	return __en.chore_microwave(inputs)
});
/**
* | output |
* | --- |
* | "Mop the kitchen floor" |
*
* @param {Chore_Mop_KitchenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_mop_kitchen = /** @type {((inputs?: Chore_Mop_KitchenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Mop_KitchenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_mop_kitchen(inputs)
	return __en.chore_mop_kitchen(inputs)
});
/**
* | output |
* | --- |
* | "{n} of {total}" |
*
* @param {Chore_N_OfInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_n_of = /** @type {((inputs: Chore_N_OfInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_N_OfInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_n_of(inputs)
	return __en.chore_n_of(inputs)
});
/**
* | output |
* | --- |
* | "Chore name" |
*
* @param {Chore_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_name_label = /** @type {((inputs?: Chore_Name_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Name_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_name_label(inputs)
	return __en.chore_name_label(inputs)
});
/**
* | output |
* | --- |
* | "Declutter the nightstand and dresser" |
*
* @param {Chore_NightstandInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_nightstand = /** @type {((inputs?: Chore_NightstandInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_NightstandInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_nightstand(inputs)
	return __en.chore_nightstand(inputs)
});
/**
* | output |
* | --- |
* | "Clean the oven" |
*
* @param {Chore_OvenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_oven = /** @type {((inputs?: Chore_OvenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_OvenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_oven(inputs)
	return __en.chore_oven(inputs)
});
/**
* | output |
* | --- |
* | "Declutter the pantry and check expiry dates" |
*
* @param {Chore_PantryInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_pantry = /** @type {((inputs?: Chore_PantryInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_PantryInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_pantry(inputs)
	return __en.chore_pantry(inputs)
});
/**
* | output |
* | --- |
* | "Wash the pet bed and blankets" |
*
* @param {Chore_Pet_BedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_pet_bed = /** @type {((inputs?: Chore_Pet_BedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Pet_BedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_pet_bed(inputs)
	return __en.chore_pet_bed(inputs)
});
/**
* | output |
* | --- |
* | "Wash the food and water bowls" |
*
* @param {Chore_Pet_BowlsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_pet_bowls = /** @type {((inputs?: Chore_Pet_BowlsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Pet_BowlsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_pet_bowls(inputs)
	return __en.chore_pet_bowls(inputs)
});
/**
* | output |
* | --- |
* | "Vacuum pet hair off the sofa" |
*
* @param {Chore_Pet_HairInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_pet_hair = /** @type {((inputs?: Chore_Pet_HairInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Pet_HairInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_pet_hair(inputs)
	return __en.chore_pet_hair(inputs)
});
/**
* | output |
* | --- |
* | "Wash the toys and the lead" |
*
* @param {Chore_Pet_ToysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_pet_toys = /** @type {((inputs?: Chore_Pet_ToysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Pet_ToysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_pet_toys(inputs)
	return __en.chore_pet_toys(inputs)
});
/**
* | output |
* | --- |
* | "Wash pillows and duvet" |
*
* @param {Chore_PillowsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_pillows = /** @type {((inputs?: Chore_PillowsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_PillowsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_pillows(inputs)
	return __en.chore_pillows(inputs)
});
/**
* | output |
* | --- |
* | "What needs doing?" |
*
* @param {Chore_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_placeholder = /** @type {((inputs?: Chore_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_placeholder(inputs)
	return __en.chore_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Dust the plant leaves" |
*
* @param {Chore_Plant_LeavesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_plant_leaves = /** @type {((inputs?: Chore_Plant_LeavesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Plant_LeavesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_plant_leaves(inputs)
	return __en.chore_plant_leaves(inputs)
});
/**
* | output |
* | --- |
* | "Water the plants" |
*
* @param {Chore_PlantsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_plants = /** @type {((inputs?: Chore_PlantsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_PlantsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_plants(inputs)
	return __en.chore_plants(inputs)
});
/**
* | output |
* | --- |
* | "Bleed the radiators" |
*
* @param {Chore_RadiatorsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_radiators = /** @type {((inputs?: Chore_RadiatorsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_RadiatorsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_radiators(inputs)
	return __en.chore_radiators(inputs)
});
/**
* | output |
* | --- |
* | "Shake out rugs and doormats" |
*
* @param {Chore_RugsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_rugs = /** @type {((inputs?: Chore_RugsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_RugsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_rugs(inputs)
	return __en.chore_rugs(inputs)
});
/**
* | output |
* | --- |
* | "Dust the screens and keyboard" |
*
* @param {Chore_ScreensInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_screens = /** @type {((inputs?: Chore_ScreensInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_ScreensInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_screens(inputs)
	return __en.chore_screens(inputs)
});
/**
* | output |
* | --- |
* | "Change the bed sheets" |
*
* @param {Chore_SheetsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_sheets = /** @type {((inputs?: Chore_SheetsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_SheetsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_sheets(inputs)
	return __en.chore_sheets(inputs)
});
/**
* | output |
* | --- |
* | "Scrub the shower / bath" |
*
* @param {Chore_ShowerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_shower = /** @type {((inputs?: Chore_ShowerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_ShowerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_shower(inputs)
	return __en.chore_shower(inputs)
});
/**
* | output |
* | --- |
* | "Wash the shower curtain / clean the screen" |
*
* @param {Chore_Shower_CurtainInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_shower_curtain = /** @type {((inputs?: Chore_Shower_CurtainInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Shower_CurtainInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_shower_curtain(inputs)
	return __en.chore_shower_curtain(inputs)
});
/**
* | output |
* | --- |
* | "Descale the showerhead and taps" |
*
* @param {Chore_ShowerheadInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_showerhead = /** @type {((inputs?: Chore_ShowerheadInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_ShowerheadInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_showerhead(inputs)
	return __en.chore_showerhead(inputs)
});
/**
* | output |
* | --- |
* | "Dust the skirting boards" |
*
* @param {Chore_SkirtingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_skirting = /** @type {((inputs?: Chore_SkirtingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_SkirtingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_skirting(inputs)
	return __en.chore_skirting(inputs)
});
/**
* | output |
* | --- |
* | "Test the smoke alarms" |
*
* @param {Chore_Smoke_AlarmsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_smoke_alarms = /** @type {((inputs?: Chore_Smoke_AlarmsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Smoke_AlarmsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_smoke_alarms(inputs)
	return __en.chore_smoke_alarms(inputs)
});
/**
* | output |
* | --- |
* | "Vacuum the sofa and fluff the cushions" |
*
* @param {Chore_SofaInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_sofa = /** @type {((inputs?: Chore_SofaInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_SofaInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_sofa(inputs)
	return __en.chore_sofa(inputs)
});
/**
* | output |
* | --- |
* | "Vacuum the stairs" |
*
* @param {Chore_StairsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_stairs = /** @type {((inputs?: Chore_StairsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_StairsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_stairs(inputs)
	return __en.chore_stairs(inputs)
});
/**
* | output |
* | --- |
* | "Degrease the stovetop" |
*
* @param {Chore_StovetopInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_stovetop = /** @type {((inputs?: Chore_StovetopInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_StovetopInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_stovetop(inputs)
	return __en.chore_stovetop(inputs)
});
/**
* | output |
* | --- |
* | "Wipe light switches, remotes and door handles" |
*
* @param {Chore_SwitchesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_switches = /** @type {((inputs?: Chore_SwitchesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_SwitchesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_switches(inputs)
	return __en.chore_switches(inputs)
});
/**
* | output |
* | --- |
* | "Clean the toilet" |
*
* @param {Chore_ToiletInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_toilet = /** @type {((inputs?: Chore_ToiletInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_ToiletInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_toilet(inputs)
	return __en.chore_toilet(inputs)
});
/**
* | output |
* | --- |
* | "Wipe the hand basin and toilet floor" |
*
* @param {Chore_Toilet_BasinInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_toilet_basin = /** @type {((inputs?: Chore_Toilet_BasinInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Toilet_BasinInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_toilet_basin(inputs)
	return __en.chore_toilet_basin(inputs)
});
/**
* | output |
* | --- |
* | "Vacuum under the bed" |
*
* @param {Chore_Under_BedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_under_bed = /** @type {((inputs?: Chore_Under_BedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Under_BedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_under_bed(inputs)
	return __en.chore_under_bed(inputs)
});
/**
* | output |
* | --- |
* | "Clean the vacuum cleaner filter" |
*
* @param {Chore_Vacuum_FilterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_vacuum_filter = /** @type {((inputs?: Chore_Vacuum_FilterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Vacuum_FilterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_vacuum_filter(inputs)
	return __en.chore_vacuum_filter(inputs)
});
/**
* | output |
* | --- |
* | "Vacuum the living room" |
*
* @param {Chore_Vacuum_LivingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_vacuum_living = /** @type {((inputs?: Chore_Vacuum_LivingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Vacuum_LivingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_vacuum_living(inputs)
	return __en.chore_vacuum_living(inputs)
});
/**
* | output |
* | --- |
* | "Sort the wardrobe: donate what you don't wear" |
*
* @param {Chore_WardrobeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_wardrobe = /** @type {((inputs?: Chore_WardrobeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_WardrobeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_wardrobe(inputs)
	return __en.chore_wardrobe(inputs)
});
/**
* | output |
* | --- |
* | "Run a washing machine cleaning cycle and wipe the seal" |
*
* @param {Chore_Washing_MachineInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_washing_machine = /** @type {((inputs?: Chore_Washing_MachineInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Washing_MachineInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_washing_machine(inputs)
	return __en.chore_washing_machine(inputs)
});
/**
* | output |
* | --- |
* | "Weed the garden" |
*
* @param {Chore_WeedingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_weeding = /** @type {((inputs?: Chore_WeedingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_WeedingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_weeding(inputs)
	return __en.chore_weeding(inputs)
});
/**
* | output |
* | --- |
* | "Clean the windows (inside)" |
*
* @param {Chore_Windows_InsideInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_windows_inside = /** @type {((inputs?: Chore_Windows_InsideInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Windows_InsideInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_windows_inside(inputs)
	return __en.chore_windows_inside(inputs)
});
/**
* | output |
* | --- |
* | "Clean the outside of the windows" |
*
* @param {Chore_Windows_OutsideInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chore_windows_outside = /** @type {((inputs?: Chore_Windows_OutsideInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chore_Windows_OutsideInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chore_windows_outside(inputs)
	return __en.chore_windows_outside(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} chore" |
* | * | "{count} chores" |
*
* @param {Chores_CountInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chores_count = /** @type {((inputs: Chores_CountInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chores_CountInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chores_count(inputs)
	return __en.chores_count(inputs)
});
/**
* | output |
* | --- |
* | "{count} chores switched on" |
*
* @param {Chores_OnInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chores_on = /** @type {((inputs: Chores_OnInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chores_OnInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.chores_on(inputs)
	return __en.chores_on(inputs)
});
/**
* | output |
* | --- |
* | "Cleanliness" |
*
* @param {CleanlinessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const cleanliness = /** @type {((inputs?: CleanlinessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CleanlinessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.cleanliness(inputs)
	return __en.cleanliness(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {CloseInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const close = /** @type {((inputs?: CloseInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CloseInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.close(inputs)
	return __en.close(inputs)
});
/**
* | output |
* | --- |
* | "Coins" |
*
* @param {Coins_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const coins_label = /** @type {((inputs?: Coins_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coins_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.coins_label(inputs)
	return __en.coins_label(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} coin" |
* | * | "{count} coins" |
*
* @param {Coins_NInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const coins_n = /** @type {((inputs: Coins_NInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coins_NInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.coins_n(inputs)
	return __en.coins_n(inputs)
});
/**
* | output |
* | --- |
* | "Colour" |
*
* @param {ColourInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const colour = /** @type {((inputs?: ColourInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ColourInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.colour(inputs)
	return __en.colour(inputs)
});
/**
* | output |
* | --- |
* | "Companion" |
*
* @param {CompanionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const companion = /** @type {((inputs?: CompanionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CompanionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.companion(inputs)
	return __en.companion(inputs)
});
/**
* | output |
* | --- |
* | "Delete this chore for everyone in the household?" |
*
* @param {Confirm_Delete_ChoreInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const confirm_delete_chore = /** @type {((inputs?: Confirm_Delete_ChoreInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Delete_ChoreInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.confirm_delete_chore(inputs)
	return __en.confirm_delete_chore(inputs)
});
/**
* | output |
* | --- |
* | "Leave “{household}”? Your progress will be deleted. If you're the last member, the household is deleted too." |
*
* @param {Confirm_LeaveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const confirm_leave = /** @type {((inputs: Confirm_LeaveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_LeaveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.confirm_leave(inputs)
	return __en.confirm_leave(inputs)
});
/**
* | output |
* | --- |
* | "You'll need an invite or device code to sign in again on this device." |
*
* @param {Confirm_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const confirm_sign_out = /** @type {((inputs?: Confirm_Sign_OutInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Sign_OutInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.confirm_sign_out(inputs)
	return __en.confirm_sign_out(inputs)
});
/**
* | output |
* | --- |
* | "Continue" |
*
* @param {_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
const _continue = /** @type {((inputs?: _ContinueInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_ContinueInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl._continue(inputs)
	return __en._continue(inputs)
});
export { _continue as "continue" }
/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Copy_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const copy_code = /** @type {((inputs?: Copy_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.copy_code(inputs)
	return __en.copy_code(inputs)
});
/**
* | output |
* | --- |
* | "Sorry about that. Reloading usually fixes it; your chores are safe." |
*
* @param {Crash_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const crash_body = /** @type {((inputs?: Crash_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crash_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.crash_body(inputs)
	return __en.crash_body(inputs)
});
/**
* | output |
* | --- |
* | "Something broke" |
*
* @param {Crash_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const crash_title = /** @type {((inputs?: Crash_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crash_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.crash_title(inputs)
	return __en.crash_title(inputs)
});
/**
* | output |
* | --- |
* | "Create household" |
*
* @param {Create_HouseholdInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const create_household = /** @type {((inputs?: Create_HouseholdInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_HouseholdInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.create_household(inputs)
	return __en.create_household(inputs)
});
/**
* | output |
* | --- |
* | "Daily time" |
*
* @param {Daily_TimeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const daily_time = /** @type {((inputs?: Daily_TimeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_TimeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.daily_time(inputs)
	return __en.daily_time(inputs)
});
/**
* | output |
* | --- |
* | "Longer chores are picked only when nothing else is due" |
*
* @param {Daily_Time_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const daily_time_sub = /** @type {((inputs?: Daily_Time_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Time_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.daily_time_sub(inputs)
	return __en.daily_time_sub(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} day overdue" |
* | * | "{count} days overdue" |
*
* @param {Days_OverdueInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const days_overdue = /** @type {((inputs: Days_OverdueInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Days_OverdueInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.days_overdue(inputs)
	return __en.days_overdue(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
const _delete = /** @type {((inputs?: _DeleteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_DeleteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl._delete(inputs)
	return __en._delete(inputs)
});
export { _delete as "delete" }
/**
* | output |
* | --- |
* | "Delete chore" |
*
* @param {Delete_ChoreInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const delete_chore = /** @type {((inputs?: Delete_ChoreInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_ChoreInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.delete_chore(inputs)
	return __en.delete_chore(inputs)
});
/**
* | output |
* | --- |
* | "{os} · App" |
*
* @param {Device_AppInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_app = /** @type {((inputs: Device_AppInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_AppInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.device_app(inputs)
	return __en.device_app(inputs)
});
/**
* | output |
* | --- |
* | "Device code" |
*
* @param {Device_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_code = /** @type {((inputs?: Device_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.device_code(inputs)
	return __en.device_code(inputs)
});
/**
* | output |
* | --- |
* | "Device" |
*
* @param {Device_GenericInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_generic = /** @type {((inputs?: Device_GenericInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_GenericInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.device_generic(inputs)
	return __en.device_generic(inputs)
});
/**
* | output |
* | --- |
* | "{browser} on {os}" |
*
* @param {Device_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_name = /** @type {((inputs: Device_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.device_name(inputs)
	return __en.device_name(inputs)
});
/**
* | output |
* | --- |
* | "Done" |
*
* @param {DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const done = /** @type {((inputs?: DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.done(inputs)
	return __en.done(inputs)
});
/**
* | output |
* | --- |
* | "Done" |
*
* @param {Done_ButtonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const done_button = /** @type {((inputs?: Done_ButtonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Done_ButtonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.done_button(inputs)
	return __en.done_button(inputs)
});
/**
* | output |
* | --- |
* | "Done for today" |
*
* @param {Done_For_TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const done_for_today = /** @type {((inputs?: Done_For_TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Done_For_TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.done_for_today(inputs)
	return __en.done_for_today(inputs)
});
/**
* | output |
* | --- |
* | "Dry day: good weather for this" |
*
* @param {Dry_DayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const dry_day = /** @type {((inputs?: Dry_DayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_DayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.dry_day(inputs)
	return __en.dry_day(inputs)
});
/**
* | output |
* | --- |
* | "Due in {count} days" |
*
* @param {Due_In_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const due_in_days = /** @type {((inputs: Due_In_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_In_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.due_in_days(inputs)
	return __en.due_in_days(inputs)
});
/**
* | output |
* | --- |
* | "Due today" |
*
* @param {Due_TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const due_today = /** @type {((inputs?: Due_TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.due_today(inputs)
	return __en.due_today(inputs)
});
/**
* | output |
* | --- |
* | "Due tomorrow" |
*
* @param {Due_TomorrowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const due_tomorrow = /** @type {((inputs?: Due_TomorrowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_TomorrowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.due_tomorrow(inputs)
	return __en.due_tomorrow(inputs)
});
/**
* | output |
* | --- |
* | "{hours} h" |
*
* @param {Duration_HInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const duration_h = /** @type {((inputs: Duration_HInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_HInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.duration_h(inputs)
	return __en.duration_h(inputs)
});
/**
* | output |
* | --- |
* | "{hours} h {minutes} min" |
*
* @param {Duration_H_MInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const duration_h_m = /** @type {((inputs: Duration_H_MInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_H_MInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.duration_h_m(inputs)
	return __en.duration_h_m(inputs)
});
/**
* | output |
* | --- |
* | "Easier one" |
*
* @param {Easier_OneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const easier_one = /** @type {((inputs?: Easier_OneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Easier_OneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.easier_one(inputs)
	return __en.easier_one(inputs)
});
/**
* | output |
* | --- |
* | "Edit chore" |
*
* @param {Edit_ChoreInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const edit_chore = /** @type {((inputs?: Edit_ChoreInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_ChoreInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.edit_chore(inputs)
	return __en.edit_chore(inputs)
});
/**
* | output |
* | --- |
* | "Effort" |
*
* @param {EffortInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const effort = /** @type {((inputs?: EffortInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EffortInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.effort(inputs)
	return __en.effort(inputs)
});
/**
* | output |
* | --- |
* | "Easy" |
*
* @param {Effort_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const effort_1 = /** @type {((inputs?: Effort_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Effort_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.effort_1(inputs)
	return __en.effort_1(inputs)
});
/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Effort_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const effort_2 = /** @type {((inputs?: Effort_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Effort_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.effort_2(inputs)
	return __en.effort_2(inputs)
});
/**
* | output |
* | --- |
* | "Hard" |
*
* @param {Effort_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const effort_3 = /** @type {((inputs?: Effort_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Effort_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.effort_3(inputs)
	return __en.effort_3(inputs)
});
/**
* | output |
* | --- |
* | "That one is already taken care of." |
*
* @param {Err_Already_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_already_done = /** @type {((inputs?: Err_Already_DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Already_DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_already_done(inputs)
	return __en.err_already_done(inputs)
});
/**
* | output |
* | --- |
* | "That chore isn't on your list." |
*
* @param {Err_Assignment_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_assignment_not_found = /** @type {((inputs?: Err_Assignment_Not_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Assignment_Not_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_assignment_not_found(inputs)
	return __en.err_assignment_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Pick one of the avatar colours." |
*
* @param {Err_AvatarInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_avatar = /** @type {((inputs?: Err_AvatarInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_AvatarInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_avatar(inputs)
	return __en.err_avatar(inputs)
});
/**
* | output |
* | --- |
* | "Finish today's chore first, then grab a bonus." |
*
* @param {Err_Bonus_Needs_DailyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_bonus_needs_daily = /** @type {((inputs?: Err_Bonus_Needs_DailyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Bonus_Needs_DailyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_bonus_needs_daily(inputs)
	return __en.err_bonus_needs_daily(inputs)
});
/**
* | output |
* | --- |
* | "Nothing left to do today. The house is sparkling." |
*
* @param {Err_Bonus_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_bonus_none = /** @type {((inputs?: Err_Bonus_NoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Bonus_NoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_bonus_none(inputs)
	return __en.err_bonus_none(inputs)
});
/**
* | output |
* | --- |
* | "You already have a bonus chore waiting." |
*
* @param {Err_Bonus_PendingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_bonus_pending = /** @type {((inputs?: Err_Bonus_PendingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Bonus_PendingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_bonus_pending(inputs)
	return __en.err_bonus_pending(inputs)
});
/**
* | output |
* | --- |
* | "Please fill in the chore name." |
*
* @param {Err_Chore_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_chore_name = /** @type {((inputs?: Err_Chore_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Chore_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_chore_name(inputs)
	return __en.err_chore_name(inputs)
});
/**
* | output |
* | --- |
* | "Chore not found." |
*
* @param {Err_Chore_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_chore_not_found = /** @type {((inputs?: Err_Chore_Not_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Chore_Not_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_chore_not_found(inputs)
	return __en.err_chore_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Please fill in the code." |
*
* @param {Err_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_code = /** @type {((inputs?: Err_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_code(inputs)
	return __en.err_code(inputs)
});
/**
* | output |
* | --- |
* | "That request wasn't allowed. Reload the page and try again." |
*
* @param {Err_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_forbidden = /** @type {((inputs?: Err_ForbiddenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_ForbiddenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_forbidden(inputs)
	return __en.err_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "You already have as many streak freezes as you can hold." |
*
* @param {Err_Freezes_FullInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_freezes_full = /** @type {((inputs?: Err_Freezes_FullInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Freezes_FullInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_freezes_full(inputs)
	return __en.err_freezes_full(inputs)
});
/**
* | output |
* | --- |
* | "Choose between 1 and 730 days." |
*
* @param {Err_FreqInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_freq = /** @type {((inputs?: Err_FreqInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_FreqInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_freq(inputs)
	return __en.err_freq(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong." |
*
* @param {Err_GenericInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_generic = /** @type {((inputs?: Err_GenericInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_GenericInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_generic(inputs)
	return __en.err_generic(inputs)
});
/**
* | output |
* | --- |
* | "Pick a day in the next two months." |
*
* @param {Err_Guests_DateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_guests_date = /** @type {((inputs?: Err_Guests_DateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Guests_DateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_guests_date(inputs)
	return __en.err_guests_date(inputs)
});
/**
* | output |
* | --- |
* | "You can't high-five yourself. (Nice try.)" |
*
* @param {Err_High_Five_SelfInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_high_five_self = /** @type {((inputs?: Err_High_Five_SelfInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_High_Five_SelfInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_high_five_self(inputs)
	return __en.err_high_five_self(inputs)
});
/**
* | output |
* | --- |
* | "Please fill in a household name." |
*
* @param {Err_Household_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_household_name = /** @type {((inputs?: Err_Household_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Household_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_household_name(inputs)
	return __en.err_household_name(inputs)
});
/**
* | output |
* | --- |
* | "There are already {count} people in this household." |
*
* @param {Err_Household_Too_SmallInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_household_too_small = /** @type {((inputs: Err_Household_Too_SmallInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Household_Too_SmallInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_household_too_small(inputs)
	return __en.err_household_too_small(inputs)
});
/**
* | output |
* | --- |
* | "Please check what you filled in." |
*
* @param {Err_InvalidInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_invalid = /** @type {((inputs?: Err_InvalidInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_InvalidInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_invalid(inputs)
	return __en.err_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Please fill in the invite code." |
*
* @param {Err_Invite_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_invite_code = /** @type {((inputs?: Err_Invite_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Invite_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_invite_code(inputs)
	return __en.err_invite_code(inputs)
});
/**
* | output |
* | --- |
* | "That invite code doesn't match any household." |
*
* @param {Err_Invite_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_invite_not_found = /** @type {((inputs?: Err_Invite_Not_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Invite_Not_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_invite_not_found(inputs)
	return __en.err_invite_not_found(inputs)
});
/**
* | output |
* | --- |
* | "You already have that one." |
*
* @param {Err_Item_OwnedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_item_owned = /** @type {((inputs?: Err_Item_OwnedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Item_OwnedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_item_owned(inputs)
	return __en.err_item_owned(inputs)
});
/**
* | output |
* | --- |
* | "That code is invalid or has expired." |
*
* @param {Err_Link_InvalidInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_link_invalid = /** @type {((inputs?: Err_Link_InvalidInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Link_InvalidInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_link_invalid(inputs)
	return __en.err_link_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Member not found." |
*
* @param {Err_Member_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_member_not_found = /** @type {((inputs?: Err_Member_Not_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Member_Not_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_member_not_found(inputs)
	return __en.err_member_not_found(inputs)
});
/**
* | output |
* | --- |
* | "You're offline. Check your connection and try again." |
*
* @param {Err_No_ConnectionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_no_connection = /** @type {((inputs?: Err_No_ConnectionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_No_ConnectionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_no_connection(inputs)
	return __en.err_no_connection(inputs)
});
/**
* | output |
* | --- |
* | "No other chore available to swap to." |
*
* @param {Err_No_Swap_OptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_no_swap_option = /** @type {((inputs?: Err_No_Swap_OptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_No_Swap_OptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_no_swap_option(inputs)
	return __en.err_no_swap_option(inputs)
});
/**
* | output |
* | --- |
* | "Not enough coins yet." |
*
* @param {Err_Not_Enough_CoinsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_not_enough_coins = /** @type {((inputs?: Err_Not_Enough_CoinsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_Enough_CoinsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_not_enough_coins(inputs)
	return __en.err_not_enough_coins(inputs)
});
/**
* | output |
* | --- |
* | "Not found." |
*
* @param {Err_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_not_found = /** @type {((inputs?: Err_Not_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_not_found(inputs)
	return __en.err_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Nothing to swap right now." |
*
* @param {Err_Nothing_To_SwapInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_nothing_to_swap = /** @type {((inputs?: Err_Nothing_To_SwapInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Nothing_To_SwapInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_nothing_to_swap(inputs)
	return __en.err_nothing_to_swap(inputs)
});
/**
* | output |
* | --- |
* | "Can't reach the server. Are you offline?" |
*
* @param {Err_OfflineInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_offline = /** @type {((inputs?: Err_OfflineInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_OfflineInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_offline(inputs)
	return __en.err_offline(inputs)
});
/**
* | output |
* | --- |
* | "That person isn't in this household." |
*
* @param {Err_OwnerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_owner = /** @type {((inputs?: Err_OwnerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_OwnerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_owner(inputs)
	return __en.err_owner(inputs)
});
/**
* | output |
* | --- |
* | "A break can't end in the past." |
*
* @param {Err_Pause_PastInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_pause_past = /** @type {((inputs?: Err_Pause_PastInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Pause_PastInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_pause_past(inputs)
	return __en.err_pause_past(inputs)
});
/**
* | output |
* | --- |
* | "A break can last at most a year." |
*
* @param {Err_Pause_Too_LongInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_pause_too_long = /** @type {((inputs?: Err_Pause_Too_LongInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Pause_Too_LongInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_pause_too_long(inputs)
	return __en.err_pause_too_long(inputs)
});
/**
* | output |
* | --- |
* | "Up to 8 people are supported." |
*
* @param {Err_People_MaxInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_people_max = /** @type {((inputs?: Err_People_MaxInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_People_MaxInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_people_max(inputs)
	return __en.err_people_max(inputs)
});
/**
* | output |
* | --- |
* | "At least one person lives here." |
*
* @param {Err_People_MinInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_people_min = /** @type {((inputs?: Err_People_MinInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_People_MinInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_people_min(inputs)
	return __en.err_people_min(inputs)
});
/**
* | output |
* | --- |
* | "Please fill in a pet name." |
*
* @param {Err_Pet_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_pet_name = /** @type {((inputs?: Err_Pet_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Pet_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_pet_name(inputs)
	return __en.err_pet_name(inputs)
});
/**
* | output |
* | --- |
* | "That doesn't look like a photo. Try a JPEG or PNG." |
*
* @param {Err_Photo_InvalidInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_photo_invalid = /** @type {((inputs?: Err_Photo_InvalidInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Photo_InvalidInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_photo_invalid(inputs)
	return __en.err_photo_invalid(inputs)
});
/**
* | output |
* | --- |
* | "That photo is too big." |
*
* @param {Err_Photo_Too_BigInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_photo_too_big = /** @type {((inputs?: Err_Photo_Too_BigInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Photo_Too_BigInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_photo_too_big(inputs)
	return __en.err_photo_too_big(inputs)
});
/**
* | output |
* | --- |
* | "The weather service isn't answering. Try again later." |
*
* @param {Err_Places_UnavailableInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_places_unavailable = /** @type {((inputs?: Err_Places_UnavailableInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Places_UnavailableInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_places_unavailable(inputs)
	return __en.err_places_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "A big job needs at least one step. Delete the job instead." |
*
* @param {Err_Project_Last_StepInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_project_last_step = /** @type {((inputs?: Err_Project_Last_StepInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Project_Last_StepInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_project_last_step(inputs)
	return __en.err_project_last_step(inputs)
});
/**
* | output |
* | --- |
* | "Give the job a name." |
*
* @param {Err_Project_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_project_name = /** @type {((inputs?: Err_Project_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Project_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_project_name(inputs)
	return __en.err_project_name(inputs)
});
/**
* | output |
* | --- |
* | "Add at least one step (20 at most)." |
*
* @param {Err_Project_StepsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_project_steps = /** @type {((inputs?: Err_Project_StepsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Project_StepsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_project_steps(inputs)
	return __en.err_project_steps(inputs)
});
/**
* | output |
* | --- |
* | "Invalid push subscription." |
*
* @param {Err_Push_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_push_subscription = /** @type {((inputs?: Err_Push_SubscriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Push_SubscriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_push_subscription(inputs)
	return __en.err_push_subscription(inputs)
});
/**
* | output |
* | --- |
* | "Too many tries. Wait a minute and try again." |
*
* @param {Err_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_rate_limited = /** @type {((inputs?: Err_Rate_LimitedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Rate_LimitedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_rate_limited(inputs)
	return __en.err_rate_limited(inputs)
});
/**
* | output |
* | --- |
* | "Please fill in the room." |
*
* @param {Err_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_room = /** @type {((inputs?: Err_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_room(inputs)
	return __en.err_room(inputs)
});
/**
* | output |
* | --- |
* | "Pick at least one day with a chore." |
*
* @param {Err_Schedule_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_schedule_empty = /** @type {((inputs?: Err_Schedule_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Schedule_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_schedule_empty(inputs)
	return __en.err_schedule_empty(inputs)
});
/**
* | output |
* | --- |
* | "Something went wrong on our side." |
*
* @param {Err_ServerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_server = /** @type {((inputs?: Err_ServerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_ServerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_server(inputs)
	return __en.err_server(inputs)
});
/**
* | output |
* | --- |
* | "Please sign in." |
*
* @param {Err_Sign_InInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_sign_in = /** @type {((inputs?: Err_Sign_InInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Sign_InInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_sign_in(inputs)
	return __en.err_sign_in(inputs)
});
/**
* | output |
* | --- |
* | "Please sign in again." |
*
* @param {Err_Sign_In_AgainInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_sign_in_again = /** @type {((inputs?: Err_Sign_In_AgainInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Sign_In_AgainInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_sign_in_again(inputs)
	return __en.err_sign_in_again(inputs)
});
/**
* | output |
* | --- |
* | "What's the step?" |
*
* @param {Err_Step_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_step_name = /** @type {((inputs?: Err_Step_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Step_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_step_name(inputs)
	return __en.err_step_name(inputs)
});
/**
* | output |
* | --- |
* | "The list is full. Tick some things off first." |
*
* @param {Err_Supplies_FullInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_supplies_full = /** @type {((inputs?: Err_Supplies_FullInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Supplies_FullInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_supplies_full(inputs)
	return __en.err_supplies_full(inputs)
});
/**
* | output |
* | --- |
* | "What do you need?" |
*
* @param {Err_Supply_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_supply_name = /** @type {((inputs?: Err_Supply_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Supply_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_supply_name(inputs)
	return __en.err_supply_name(inputs)
});
/**
* | output |
* | --- |
* | "You already used your swap today." |
*
* @param {Err_Swap_UsedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_swap_used = /** @type {((inputs?: Err_Swap_UsedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Swap_UsedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_swap_used(inputs)
	return __en.err_swap_used(inputs)
});
/**
* | output |
* | --- |
* | "Reminder time must look like 18:30." |
*
* @param {Err_Time_FormatInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_time_format = /** @type {((inputs?: Err_Time_FormatInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Time_FormatInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_time_format(inputs)
	return __en.err_time_format(inputs)
});
/**
* | output |
* | --- |
* | "The server took too long to answer. Try again." |
*
* @param {Err_TimeoutInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_timeout = /** @type {((inputs?: Err_TimeoutInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_TimeoutInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_timeout(inputs)
	return __en.err_timeout(inputs)
});
/**
* | output |
* | --- |
* | "Pick between 1 and 360 minutes." |
*
* @param {Err_Timer_MinutesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_timer_minutes = /** @type {((inputs?: Err_Timer_MinutesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Timer_MinutesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_timer_minutes(inputs)
	return __en.err_timer_minutes(inputs)
});
/**
* | output |
* | --- |
* | "That's a lot of machines at once. Clear a finished one first." |
*
* @param {Err_Timers_FullInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_timers_full = /** @type {((inputs?: Err_Timers_FullInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Timers_FullInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_timers_full(inputs)
	return __en.err_timers_full(inputs)
});
/**
* | output |
* | --- |
* | "Request too large." |
*
* @param {Err_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_too_large = /** @type {((inputs?: Err_Too_LargeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Too_LargeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_too_large(inputs)
	return __en.err_too_large(inputs)
});
/**
* | output |
* | --- |
* | "That's too long." |
*
* @param {Err_Too_LongInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_too_long = /** @type {((inputs?: Err_Too_LongInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Too_LongInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_too_long(inputs)
	return __en.err_too_long(inputs)
});
/**
* | output |
* | --- |
* | "That trade isn't open any more." |
*
* @param {Err_Trade_GoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_trade_gone = /** @type {((inputs?: Err_Trade_GoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Trade_GoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_trade_gone(inputs)
	return __en.err_trade_gone(inputs)
});
/**
* | output |
* | --- |
* | "You both need a chore waiting today to trade." |
*
* @param {Err_Trade_NothingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_trade_nothing = /** @type {((inputs?: Err_Trade_NothingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Trade_NothingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_trade_nothing(inputs)
	return __en.err_trade_nothing(inputs)
});
/**
* | output |
* | --- |
* | "One of these chores belongs to someone, so it can't be traded." |
*
* @param {Err_Trade_OwnedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_trade_owned = /** @type {((inputs?: Err_Trade_OwnedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Trade_OwnedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_trade_owned(inputs)
	return __en.err_trade_owned(inputs)
});
/**
* | output |
* | --- |
* | "What's the treat?" |
*
* @param {Err_Treat_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_treat_name = /** @type {((inputs?: Err_Treat_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Treat_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_treat_name(inputs)
	return __en.err_treat_name(inputs)
});
/**
* | output |
* | --- |
* | "Pick a price between 10 and 100,000 coins." |
*
* @param {Err_Treat_PriceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_treat_price = /** @type {((inputs?: Err_Treat_PriceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Treat_PriceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_treat_price(inputs)
	return __en.err_treat_price(inputs)
});
/**
* | output |
* | --- |
* | "That's a lot of treats! Remove one first." |
*
* @param {Err_Treats_FullInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_treats_full = /** @type {((inputs?: Err_Treats_FullInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Treats_FullInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_treats_full(inputs)
	return __en.err_treats_full(inputs)
});
/**
* | output |
* | --- |
* | "Unknown time zone." |
*
* @param {Err_TzInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_tz = /** @type {((inputs?: Err_TzInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_TzInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_tz(inputs)
	return __en.err_tz(inputs)
});
/**
* | output |
* | --- |
* | "Please fill in your name." |
*
* @param {Err_Your_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_your_name = /** @type {((inputs?: Err_Your_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Your_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.err_your_name(inputs)
	return __en.err_your_name(inputs)
});
/**
* | output |
* | --- |
* | "Every how many days" |
*
* @param {Every_How_Many_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const every_how_many_days = /** @type {((inputs?: Every_How_Many_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Every_How_Many_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.every_how_many_days(inputs)
	return __en.every_how_many_days(inputs)
});
/**
* | output |
* | --- |
* | "Everyone" |
*
* @param {EveryoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const everyone = /** @type {((inputs?: EveryoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EveryoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.everyone(inputs)
	return __en.everyone(inputs)
});
/**
* | output |
* | --- |
* | "Expired. Close this and make a new code." |
*
* @param {ExpiredInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const expired = /** @type {((inputs?: ExpiredInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ExpiredInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.expired(inputs)
	return __en.expired(inputs)
});
/**
* | output |
* | --- |
* | "Expires in {time}" |
*
* @param {Expires_InInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const expires_in = /** @type {((inputs: Expires_InInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expires_InInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.expires_in(inputs)
	return __en.expires_in(inputs)
});
/**
* | output |
* | --- |
* | "Fair share" |
*
* @param {Fair_ShareInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const fair_share = /** @type {((inputs?: Fair_ShareInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_ShareInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.fair_share(inputs)
	return __en.fair_share(inputs)
});
/**
* | output |
* | --- |
* | "Not enough done yet to compare." |
*
* @param {Fair_Share_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const fair_share_empty = /** @type {((inputs?: Fair_Share_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Share_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.fair_share_empty(inputs)
	return __en.fair_share_empty(inputs)
});
/**
* | output |
* | --- |
* | "Effort over the last {days} days (minutes times how hard). Whoever's doing more gets lighter chores for a while." |
*
* @param {Fair_Share_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const fair_share_hint = /** @type {((inputs: Fair_Share_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Share_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.fair_share_hint(inputs)
	return __en.fair_share_hint(inputs)
});
/**
* | output |
* | --- |
* | "Your first chore earns your first badge." |
*
* @param {First_Badge_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const first_badge_hint = /** @type {((inputs?: First_Badge_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<First_Badge_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.first_badge_hint(inputs)
	return __en.first_badge_hint(inputs)
});
/**
* | output |
* | --- |
* | "found {sticker}" |
*
* @param {Found_StickerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const found_sticker = /** @type {((inputs: Found_StickerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Found_StickerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.found_sticker(inputs)
	return __en.found_sticker(inputs)
});
/**
* | output |
* | --- |
* | "Streak freeze ready" |
*
* @param {Freeze_BoughtInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_bought = /** @type {((inputs?: Freeze_BoughtInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_BoughtInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_bought(inputs)
	return __en.freeze_bought(inputs)
});
/**
* | output |
* | --- |
* | "{price} coins. If you miss a chore day, it keeps your streak going." |
*
* @param {Freeze_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_confirm_body = /** @type {((inputs: Freeze_Confirm_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_Confirm_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_confirm_body(inputs)
	return __en.freeze_confirm_body(inputs)
});
/**
* | output |
* | --- |
* | "Buy a streak freeze?" |
*
* @param {Freeze_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_confirm_title = /** @type {((inputs?: Freeze_Confirm_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_Confirm_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_confirm_title(inputs)
	return __en.freeze_confirm_title(inputs)
});
/**
* | output |
* | --- |
* | "A streak freeze covered the missed day" |
*
* @param {Freeze_CoveredInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_covered = /** @type {((inputs?: Freeze_CoveredInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_CoveredInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_covered(inputs)
	return __en.freeze_covered(inputs)
});
/**
* | output |
* | --- |
* | "Streak freeze earned" |
*
* @param {Freeze_EarnedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_earned = /** @type {((inputs?: Freeze_EarnedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_EarnedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_earned(inputs)
	return __en.freeze_earned(inputs)
});
/**
* | output |
* | --- |
* | "Covers one missed day automatically" |
*
* @param {Freeze_Earned_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_earned_sub = /** @type {((inputs?: Freeze_Earned_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_Earned_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_earned_sub(inputs)
	return __en.freeze_earned_sub(inputs)
});
/**
* | output |
* | --- |
* | "Full" |
*
* @param {Freeze_FullInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_full = /** @type {((inputs?: Freeze_FullInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_FullInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_full(inputs)
	return __en.freeze_full(inputs)
});
/**
* | output |
* | --- |
* | "Streak freeze" |
*
* @param {Freeze_ItemInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_item = /** @type {((inputs?: Freeze_ItemInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_ItemInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_item(inputs)
	return __en.freeze_item(inputs)
});
/**
* | output |
* | --- |
* | "Covers a missed chore day · you have {count} of {max}" |
*
* @param {Freeze_Item_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freeze_item_sub = /** @type {((inputs: Freeze_Item_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freeze_Item_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freeze_item_sub(inputs)
	return __en.freeze_item_sub(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} freeze" |
* | * | "{count} freezes" |
*
* @param {Freezes_CountInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freezes_count = /** @type {((inputs: Freezes_CountInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freezes_CountInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freezes_count(inputs)
	return __en.freezes_count(inputs)
});
/**
* | output |
* | --- |
* | "Every 2 months" |
*
* @param {Freq_2monthsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_2months = /** @type {((inputs?: Freq_2monthsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_2monthsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_2months(inputs)
	return __en.freq_2months(inputs)
});
/**
* | output |
* | --- |
* | "Every 2 weeks" |
*
* @param {Freq_2weeksInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_2weeks = /** @type {((inputs?: Freq_2weeksInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_2weeksInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_2weeks(inputs)
	return __en.freq_2weeks(inputs)
});
/**
* | output |
* | --- |
* | "Every 3 months" |
*
* @param {Freq_3monthsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_3months = /** @type {((inputs?: Freq_3monthsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_3monthsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_3months(inputs)
	return __en.freq_3months(inputs)
});
/**
* | output |
* | --- |
* | "Custom…" |
*
* @param {Freq_CustomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_custom = /** @type {((inputs?: Freq_CustomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_CustomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_custom(inputs)
	return __en.freq_custom(inputs)
});
/**
* | output |
* | --- |
* | "Daily" |
*
* @param {Freq_DailyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_daily = /** @type {((inputs?: Freq_DailyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_DailyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_daily(inputs)
	return __en.freq_daily(inputs)
});
/**
* | output |
* | --- |
* | "Every {count} days" |
*
* @param {Freq_Every_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_every_days = /** @type {((inputs: Freq_Every_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_Every_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_every_days(inputs)
	return __en.freq_every_days(inputs)
});
/**
* | output |
* | --- |
* | "Every {count} weeks" |
*
* @param {Freq_Every_WeeksInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_every_weeks = /** @type {((inputs: Freq_Every_WeeksInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_Every_WeeksInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_every_weeks(inputs)
	return __en.freq_every_weeks(inputs)
});
/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Freq_MonthlyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_monthly = /** @type {((inputs?: Freq_MonthlyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_MonthlyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_monthly(inputs)
	return __en.freq_monthly(inputs)
});
/**
* | output |
* | --- |
* | "Twice a year" |
*
* @param {Freq_Twice_YearInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_twice_year = /** @type {((inputs?: Freq_Twice_YearInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_Twice_YearInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_twice_year(inputs)
	return __en.freq_twice_year(inputs)
});
/**
* | output |
* | --- |
* | "Weekly" |
*
* @param {Freq_WeeklyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_weekly = /** @type {((inputs?: Freq_WeeklyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_WeeklyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_weekly(inputs)
	return __en.freq_weekly(inputs)
});
/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Freq_YearlyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const freq_yearly = /** @type {((inputs?: Freq_YearlyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freq_YearlyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.freq_yearly(inputs)
	return __en.freq_yearly(inputs)
});
/**
* | output |
* | --- |
* | "Fully grown" |
*
* @param {Fully_GrownInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const fully_grown = /** @type {((inputs?: Fully_GrownInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fully_GrownInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.fully_grown(inputs)
	return __en.fully_grown(inputs)
});
/**
* | output |
* | --- |
* | "Aquarium" |
*
* @param {Furniture_AquariumInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_aquarium = /** @type {((inputs?: Furniture_AquariumInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_AquariumInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_aquarium(inputs)
	return __en.furniture_aquarium(inputs)
});
/**
* | output |
* | --- |
* | "Bookcase" |
*
* @param {Furniture_BookcaseInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_bookcase = /** @type {((inputs?: Furniture_BookcaseInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_BookcaseInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_bookcase(inputs)
	return __en.furniture_bookcase(inputs)
});
/**
* | output |
* | --- |
* | "Clock" |
*
* @param {Furniture_ClockInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_clock = /** @type {((inputs?: Furniture_ClockInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_ClockInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_clock(inputs)
	return __en.furniture_clock(inputs)
});
/**
* | output |
* | --- |
* | "Cushion" |
*
* @param {Furniture_CushionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_cushion = /** @type {((inputs?: Furniture_CushionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_CushionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_cushion(inputs)
	return __en.furniture_cushion(inputs)
});
/**
* | output |
* | --- |
* | "Disco ball" |
*
* @param {Furniture_Disco_BallInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_disco_ball = /** @type {((inputs?: Furniture_Disco_BallInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_Disco_BallInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_disco_ball(inputs)
	return __en.furniture_disco_ball(inputs)
});
/**
* | output |
* | --- |
* | "Dotty wallpaper" |
*
* @param {Furniture_DotsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_dots = /** @type {((inputs?: Furniture_DotsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_DotsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_dots(inputs)
	return __en.furniture_dots(inputs)
});
/**
* | output |
* | --- |
* | "Fairy lights" |
*
* @param {Furniture_Fairy_LightsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_fairy_lights = /** @type {((inputs?: Furniture_Fairy_LightsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_Fairy_LightsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_fairy_lights(inputs)
	return __en.furniture_fairy_lights(inputs)
});
/**
* | output |
* | --- |
* | "Floor lamp" |
*
* @param {Furniture_Floor_LampInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_floor_lamp = /** @type {((inputs?: Furniture_Floor_LampInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_Floor_LampInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_floor_lamp(inputs)
	return __en.furniture_floor_lamp(inputs)
});
/**
* | output |
* | --- |
* | "Painting" |
*
* @param {Furniture_PaintingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_painting = /** @type {((inputs?: Furniture_PaintingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_PaintingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_painting(inputs)
	return __en.furniture_painting(inputs)
});
/**
* | output |
* | --- |
* | "{pet} got a {item}! Consider this your permission to treat your own room too." |
*
* @param {Furniture_PermissionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_permission = /** @type {((inputs: Furniture_PermissionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_PermissionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_permission(inputs)
	return __en.furniture_permission(inputs)
});
/**
* | output |
* | --- |
* | "Plant" |
*
* @param {Furniture_PlantInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_plant = /** @type {((inputs?: Furniture_PlantInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_PlantInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_plant(inputs)
	return __en.furniture_plant(inputs)
});
/**
* | output |
* | --- |
* | "Rug" |
*
* @param {Furniture_RugInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_rug = /** @type {((inputs?: Furniture_RugInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_RugInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_rug(inputs)
	return __en.furniture_rug(inputs)
});
/**
* | output |
* | --- |
* | "Shelf" |
*
* @param {Furniture_ShelfInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_shelf = /** @type {((inputs?: Furniture_ShelfInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_ShelfInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_shelf(inputs)
	return __en.furniture_shelf(inputs)
});
/**
* | output |
* | --- |
* | "Striped wallpaper" |
*
* @param {Furniture_StripesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_stripes = /** @type {((inputs?: Furniture_StripesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_StripesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_stripes(inputs)
	return __en.furniture_stripes(inputs)
});
/**
* | output |
* | --- |
* | "Window" |
*
* @param {Furniture_WindowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const furniture_window = /** @type {((inputs?: Furniture_WindowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Furniture_WindowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.furniture_window(inputs)
	return __en.furniture_window(inputs)
});
/**
* | output |
* | --- |
* | "Guests {date}: the rooms they'll see come first." |
*
* @param {Guests_BannerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_banner = /** @type {((inputs: Guests_BannerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_BannerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_banner(inputs)
	return __en.guests_banner(inputs)
});
/**
* | output |
* | --- |
* | "No guests after all" |
*
* @param {Guests_ClearInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_clear = /** @type {((inputs?: Guests_ClearInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_ClearInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_clear(inputs)
	return __en.guests_clear(inputs)
});
/**
* | output |
* | --- |
* | "In the days before, the chores visitors notice come first: toilet, living room, hallway, kitchen." |
*
* @param {Guests_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_intro = /** @type {((inputs?: Guests_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_intro(inputs)
	return __en.guests_intro(inputs)
});
/**
* | output |
* | --- |
* | "Guests {date}" |
*
* @param {Guests_OnInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_on = /** @type {((inputs: Guests_OnInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_OnInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_on(inputs)
	return __en.guests_on(inputs)
});
/**
* | output |
* | --- |
* | "Or pick a date" |
*
* @param {Guests_PickInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_pick = /** @type {((inputs?: Guests_PickInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_PickInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_pick(inputs)
	return __en.guests_pick(inputs)
});
/**
* | output |
* | --- |
* | "Guests coming?" |
*
* @param {Guests_RowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_row = /** @type {((inputs?: Guests_RowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_RowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_row(inputs)
	return __en.guests_row(inputs)
});
/**
* | output |
* | --- |
* | "The rooms people see get done first" |
*
* @param {Guests_Row_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_row_sub = /** @type {((inputs?: Guests_Row_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_Row_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_row_sub(inputs)
	return __en.guests_row_sub(inputs)
});
/**
* | output |
* | --- |
* | "When are guests coming?" |
*
* @param {Guests_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_title = /** @type {((inputs?: Guests_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_title(inputs)
	return __en.guests_title(inputs)
});
/**
* | output |
* | --- |
* | "Tomorrow" |
*
* @param {Guests_TomorrowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const guests_tomorrow = /** @type {((inputs?: Guests_TomorrowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guests_TomorrowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.guests_tomorrow(inputs)
	return __en.guests_tomorrow(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Hide {count} switched-off chore" |
* | * | "Hide {count} switched-off chores" |
*
* @param {Hide_InactiveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const hide_inactive = /** @type {((inputs: Hide_InactiveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hide_InactiveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.hide_inactive(inputs)
	return __en.hide_inactive(inputs)
});
/**
* | output |
* | --- |
* | "High-five" |
*
* @param {High_FiveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const high_five = /** @type {((inputs?: High_FiveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<High_FiveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.high_five(inputs)
	return __en.high_five(inputs)
});
/**
* | output |
* | --- |
* | "High-fived" |
*
* @param {High_FivedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const high_fived = /** @type {((inputs?: High_FivedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<High_FivedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.high_fived(inputs)
	return __en.high_fived(inputs)
});
/**
* | output |
* | --- |
* | "History" |
*
* @param {HistoryInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const history = /** @type {((inputs?: HistoryInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HistoryInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.history(inputs)
	return __en.history(inputs)
});
/**
* | output |
* | --- |
* | "Not done yet in the app." |
*
* @param {History_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const history_empty = /** @type {((inputs?: History_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.history_empty(inputs)
	return __en.history_empty(inputs)
});
/**
* | output |
* | --- |
* | "So you only get chores that make sense. You can change this later." |
*
* @param {Home_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_intro = /** @type {((inputs?: Home_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_intro(inputs)
	return __en.home_intro(inputs)
});
/**
* | output |
* | --- |
* | "Bird" |
*
* @param {Home_Pet_BirdInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_pet_bird = /** @type {((inputs?: Home_Pet_BirdInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pet_BirdInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_pet_bird(inputs)
	return __en.home_pet_bird(inputs)
});
/**
* | output |
* | --- |
* | "Cat" |
*
* @param {Home_Pet_CatInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_pet_cat = /** @type {((inputs?: Home_Pet_CatInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pet_CatInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_pet_cat(inputs)
	return __en.home_pet_cat(inputs)
});
/**
* | output |
* | --- |
* | "Dog" |
*
* @param {Home_Pet_DogInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_pet_dog = /** @type {((inputs?: Home_Pet_DogInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pet_DogInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_pet_dog(inputs)
	return __en.home_pet_dog(inputs)
});
/**
* | output |
* | --- |
* | "Fish" |
*
* @param {Home_Pet_FishInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_pet_fish = /** @type {((inputs?: Home_Pet_FishInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pet_FishInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_pet_fish(inputs)
	return __en.home_pet_fish(inputs)
});
/**
* | output |
* | --- |
* | "Rabbit or rodent" |
*
* @param {Home_Pet_Small_PetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_pet_small_pet = /** @type {((inputs?: Home_Pet_Small_PetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pet_Small_PetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_pet_small_pet(inputs)
	return __en.home_pet_small_pet(inputs)
});
/**
* | output |
* | --- |
* | "Chore list updated for your home" |
*
* @param {Home_SavedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_saved = /** @type {((inputs?: Home_SavedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_SavedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_saved(inputs)
	return __en.home_saved(inputs)
});
/**
* | output |
* | --- |
* | "Balcony" |
*
* @param {Home_Space_BalconyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_balcony = /** @type {((inputs?: Home_Space_BalconyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_BalconyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_balcony(inputs)
	return __en.home_space_balcony(inputs)
});
/**
* | output |
* | --- |
* | "Dining area" |
*
* @param {Home_Space_DiningInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_dining = /** @type {((inputs?: Home_Space_DiningInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_DiningInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_dining(inputs)
	return __en.home_space_dining(inputs)
});
/**
* | output |
* | --- |
* | "Garage" |
*
* @param {Home_Space_GarageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_garage = /** @type {((inputs?: Home_Space_GarageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_GarageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_garage(inputs)
	return __en.home_space_garage(inputs)
});
/**
* | output |
* | --- |
* | "Garden" |
*
* @param {Home_Space_GardenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_garden = /** @type {((inputs?: Home_Space_GardenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_GardenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_garden(inputs)
	return __en.home_space_garden(inputs)
});
/**
* | output |
* | --- |
* | "Guest room" |
*
* @param {Home_Space_Guest_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_guest_room = /** @type {((inputs?: Home_Space_Guest_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_Guest_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_guest_room(inputs)
	return __en.home_space_guest_room(inputs)
});
/**
* | output |
* | --- |
* | "Laundry room" |
*
* @param {Home_Space_LaundryInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_laundry = /** @type {((inputs?: Home_Space_LaundryInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_LaundryInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_laundry(inputs)
	return __en.home_space_laundry(inputs)
});
/**
* | output |
* | --- |
* | "Home office" |
*
* @param {Home_Space_OfficeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_office = /** @type {((inputs?: Home_Space_OfficeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_OfficeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_office(inputs)
	return __en.home_space_office(inputs)
});
/**
* | output |
* | --- |
* | "Stairs" |
*
* @param {Home_Space_StairsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_space_stairs = /** @type {((inputs?: Home_Space_StairsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Space_StairsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_space_stairs(inputs)
	return __en.home_space_stairs(inputs)
});
/**
* | output |
* | --- |
* | "Bathtub" |
*
* @param {Home_Thing_BathtubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_thing_bathtub = /** @type {((inputs?: Home_Thing_BathtubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Thing_BathtubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_thing_bathtub(inputs)
	return __en.home_thing_bathtub(inputs)
});
/**
* | output |
* | --- |
* | "Dishwasher" |
*
* @param {Home_Thing_DishwasherInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_thing_dishwasher = /** @type {((inputs?: Home_Thing_DishwasherInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Thing_DishwasherInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_thing_dishwasher(inputs)
	return __en.home_thing_dishwasher(inputs)
});
/**
* | output |
* | --- |
* | "Tumble dryer" |
*
* @param {Home_Thing_DryerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_thing_dryer = /** @type {((inputs?: Home_Thing_DryerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Thing_DryerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_thing_dryer(inputs)
	return __en.home_thing_dryer(inputs)
});
/**
* | output |
* | --- |
* | "Houseplants" |
*
* @param {Home_Thing_PlantsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_thing_plants = /** @type {((inputs?: Home_Thing_PlantsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Thing_PlantsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_thing_plants(inputs)
	return __en.home_thing_plants(inputs)
});
/**
* | output |
* | --- |
* | "Tell us about your home" |
*
* @param {Home_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_title = /** @type {((inputs?: Home_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_title(inputs)
	return __en.home_title(inputs)
});
/**
* | output |
* | --- |
* | "Apartment" |
*
* @param {Home_Type_ApartmentInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_type_apartment = /** @type {((inputs?: Home_Type_ApartmentInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Type_ApartmentInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_type_apartment(inputs)
	return __en.home_type_apartment(inputs)
});
/**
* | output |
* | --- |
* | "House" |
*
* @param {Home_Type_HouseInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_type_house = /** @type {((inputs?: Home_Type_HouseInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Type_HouseInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.home_type_house(inputs)
	return __en.home_type_house(inputs)
});
/**
* | output |
* | --- |
* | "Household" |
*
* @param {HouseholdInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const household = /** @type {((inputs?: HouseholdInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HouseholdInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.household(inputs)
	return __en.household(inputs)
});
/**
* | output |
* | --- |
* | "Household name" |
*
* @param {Household_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const household_name = /** @type {((inputs?: Household_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.household_name(inputs)
	return __en.household_name(inputs)
});
/**
* | output |
* | --- |
* | "Our place" |
*
* @param {Household_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const household_name_placeholder = /** @type {((inputs?: Household_Name_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Name_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.household_name_placeholder(inputs)
	return __en.household_name_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "In season: {months}" |
*
* @param {In_SeasonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const in_season = /** @type {((inputs: In_SeasonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<In_SeasonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.in_season(inputs)
	return __en.in_season(inputs)
});
/**
* | output |
* | --- |
* | "It works best as an app: daily reminders, full screen, one tap away on your home screen." |
*
* @param {Install_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_body = /** @type {((inputs?: Install_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_body(inputs)
	return __en.install_body(inputs)
});
/**
* | output |
* | --- |
* | "Install app" |
*
* @param {Install_ButtonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_button = /** @type {((inputs?: Install_ButtonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_ButtonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_button(inputs)
	return __en.install_button(inputs)
});
/**
* | output |
* | --- |
* | "Open CleanReminder from your home screen or app list to get started." |
*
* @param {Install_Done_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_done_body = /** @type {((inputs?: Install_Done_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Done_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_done_body(inputs)
	return __en.install_done_body(inputs)
});
/**
* | output |
* | --- |
* | "Installed" |
*
* @param {Install_Done_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_done_title = /** @type {((inputs?: Install_Done_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Done_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_done_title(inputs)
	return __en.install_done_title(inputs)
});
/**
* | output |
* | --- |
* | "Your invite code. You'll need it in the app:" |
*
* @param {Install_Invite_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_invite_note = /** @type {((inputs?: Install_Invite_NoteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Invite_NoteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_invite_note(inputs)
	return __en.install_invite_note(inputs)
});
/**
* | output |
* | --- |
* | "Tap Share in Safari's toolbar" |
*
* @param {Install_Ios_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_ios_1 = /** @type {((inputs?: Install_Ios_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Ios_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_ios_1(inputs)
	return __en.install_ios_1(inputs)
});
/**
* | output |
* | --- |
* | "Choose “Add to Home Screen”" |
*
* @param {Install_Ios_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_ios_2 = /** @type {((inputs?: Install_Ios_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Ios_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_ios_2(inputs)
	return __en.install_ios_2(inputs)
});
/**
* | output |
* | --- |
* | "Open CleanReminder from your home screen" |
*
* @param {Install_OpenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_open = /** @type {((inputs?: Install_OpenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_OpenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_open(inputs)
	return __en.install_open(inputs)
});
/**
* | output |
* | --- |
* | "Open your browser's menu" |
*
* @param {Install_Other_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_other_1 = /** @type {((inputs?: Install_Other_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Other_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_other_1(inputs)
	return __en.install_other_1(inputs)
});
/**
* | output |
* | --- |
* | "Choose “Install app” or “Add to Home screen”" |
*
* @param {Install_Other_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_other_2 = /** @type {((inputs?: Install_Other_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Other_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_other_2(inputs)
	return __en.install_other_2(inputs)
});
/**
* | output |
* | --- |
* | "Use in the browser instead" |
*
* @param {Install_SkipInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_skip = /** @type {((inputs?: Install_SkipInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_SkipInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_skip(inputs)
	return __en.install_skip(inputs)
});
/**
* | output |
* | --- |
* | "Install CleanReminder" |
*
* @param {Install_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_title = /** @type {((inputs?: Install_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.install_title(inputs)
	return __en.install_title(inputs)
});
/**
* | output |
* | --- |
* | "Invite code" |
*
* @param {Invite_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_code = /** @type {((inputs?: Invite_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.invite_code(inputs)
	return __en.invite_code(inputs)
});
/**
* | output |
* | --- |
* | "Invite code: {code}" |
*
* @param {Invite_Code_ToastInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_code_toast = /** @type {((inputs: Invite_Code_ToastInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Code_ToastInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.invite_code_toast(inputs)
	return __en.invite_code_toast(inputs)
});
/**
* | output |
* | --- |
* | "Invite link copied" |
*
* @param {Invite_CopiedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_copied = /** @type {((inputs?: Invite_CopiedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_CopiedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.invite_copied(inputs)
	return __en.invite_copied(inputs)
});
/**
* | output |
* | --- |
* | "Join “{household}” on CleanReminder. Invite code: {code}" |
*
* @param {Invite_TextInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_text = /** @type {((inputs: Invite_TextInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_TextInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.invite_text(inputs)
	return __en.invite_text(inputs)
});
/**
* | output |
* | --- |
* | "Anyone with the invite code can join, so only share it with people you live with." |
*
* @param {Invite_WarningInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_warning = /** @type {((inputs?: Invite_WarningInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_WarningInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.invite_warning(inputs)
	return __en.invite_warning(inputs)
});
/**
* | output |
* | --- |
* | "On iPhone, add the app to your Home Screen first (Share, then Add to Home Screen) and open it from there." |
*
* @param {Ios_Home_ScreenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ios_home_screen = /** @type {((inputs?: Ios_Home_ScreenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ios_Home_ScreenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ios_home_screen(inputs)
	return __en.ios_home_screen(inputs)
});
/**
* | output |
* | --- |
* | "Beanie" |
*
* @param {Item_BeanieInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_beanie = /** @type {((inputs?: Item_BeanieInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_BeanieInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_beanie(inputs)
	return __en.item_beanie(inputs)
});
/**
* | output |
* | --- |
* | "Bikini" |
*
* @param {Item_BikiniInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_bikini = /** @type {((inputs?: Item_BikiniInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_BikiniInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_bikini(inputs)
	return __en.item_bikini(inputs)
});
/**
* | output |
* | --- |
* | "Bow" |
*
* @param {Item_BowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_bow = /** @type {((inputs?: Item_BowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_BowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_bow(inputs)
	return __en.item_bow(inputs)
});
/**
* | output |
* | --- |
* | "Tiny broom" |
*
* @param {Item_BroomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_broom = /** @type {((inputs?: Item_BroomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_BroomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_broom(inputs)
	return __en.item_broom(inputs)
});
/**
* | output |
* | --- |
* | "Flower" |
*
* @param {Item_FlowerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_flower = /** @type {((inputs?: Item_FlowerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_FlowerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_flower(inputs)
	return __en.item_flower(inputs)
});
/**
* | output |
* | --- |
* | "Glasses" |
*
* @param {Item_GlassesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_glasses = /** @type {((inputs?: Item_GlassesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_GlassesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_glasses(inputs)
	return __en.item_glasses(inputs)
});
/**
* | output |
* | --- |
* | "Party hat" |
*
* @param {Item_Party_HatInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_party_hat = /** @type {((inputs?: Item_Party_HatInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Party_HatInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_party_hat(inputs)
	return __en.item_party_hat(inputs)
});
/**
* | output |
* | --- |
* | "{pet} got the {item}! Consider this your permission to buy a real one too." |
*
* @param {Item_PermissionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_permission = /** @type {((inputs: Item_PermissionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_PermissionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_permission(inputs)
	return __en.item_permission(inputs)
});
/**
* | output |
* | --- |
* | "Scarf" |
*
* @param {Item_ScarfInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_scarf = /** @type {((inputs?: Item_ScarfInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_ScarfInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_scarf(inputs)
	return __en.item_scarf(inputs)
});
/**
* | output |
* | --- |
* | "Sunglasses" |
*
* @param {Item_SunglassesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_sunglasses = /** @type {((inputs?: Item_SunglassesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_SunglassesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_sunglasses(inputs)
	return __en.item_sunglasses(inputs)
});
/**
* | output |
* | --- |
* | "Sun hat" |
*
* @param {Item_SunhatInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const item_sunhat = /** @type {((inputs?: Item_SunhatInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_SunhatInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.item_sunhat(inputs)
	return __en.item_sunhat(inputs)
});
/**
* | output |
* | --- |
* | "Join" |
*
* @param {JoinInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const join = /** @type {((inputs?: JoinInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<JoinInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.join(inputs)
	return __en.join(inputs)
});
/**
* | output |
* | --- |
* | "Join a household" |
*
* @param {Join_HouseholdInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const join_household = /** @type {((inputs?: Join_HouseholdInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Join_HouseholdInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.join_household(inputs)
	return __en.join_household(inputs)
});
/**
* | output |
* | --- |
* | "Keep the list as it is" |
*
* @param {Keep_ListInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const keep_list = /** @type {((inputs?: Keep_ListInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keep_ListInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.keep_list(inputs)
	return __en.keep_list(inputs)
});
/**
* | output |
* | --- |
* | "Language" |
*
* @param {LanguageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const language = /** @type {((inputs?: LanguageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LanguageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.language(inputs)
	return __en.language(inputs)
});
/**
* | output |
* | --- |
* | "Same as device ({language})" |
*
* @param {Language_AutoInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const language_auto = /** @type {((inputs: Language_AutoInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_AutoInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.language_auto(inputs)
	return __en.language_auto(inputs)
});
/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Last_7_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_7_days = /** @type {((inputs?: Last_7_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_7_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.last_7_days(inputs)
	return __en.last_7_days(inputs)
});
/**
* | output |
* | --- |
* | "Last active {when}" |
*
* @param {Last_ActiveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_active = /** @type {((inputs: Last_ActiveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_ActiveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.last_active(inputs)
	return __en.last_active(inputs)
});
/**
* | output |
* | --- |
* | "Last done" |
*
* @param {Last_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_done = /** @type {((inputs?: Last_DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.last_done(inputs)
	return __en.last_done(inputs)
});
/**
* | output |
* | --- |
* | "{when} by {name}" |
*
* @param {Last_Done_ByInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_done_by = /** @type {((inputs: Last_Done_ByInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Done_ByInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.last_done_by(inputs)
	return __en.last_done_by(inputs)
});
/**
* | output |
* | --- |
* | "Done {count} days ago" |
*
* @param {Last_Done_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_done_days = /** @type {((inputs: Last_Done_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Done_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.last_done_days(inputs)
	return __en.last_done_days(inputs)
});
/**
* | output |
* | --- |
* | "Done today" |
*
* @param {Last_Done_TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_done_today = /** @type {((inputs?: Last_Done_TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Done_TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.last_done_today(inputs)
	return __en.last_done_today(inputs)
});
/**
* | output |
* | --- |
* | "Done yesterday" |
*
* @param {Last_Done_YesterdayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_done_yesterday = /** @type {((inputs?: Last_Done_YesterdayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Done_YesterdayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.last_done_yesterday(inputs)
	return __en.last_done_yesterday(inputs)
});
/**
* | output |
* | --- |
* | "A few days ago" |
*
* @param {Ld_Few_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_few_days = /** @type {((inputs?: Ld_Few_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_Few_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_few_days(inputs)
	return __en.ld_few_days(inputs)
});
/**
* | output |
* | --- |
* | "A few months ago" |
*
* @param {Ld_Few_MonthsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_few_months = /** @type {((inputs?: Ld_Few_MonthsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_Few_MonthsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_few_months(inputs)
	return __en.ld_few_months(inputs)
});
/**
* | output |
* | --- |
* | "A month ago" |
*
* @param {Ld_MonthInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_month = /** @type {((inputs?: Ld_MonthInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_MonthInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_month(inputs)
	return __en.ld_month(inputs)
});
/**
* | output |
* | --- |
* | "Today" |
*
* @param {Ld_TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_today = /** @type {((inputs?: Ld_TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_today(inputs)
	return __en.ld_today(inputs)
});
/**
* | output |
* | --- |
* | "Two weeks ago" |
*
* @param {Ld_Two_WeeksInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_two_weeks = /** @type {((inputs?: Ld_Two_WeeksInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_Two_WeeksInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_two_weeks(inputs)
	return __en.ld_two_weeks(inputs)
});
/**
* | output |
* | --- |
* | "About a week ago" |
*
* @param {Ld_WeekInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_week = /** @type {((inputs?: Ld_WeekInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_WeekInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_week(inputs)
	return __en.ld_week(inputs)
});
/**
* | output |
* | --- |
* | "Over a year ago" |
*
* @param {Ld_YearInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_year = /** @type {((inputs?: Ld_YearInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_YearInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_year(inputs)
	return __en.ld_year(inputs)
});
/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {Ld_YesterdayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ld_yesterday = /** @type {((inputs?: Ld_YesterdayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ld_YesterdayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.ld_yesterday(inputs)
	return __en.ld_yesterday(inputs)
});
/**
* | output |
* | --- |
* | "Leave household" |
*
* @param {Leave_HouseholdInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const leave_household = /** @type {((inputs?: Leave_HouseholdInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leave_HouseholdInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.leave_household(inputs)
	return __en.leave_household(inputs)
});
/**
* | output |
* | --- |
* | "Level {level}" |
*
* @param {Level_NInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_n = /** @type {((inputs: Level_NInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_NInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_n(inputs)
	return __en.level_n(inputs)
});
/**
* | output |
* | --- |
* | "Dust Novice" |
*
* @param {Level_Title_0Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_0 = /** @type {((inputs?: Level_Title_0Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_0Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_0(inputs)
	return __en.level_title_0(inputs)
});
/**
* | output |
* | --- |
* | "Sponge Squire" |
*
* @param {Level_Title_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_1 = /** @type {((inputs?: Level_Title_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_1(inputs)
	return __en.level_title_1(inputs)
});
/**
* | output |
* | --- |
* | "Legend of the Lint Trap" |
*
* @param {Level_Title_10Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_10 = /** @type {((inputs?: Level_Title_10Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_10Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_10(inputs)
	return __en.level_title_10(inputs)
});
/**
* | output |
* | --- |
* | "Crumb Chaser" |
*
* @param {Level_Title_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_2 = /** @type {((inputs?: Level_Title_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_2(inputs)
	return __en.level_title_2(inputs)
});
/**
* | output |
* | --- |
* | "Mop Knight" |
*
* @param {Level_Title_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_3 = /** @type {((inputs?: Level_Title_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_3(inputs)
	return __en.level_title_3(inputs)
});
/**
* | output |
* | --- |
* | "Broom Baron" |
*
* @param {Level_Title_4Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_4 = /** @type {((inputs?: Level_Title_4Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_4Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_4(inputs)
	return __en.level_title_4(inputs)
});
/**
* | output |
* | --- |
* | "Scrub Sorcerer" |
*
* @param {Level_Title_5Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_5 = /** @type {((inputs?: Level_Title_5Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_5Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_5(inputs)
	return __en.level_title_5(inputs)
});
/**
* | output |
* | --- |
* | "Duchess of Dusting" |
*
* @param {Level_Title_6Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_6 = /** @type {((inputs?: Level_Title_6Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_6Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_6(inputs)
	return __en.level_title_6(inputs)
});
/**
* | output |
* | --- |
* | "Tidy Titan" |
*
* @param {Level_Title_7Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_7 = /** @type {((inputs?: Level_Title_7Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_7Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_7(inputs)
	return __en.level_title_7(inputs)
});
/**
* | output |
* | --- |
* | "Grime Slayer" |
*
* @param {Level_Title_8Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_8 = /** @type {((inputs?: Level_Title_8Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_8Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_8(inputs)
	return __en.level_title_8(inputs)
});
/**
* | output |
* | --- |
* | "Sparkle Sage" |
*
* @param {Level_Title_9Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_title_9 = /** @type {((inputs?: Level_Title_9Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Title_9Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_title_9(inputs)
	return __en.level_title_9(inputs)
});
/**
* | output |
* | --- |
* | "You're now a {title}" |
*
* @param {Level_Up_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const level_up_sub = /** @type {((inputs: Level_Up_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Up_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.level_up_sub(inputs)
	return __en.level_up_sub(inputs)
});
/**
* | output |
* | --- |
* | "Link a device" |
*
* @param {Link_DeviceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const link_device = /** @type {((inputs?: Link_DeviceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_DeviceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.link_device(inputs)
	return __en.link_device(inputs)
});
/**
* | output |
* | --- |
* | "Use your account on another phone or computer" |
*
* @param {Link_Device_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const link_device_sub = /** @type {((inputs?: Link_Device_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Device_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.link_device_sub(inputs)
	return __en.link_device_sub(inputs)
});
/**
* | output |
* | --- |
* | "On a device where you're already signed in, open Settings and tap “Link a device”. Enter the code it shows." |
*
* @param {Link_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const link_intro = /** @type {((inputs?: Link_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.link_intro(inputs)
	return __en.link_intro(inputs)
});
/**
* | output |
* | --- |
* | "On the other device, open CleanReminder and choose “Sign in with a device code”." |
*
* @param {Link_Sheet_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const link_sheet_body = /** @type {((inputs?: Link_Sheet_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Sheet_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.link_sheet_body(inputs)
	return __en.link_sheet_body(inputs)
});
/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Link_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const link_title = /** @type {((inputs?: Link_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.link_title(inputs)
	return __en.link_title(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load your house" |
*
* @param {Load_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const load_error_title = /** @type {((inputs?: Load_Error_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Error_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.load_error_title(inputs)
	return __en.load_error_title(inputs)
});
/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading = /** @type {((inputs?: LoadingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LoadingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.loading(inputs)
	return __en.loading(inputs)
});
/**
* | output |
* | --- |
* | "Mark as done" |
*
* @param {Mark_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const mark_done = /** @type {((inputs?: Mark_DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mark_DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.mark_done(inputs)
	return __en.mark_done(inputs)
});
/**
* | output |
* | --- |
* | "Mark {name} as done" |
*
* @param {Mark_X_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const mark_x_done = /** @type {((inputs: Mark_X_DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mark_X_DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.mark_x_done(inputs)
	return __en.mark_x_done(inputs)
});
/**
* | output |
* | --- |
* | "{minutes} min" |
*
* @param {Minutes_ShortInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const minutes_short = /** @type {((inputs: Minutes_ShortInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minutes_ShortInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.minutes_short(inputs)
	return __en.minutes_short(inputs)
});
/**
* | output |
* | --- |
* | "Grumpy" |
*
* @param {Mood_GrumpyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const mood_grumpy = /** @type {((inputs?: Mood_GrumpyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mood_GrumpyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.mood_grumpy(inputs)
	return __en.mood_grumpy(inputs)
});
/**
* | output |
* | --- |
* | "Happy" |
*
* @param {Mood_HappyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const mood_happy = /** @type {((inputs?: Mood_HappyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mood_HappyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.mood_happy(inputs)
	return __en.mood_happy(inputs)
});
/**
* | output |
* | --- |
* | "Meh" |
*
* @param {Mood_MehInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const mood_meh = /** @type {((inputs?: Mood_MehInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mood_MehInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.mood_meh(inputs)
	return __en.mood_meh(inputs)
});
/**
* | output |
* | --- |
* | "Hiding" |
*
* @param {Mood_SadInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const mood_sad = /** @type {((inputs?: Mood_SadInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mood_SadInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.mood_sad(inputs)
	return __en.mood_sad(inputs)
});
/**
* | output |
* | --- |
* | "Thriving" |
*
* @param {Mood_ThrivingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const mood_thriving = /** @type {((inputs?: Mood_ThrivingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mood_ThrivingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.mood_thriving(inputs)
	return __en.mood_thriving(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const name = /** @type {((inputs?: NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.name(inputs)
	return __en.name(inputs)
});
/**
* | output |
* | --- |
* | "Never mind" |
*
* @param {Never_MindInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const never_mind = /** @type {((inputs?: Never_MindInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Never_MindInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.never_mind(inputs)
	return __en.never_mind(inputs)
});
/**
* | output |
* | --- |
* | "New chore" |
*
* @param {New_ChoreInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const new_chore = /** @type {((inputs?: New_ChoreInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ChoreInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.new_chore(inputs)
	return __en.new_chore(inputs)
});
/**
* | output |
* | --- |
* | "New code" |
*
* @param {New_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const new_code = /** @type {((inputs?: New_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.new_code(inputs)
	return __en.new_code(inputs)
});
/**
* | output |
* | --- |
* | "New household" |
*
* @param {New_HouseholdInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const new_household = /** @type {((inputs?: New_HouseholdInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_HouseholdInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.new_household(inputs)
	return __en.new_household(inputs)
});
/**
* | output |
* | --- |
* | "New room…" |
*
* @param {New_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const new_room = /** @type {((inputs?: New_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.new_room(inputs)
	return __en.new_room(inputs)
});
/**
* | output |
* | --- |
* | "Next badges" |
*
* @param {Next_BadgesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const next_badges = /** @type {((inputs?: Next_BadgesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_BadgesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.next_badges(inputs)
	return __en.next_badges(inputs)
});
/**
* | output |
* | --- |
* | "No chores to pick from. Switch some on in Chores." |
*
* @param {No_Chores_AvailableInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_chores_available = /** @type {((inputs?: No_Chores_AvailableInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Chores_AvailableInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.no_chores_available(inputs)
	return __en.no_chores_available(inputs)
});
/**
* | output |
* | --- |
* | "No streak yet" |
*
* @param {No_StreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_streak = /** @type {((inputs?: No_StreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_StreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.no_streak(inputs)
	return __en.no_streak(inputs)
});
/**
* | output |
* | --- |
* | "Not done yet" |
*
* @param {Not_Done_YetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const not_done_yet = /** @type {((inputs?: Not_Done_YetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Done_YetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.not_done_yet(inputs)
	return __en.not_done_yet(inputs)
});
/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Not_NowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const not_now = /** @type {((inputs?: Not_NowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_NowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.not_now(inputs)
	return __en.not_now(inputs)
});
/**
* | output |
* | --- |
* | "Not sure" |
*
* @param {Not_SureInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const not_sure = /** @type {((inputs?: Not_SureInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_SureInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.not_sure(inputs)
	return __en.not_sure(inputs)
});
/**
* | output |
* | --- |
* | "Notes" |
*
* @param {NotesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notes = /** @type {((inputs?: NotesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NotesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notes(inputs)
	return __en.notes(inputs)
});
/**
* | output |
* | --- |
* | "Shown on the chore card, e.g. which cleaner to use." |
*
* @param {Notes_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notes_hint = /** @type {((inputs?: Notes_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notes_hint(inputs)
	return __en.notes_hint(inputs)
});
/**
* | output |
* | --- |
* | "Use the blue spray, not bleach" |
*
* @param {Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notes_placeholder = /** @type {((inputs?: Notes_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notes_placeholder(inputs)
	return __en.notes_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Nothing picked yet" |
*
* @param {Nothing_PickedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const nothing_picked = /** @type {((inputs?: Nothing_PickedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nothing_PickedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.nothing_picked(inputs)
	return __en.nothing_picked(inputs)
});
/**
* | output |
* | --- |
* | "Daily chore" |
*
* @param {Notif_DailyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_daily = /** @type {((inputs?: Notif_DailyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_DailyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_daily(inputs)
	return __en.notif_daily(inputs)
});
/**
* | output |
* | --- |
* | "At your reminder time" |
*
* @param {Notif_Daily_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_daily_sub = /** @type {((inputs?: Notif_Daily_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Daily_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_daily_sub(inputs)
	return __en.notif_daily_sub(inputs)
});
/**
* | output |
* | --- |
* | "Weekly recap" |
*
* @param {Notif_RecapInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_recap = /** @type {((inputs?: Notif_RecapInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_RecapInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_recap(inputs)
	return __en.notif_recap(inputs)
});
/**
* | output |
* | --- |
* | "Sunday at 19:00: how the week went" |
*
* @param {Notif_Recap_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_recap_sub = /** @type {((inputs?: Notif_Recap_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Recap_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_recap_sub(inputs)
	return __en.notif_recap_sub(inputs)
});
/**
* | output |
* | --- |
* | "Streak reminder" |
*
* @param {Notif_StreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_streak = /** @type {((inputs?: Notif_StreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_StreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_streak(inputs)
	return __en.notif_streak(inputs)
});
/**
* | output |
* | --- |
* | "At 20:30 if today's chore isn't done" |
*
* @param {Notif_Streak_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_streak_sub = /** @type {((inputs?: Notif_Streak_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Streak_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_streak_sub(inputs)
	return __en.notif_streak_sub(inputs)
});
/**
* | output |
* | --- |
* | "Household activity" |
*
* @param {Notif_TeamInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_team = /** @type {((inputs?: Notif_TeamInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_TeamInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_team(inputs)
	return __en.notif_team(inputs)
});
/**
* | output |
* | --- |
* | "When someone finishes a chore" |
*
* @param {Notif_Team_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notif_team_sub = /** @type {((inputs?: Notif_Team_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Team_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notif_team_sub(inputs)
	return __en.notif_team_sub(inputs)
});
/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {NotificationsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const notifications = /** @type {((inputs?: NotificationsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NotificationsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.notifications(inputs)
	return __en.notifications(inputs)
});
/**
* | output |
* | --- |
* | "Off" |
*
* @param {OffInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const off = /** @type {((inputs?: OffInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OffInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.off(inputs)
	return __en.off(inputs)
});
/**
* | output |
* | --- |
* | "Off on this device" |
*
* @param {Off_This_DeviceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const off_this_device = /** @type {((inputs?: Off_This_DeviceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Off_This_DeviceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.off_this_device(inputs)
	return __en.off_this_device(inputs)
});
/**
* | output |
* | --- |
* | "You're offline" |
*
* @param {Offline_BannerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const offline_banner = /** @type {((inputs?: Offline_BannerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_BannerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.offline_banner(inputs)
	return __en.offline_banner(inputs)
});
/**
* | output |
* | --- |
* | "On a break" |
*
* @param {On_A_BreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const on_a_break = /** @type {((inputs?: On_A_BreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<On_A_BreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.on_a_break(inputs)
	return __en.on_a_break(inputs)
});
/**
* | output |
* | --- |
* | "{count} overdue" |
*
* @param {Overdue_CountInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const overdue_count = /** @type {((inputs: Overdue_CountInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overdue_CountInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.overdue_count(inputs)
	return __en.overdue_count(inputs)
});
/**
* | output |
* | --- |
* | "People" |
*
* @param {PeopleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const people = /** @type {((inputs?: PeopleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PeopleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.people(inputs)
	return __en.people(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} person" |
* | * | "{count} people" |
*
* @param {People_CountInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const people_count = /** @type {((inputs: People_CountInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<People_CountInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.people_count(inputs)
	return __en.people_count(inputs)
});
/**
* | output |
* | --- |
* | "Everyone does one chore a day, so this decides how big your chore list starts. You can change it later." |
*
* @param {People_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const people_hint = /** @type {((inputs?: People_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<People_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.people_hint(inputs)
	return __en.people_hint(inputs)
});
/**
* | output |
* | --- |
* | "How many people live here?" |
*
* @param {People_QuestionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const people_question = /** @type {((inputs?: People_QuestionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<People_QuestionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.people_question(inputs)
	return __en.people_question(inputs)
});
/**
* | output |
* | --- |
* | "Sets how many chores are switched on" |
*
* @param {People_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const people_sub = /** @type {((inputs?: People_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<People_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.people_sub(inputs)
	return __en.people_sub(inputs)
});
/**
* | output |
* | --- |
* | "{perDay} a day needed" |
*
* @param {Per_Day_NeededInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const per_day_needed = /** @type {((inputs: Per_Day_NeededInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Per_Day_NeededInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.per_day_needed(inputs)
	return __en.per_day_needed(inputs)
});
/**
* | output |
* | --- |
* | "Dust Speck" |
*
* @param {Pet_Bunny_Stage_0Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_bunny_stage_0 = /** @type {((inputs?: Pet_Bunny_Stage_0Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Bunny_Stage_0Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_bunny_stage_0(inputs)
	return __en.pet_bunny_stage_0(inputs)
});
/**
* | output |
* | --- |
* | "Baby Bunny" |
*
* @param {Pet_Bunny_Stage_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_bunny_stage_1 = /** @type {((inputs?: Pet_Bunny_Stage_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Bunny_Stage_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_bunny_stage_1(inputs)
	return __en.pet_bunny_stage_1(inputs)
});
/**
* | output |
* | --- |
* | "Fluffball" |
*
* @param {Pet_Bunny_Stage_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_bunny_stage_2 = /** @type {((inputs?: Pet_Bunny_Stage_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Bunny_Stage_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_bunny_stage_2(inputs)
	return __en.pet_bunny_stage_2(inputs)
});
/**
* | output |
* | --- |
* | "Grown-up Bunny" |
*
* @param {Pet_Bunny_Stage_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_bunny_stage_3 = /** @type {((inputs?: Pet_Bunny_Stage_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Bunny_Stage_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_bunny_stage_3(inputs)
	return __en.pet_bunny_stage_3(inputs)
});
/**
* | output |
* | --- |
* | "Majestic Floof" |
*
* @param {Pet_Bunny_Stage_4Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_bunny_stage_4 = /** @type {((inputs?: Pet_Bunny_Stage_4Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Bunny_Stage_4Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_bunny_stage_4(inputs)
	return __en.pet_bunny_stage_4(inputs)
});
/**
* | output |
* | --- |
* | "Legendary Floof" |
*
* @param {Pet_Bunny_Stage_5Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_bunny_stage_5 = /** @type {((inputs?: Pet_Bunny_Stage_5Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Bunny_Stage_5Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_bunny_stage_5(inputs)
	return __en.pet_bunny_stage_5(inputs)
});
/**
* | output |
* | --- |
* | "Kitten" |
*
* @param {Pet_Cat_Stage_0Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_cat_stage_0 = /** @type {((inputs?: Pet_Cat_Stage_0Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Cat_Stage_0Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_cat_stage_0(inputs)
	return __en.pet_cat_stage_0(inputs)
});
/**
* | output |
* | --- |
* | "Tiny Tabby" |
*
* @param {Pet_Cat_Stage_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_cat_stage_1 = /** @type {((inputs?: Pet_Cat_Stage_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Cat_Stage_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_cat_stage_1(inputs)
	return __en.pet_cat_stage_1(inputs)
});
/**
* | output |
* | --- |
* | "Curious Cat" |
*
* @param {Pet_Cat_Stage_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_cat_stage_2 = /** @type {((inputs?: Pet_Cat_Stage_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Cat_Stage_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_cat_stage_2(inputs)
	return __en.pet_cat_stage_2(inputs)
});
/**
* | output |
* | --- |
* | "House Cat" |
*
* @param {Pet_Cat_Stage_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_cat_stage_3 = /** @type {((inputs?: Pet_Cat_Stage_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Cat_Stage_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_cat_stage_3(inputs)
	return __en.pet_cat_stage_3(inputs)
});
/**
* | output |
* | --- |
* | "Majestic Mouser" |
*
* @param {Pet_Cat_Stage_4Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_cat_stage_4 = /** @type {((inputs?: Pet_Cat_Stage_4Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Cat_Stage_4Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_cat_stage_4(inputs)
	return __en.pet_cat_stage_4(inputs)
});
/**
* | output |
* | --- |
* | "Legendary Lion" |
*
* @param {Pet_Cat_Stage_5Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_cat_stage_5 = /** @type {((inputs?: Pet_Cat_Stage_5Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Cat_Stage_5Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_cat_stage_5(inputs)
	return __en.pet_cat_stage_5(inputs)
});
/**
* | output |
* | --- |
* | "Egg" |
*
* @param {Pet_Chick_Stage_0Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_chick_stage_0 = /** @type {((inputs?: Pet_Chick_Stage_0Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Chick_Stage_0Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_chick_stage_0(inputs)
	return __en.pet_chick_stage_0(inputs)
});
/**
* | output |
* | --- |
* | "Hatchling" |
*
* @param {Pet_Chick_Stage_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_chick_stage_1 = /** @type {((inputs?: Pet_Chick_Stage_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Chick_Stage_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_chick_stage_1(inputs)
	return __en.pet_chick_stage_1(inputs)
});
/**
* | output |
* | --- |
* | "Fluffy Chick" |
*
* @param {Pet_Chick_Stage_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_chick_stage_2 = /** @type {((inputs?: Pet_Chick_Stage_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Chick_Stage_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_chick_stage_2(inputs)
	return __en.pet_chick_stage_2(inputs)
});
/**
* | output |
* | --- |
* | "Young Bird" |
*
* @param {Pet_Chick_Stage_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_chick_stage_3 = /** @type {((inputs?: Pet_Chick_Stage_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Chick_Stage_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_chick_stage_3(inputs)
	return __en.pet_chick_stage_3(inputs)
});
/**
* | output |
* | --- |
* | "Proud Bird" |
*
* @param {Pet_Chick_Stage_4Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_chick_stage_4 = /** @type {((inputs?: Pet_Chick_Stage_4Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Chick_Stage_4Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_chick_stage_4(inputs)
	return __en.pet_chick_stage_4(inputs)
});
/**
* | output |
* | --- |
* | "Legendary Phoenix" |
*
* @param {Pet_Chick_Stage_5Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_chick_stage_5 = /** @type {((inputs?: Pet_Chick_Stage_5Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Chick_Stage_5Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_chick_stage_5(inputs)
	return __en.pet_chick_stage_5(inputs)
});
/**
* | output |
* | --- |
* | "Tiny Kit" |
*
* @param {Pet_Fox_Stage_0Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_fox_stage_0 = /** @type {((inputs?: Pet_Fox_Stage_0Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Fox_Stage_0Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_fox_stage_0(inputs)
	return __en.pet_fox_stage_0(inputs)
});
/**
* | output |
* | --- |
* | "Fox Kit" |
*
* @param {Pet_Fox_Stage_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_fox_stage_1 = /** @type {((inputs?: Pet_Fox_Stage_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Fox_Stage_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_fox_stage_1(inputs)
	return __en.pet_fox_stage_1(inputs)
});
/**
* | output |
* | --- |
* | "Curious Fox" |
*
* @param {Pet_Fox_Stage_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_fox_stage_2 = /** @type {((inputs?: Pet_Fox_Stage_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Fox_Stage_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_fox_stage_2(inputs)
	return __en.pet_fox_stage_2(inputs)
});
/**
* | output |
* | --- |
* | "Clever Fox" |
*
* @param {Pet_Fox_Stage_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_fox_stage_3 = /** @type {((inputs?: Pet_Fox_Stage_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Fox_Stage_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_fox_stage_3(inputs)
	return __en.pet_fox_stage_3(inputs)
});
/**
* | output |
* | --- |
* | "Majestic Fox" |
*
* @param {Pet_Fox_Stage_4Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_fox_stage_4 = /** @type {((inputs?: Pet_Fox_Stage_4Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Fox_Stage_4Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_fox_stage_4(inputs)
	return __en.pet_fox_stage_4(inputs)
});
/**
* | output |
* | --- |
* | "Legendary Nine-Tails" |
*
* @param {Pet_Fox_Stage_5Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_fox_stage_5 = /** @type {((inputs?: Pet_Fox_Stage_5Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Fox_Stage_5Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_fox_stage_5(inputs)
	return __en.pet_fox_stage_5(inputs)
});
/**
* | output |
* | --- |
* | "{name} is now a {stage}. All thanks to your chores." |
*
* @param {Pet_Grew_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_grew_body = /** @type {((inputs: Pet_Grew_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Grew_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_grew_body(inputs)
	return __en.pet_grew_body(inputs)
});
/**
* | output |
* | --- |
* | "{name} grew!" |
*
* @param {Pet_Grew_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_grew_title = /** @type {((inputs: Pet_Grew_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Grew_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_grew_title(inputs)
	return __en.pet_grew_title(inputs)
});
/**
* | output |
* | --- |
* | "It grows with every chore you do, and its mood shows how the house is doing." |
*
* @param {Pet_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_intro = /** @type {((inputs?: Pet_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_intro(inputs)
	return __en.pet_intro(inputs)
});
/**
* | output |
* | --- |
* | "Dust bunny" |
*
* @param {Pet_Kind_BunnyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_kind_bunny = /** @type {((inputs?: Pet_Kind_BunnyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Kind_BunnyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_kind_bunny(inputs)
	return __en.pet_kind_bunny(inputs)
});
/**
* | output |
* | --- |
* | "Cat" |
*
* @param {Pet_Kind_CatInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_kind_cat = /** @type {((inputs?: Pet_Kind_CatInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Kind_CatInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_kind_cat(inputs)
	return __en.pet_kind_cat(inputs)
});
/**
* | output |
* | --- |
* | "Chick" |
*
* @param {Pet_Kind_ChickInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_kind_chick = /** @type {((inputs?: Pet_Kind_ChickInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Kind_ChickInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_kind_chick(inputs)
	return __en.pet_kind_chick(inputs)
});
/**
* | output |
* | --- |
* | "Fox" |
*
* @param {Pet_Kind_FoxInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_kind_fox = /** @type {((inputs?: Pet_Kind_FoxInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Kind_FoxInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_kind_fox(inputs)
	return __en.pet_kind_fox(inputs)
});
/**
* | output |
* | --- |
* | "Pup" |
*
* @param {Pet_Kind_PupInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_kind_pup = /** @type {((inputs?: Pet_Kind_PupInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Kind_PupInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_kind_pup(inputs)
	return __en.pet_kind_pup(inputs)
});
/**
* | output |
* | --- |
* | "Sprout" |
*
* @param {Pet_Kind_SproutInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_kind_sprout = /** @type {((inputs?: Pet_Kind_SproutInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Kind_SproutInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_kind_sprout(inputs)
	return __en.pet_kind_sprout(inputs)
});
/**
* | output |
* | --- |
* | "Fluffle,Biscuit,Pip,Mochi,Noodle,Pebble,Waffles,Bean,Sprinkle,Nugget,Maple,Dumpling,Toast,Clover" |
*
* @param {Pet_Name_IdeasInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_name_ideas = /** @type {((inputs?: Pet_Name_IdeasInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Name_IdeasInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_name_ideas(inputs)
	return __en.pet_name_ideas(inputs)
});
/**
* | output |
* | --- |
* | "Pet's name" |
*
* @param {Pet_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_name_label = /** @type {((inputs?: Pet_Name_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Name_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_name_label(inputs)
	return __en.pet_name_label(inputs)
});
/**
* | output |
* | --- |
* | "{name}'s" |
*
* @param {Pet_OwnerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_owner = /** @type {((inputs: Pet_OwnerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_OwnerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_owner(inputs)
	return __en.pet_owner(inputs)
});
/**
* | output |
* | --- |
* | "Newborn Pup" |
*
* @param {Pet_Pup_Stage_0Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_pup_stage_0 = /** @type {((inputs?: Pet_Pup_Stage_0Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Pup_Stage_0Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_pup_stage_0(inputs)
	return __en.pet_pup_stage_0(inputs)
});
/**
* | output |
* | --- |
* | "Puppy" |
*
* @param {Pet_Pup_Stage_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_pup_stage_1 = /** @type {((inputs?: Pet_Pup_Stage_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Pup_Stage_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_pup_stage_1(inputs)
	return __en.pet_pup_stage_1(inputs)
});
/**
* | output |
* | --- |
* | "Good Pup" |
*
* @param {Pet_Pup_Stage_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_pup_stage_2 = /** @type {((inputs?: Pet_Pup_Stage_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Pup_Stage_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_pup_stage_2(inputs)
	return __en.pet_pup_stage_2(inputs)
});
/**
* | output |
* | --- |
* | "Best Friend" |
*
* @param {Pet_Pup_Stage_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_pup_stage_3 = /** @type {((inputs?: Pet_Pup_Stage_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Pup_Stage_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_pup_stage_3(inputs)
	return __en.pet_pup_stage_3(inputs)
});
/**
* | output |
* | --- |
* | "Top Dog" |
*
* @param {Pet_Pup_Stage_4Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_pup_stage_4 = /** @type {((inputs?: Pet_Pup_Stage_4Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Pup_Stage_4Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_pup_stage_4(inputs)
	return __en.pet_pup_stage_4(inputs)
});
/**
* | output |
* | --- |
* | "Legendary Hound" |
*
* @param {Pet_Pup_Stage_5Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_pup_stage_5 = /** @type {((inputs?: Pet_Pup_Stage_5Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Pup_Stage_5Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_pup_stage_5(inputs)
	return __en.pet_pup_stage_5(inputs)
});
/**
* | output |
* | --- |
* | "Say hi to {name}" |
*
* @param {Pet_SavedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_saved = /** @type {((inputs: Pet_SavedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_SavedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_saved(inputs)
	return __en.pet_saved(inputs)
});
/**
* | output |
* | --- |
* | "Suggest a name" |
*
* @param {Pet_ShuffleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_shuffle = /** @type {((inputs?: Pet_ShuffleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_ShuffleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_shuffle(inputs)
	return __en.pet_shuffle(inputs)
});
/**
* | output |
* | --- |
* | "Seed" |
*
* @param {Pet_Sprout_Stage_0Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_sprout_stage_0 = /** @type {((inputs?: Pet_Sprout_Stage_0Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Sprout_Stage_0Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_sprout_stage_0(inputs)
	return __en.pet_sprout_stage_0(inputs)
});
/**
* | output |
* | --- |
* | "Sprout" |
*
* @param {Pet_Sprout_Stage_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_sprout_stage_1 = /** @type {((inputs?: Pet_Sprout_Stage_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Sprout_Stage_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_sprout_stage_1(inputs)
	return __en.pet_sprout_stage_1(inputs)
});
/**
* | output |
* | --- |
* | "Seedling" |
*
* @param {Pet_Sprout_Stage_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_sprout_stage_2 = /** @type {((inputs?: Pet_Sprout_Stage_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Sprout_Stage_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_sprout_stage_2(inputs)
	return __en.pet_sprout_stage_2(inputs)
});
/**
* | output |
* | --- |
* | "Leafy Friend" |
*
* @param {Pet_Sprout_Stage_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_sprout_stage_3 = /** @type {((inputs?: Pet_Sprout_Stage_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Sprout_Stage_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_sprout_stage_3(inputs)
	return __en.pet_sprout_stage_3(inputs)
});
/**
* | output |
* | --- |
* | "Blooming Beauty" |
*
* @param {Pet_Sprout_Stage_4Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_sprout_stage_4 = /** @type {((inputs?: Pet_Sprout_Stage_4Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Sprout_Stage_4Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_sprout_stage_4(inputs)
	return __en.pet_sprout_stage_4(inputs)
});
/**
* | output |
* | --- |
* | "Legendary Tree" |
*
* @param {Pet_Sprout_Stage_5Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_sprout_stage_5 = /** @type {((inputs?: Pet_Sprout_Stage_5Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_Sprout_Stage_5Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_sprout_stage_5(inputs)
	return __en.pet_sprout_stage_5(inputs)
});
/**
* | output |
* | --- |
* | "Pick a companion" |
*
* @param {Pet_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pet_title = /** @type {((inputs?: Pet_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pet_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pet_title(inputs)
	return __en.pet_title(inputs)
});
/**
* | output |
* | --- |
* | "Companions" |
*
* @param {Pets_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const pets_title = /** @type {((inputs?: Pets_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pets_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.pets_title(inputs)
	return __en.pets_title(inputs)
});
/**
* | output |
* | --- |
* | "Add photo" |
*
* @param {Photo_AddInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const photo_add = /** @type {((inputs?: Photo_AddInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_AddInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.photo_add(inputs)
	return __en.photo_add(inputs)
});
/**
* | output |
* | --- |
* | "Profile photo" |
*
* @param {Photo_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const photo_label = /** @type {((inputs?: Photo_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.photo_label(inputs)
	return __en.photo_label(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't read that image. Try another photo." |
*
* @param {Photo_Read_ErrorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const photo_read_error = /** @type {((inputs?: Photo_Read_ErrorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_Read_ErrorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.photo_read_error(inputs)
	return __en.photo_read_error(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Photo_RemoveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const photo_remove = /** @type {((inputs?: Photo_RemoveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_RemoveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.photo_remove(inputs)
	return __en.photo_remove(inputs)
});
/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Photo_ReplaceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const photo_replace = /** @type {((inputs?: Photo_ReplaceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_ReplaceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.photo_replace(inputs)
	return __en.photo_replace(inputs)
});
/**
* | output |
* | --- |
* | "+ {count} bonus" |
*
* @param {Plus_BonusInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const plus_bonus = /** @type {((inputs: Plus_BonusInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_BonusInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.plus_bonus(inputs)
	return __en.plus_bonus(inputs)
});
/**
* | output |
* | --- |
* | "+{coins} bonus coins for finishing a big job" |
*
* @param {Project_BonusInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_bonus = /** @type {((inputs: Project_BonusInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_BonusInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_bonus(inputs)
	return __en.project_bonus(inputs)
});
/**
* | output |
* | --- |
* | "Start this job" |
*
* @param {Project_CreateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_create = /** @type {((inputs?: Project_CreateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_CreateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_create(inputs)
	return __en.project_create(inputs)
});
/**
* | output |
* | --- |
* | "Delete big job" |
*
* @param {Project_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_delete = /** @type {((inputs?: Project_DeleteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_DeleteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_delete(inputs)
	return __en.project_delete(inputs)
});
/**
* | output |
* | --- |
* | "Its steps go too. What's already been done stays in the history." |
*
* @param {Project_Delete_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_delete_body = /** @type {((inputs?: Project_Delete_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Delete_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_delete_body(inputs)
	return __en.project_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete {name}?" |
*
* @param {Project_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_delete_title = /** @type {((inputs: Project_Delete_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Delete_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_delete_title(inputs)
	return __en.project_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "All done" |
*
* @param {Project_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_done = /** @type {((inputs?: Project_DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_done(inputs)
	return __en.project_done(inputs)
});
/**
* | output |
* | --- |
* | "{name}: all done!" |
*
* @param {Project_FinishedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_finished = /** @type {((inputs: Project_FinishedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_FinishedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_finished(inputs)
	return __en.project_finished(inputs)
});
/**
* | output |
* | --- |
* | "Split it into bite-size steps. They come up one at a time between your regular chores." |
*
* @param {Project_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_intro = /** @type {((inputs?: Project_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_intro(inputs)
	return __en.project_intro(inputs)
});
/**
* | output |
* | --- |
* | "What's the job?" |
*
* @param {Project_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_name = /** @type {((inputs?: Project_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_name(inputs)
	return __en.project_name(inputs)
});
/**
* | output |
* | --- |
* | "New big job" |
*
* @param {Project_NewInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_new = /** @type {((inputs?: Project_NewInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_NewInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_new(inputs)
	return __en.project_new(inputs)
});
/**
* | output |
* | --- |
* | "Clear out the garage, bit by bit" |
*
* @param {Project_New_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_new_sub = /** @type {((inputs?: Project_New_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_New_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_new_sub(inputs)
	return __en.project_new_sub(inputs)
});
/**
* | output |
* | --- |
* | "How fast" |
*
* @param {Project_PaceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_pace = /** @type {((inputs?: Project_PaceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_PaceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_pace(inputs)
	return __en.project_pace(inputs)
});
/**
* | output |
* | --- |
* | "A step a day" |
*
* @param {Project_Pace_1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_pace_1 = /** @type {((inputs?: Project_Pace_1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Pace_1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_pace_1(inputs)
	return __en.project_pace_1(inputs)
});
/**
* | output |
* | --- |
* | "Every few days" |
*
* @param {Project_Pace_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_pace_3 = /** @type {((inputs?: Project_Pace_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Pace_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_pace_3(inputs)
	return __en.project_pace_3(inputs)
});
/**
* | output |
* | --- |
* | "A step a week" |
*
* @param {Project_Pace_7Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_pace_7 = /** @type {((inputs?: Project_Pace_7Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Pace_7Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_pace_7(inputs)
	return __en.project_pace_7(inputs)
});
/**
* | output |
* | --- |
* | "Clear out the garage" |
*
* @param {Project_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_placeholder = /** @type {((inputs?: Project_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_placeholder(inputs)
	return __en.project_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "{name}: {done} of {total} steps done" |
*
* @param {Project_ProgressInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_progress = /** @type {((inputs: Project_ProgressInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_ProgressInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_progress(inputs)
	return __en.project_progress(inputs)
});
/**
* | output |
* | --- |
* | "{done} of {total} steps done" |
*
* @param {Project_Row_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_row_sub = /** @type {((inputs: Project_Row_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Row_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_row_sub(inputs)
	return __en.project_row_sub(inputs)
});
/**
* | output |
* | --- |
* | "{project} · step {step} of {total}" |
*
* @param {Project_Step_OfInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_step_of = /** @type {((inputs: Project_Step_OfInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Step_OfInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_step_of(inputs)
	return __en.project_step_of(inputs)
});
/**
* | output |
* | --- |
* | "Steps, in order" |
*
* @param {Project_StepsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_steps = /** @type {((inputs?: Project_StepsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_StepsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_steps(inputs)
	return __en.project_steps(inputs)
});
/**
* | output |
* | --- |
* | "About 15 minutes each works best." |
*
* @param {Project_Steps_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_steps_hint = /** @type {((inputs?: Project_Steps_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Steps_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.project_steps_hint(inputs)
	return __en.project_steps_hint(inputs)
});
/**
* | output |
* | --- |
* | "Notifications are blocked in your browser settings." |
*
* @param {Push_BlockedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_blocked = /** @type {((inputs?: Push_BlockedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_BlockedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_blocked(inputs)
	return __en.push_blocked(inputs)
});
/**
* | output |
* | --- |
* | "Blocked. Allow notifications for CleanReminder in your phone's settings." |
*
* @param {Push_Blocked_HereInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_blocked_here = /** @type {((inputs?: Push_Blocked_HereInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Blocked_HereInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_blocked_here(inputs)
	return __en.push_blocked_here(inputs)
});
/**
* | output |
* | --- |
* | "About {minutes} minutes. A good day to start a streak." |
*
* @param {Push_Daily_Body_StartInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_daily_body_start = /** @type {((inputs: Push_Daily_Body_StartInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Daily_Body_StartInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_daily_body_start(inputs)
	return __en.push_daily_body_start(inputs)
});
/**
* | output |
* | --- |
* | "About {minutes} minutes. Keep your {streak}-day streak going." |
*
* @param {Push_Daily_Body_StreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_daily_body_streak = /** @type {((inputs: Push_Daily_Body_StreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Daily_Body_StreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_daily_body_streak(inputs)
	return __en.push_daily_body_streak(inputs)
});
/**
* | output |
* | --- |
* | "Today: {chore}" |
*
* @param {Push_Daily_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_daily_title = /** @type {((inputs: Push_Daily_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Daily_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_daily_title(inputs)
	return __en.push_daily_title(inputs)
});
/**
* | output |
* | --- |
* | "{name} high-fived you" |
*
* @param {Push_High_Five_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_high_five_title = /** @type {((inputs: Push_High_Five_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_High_Five_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_high_five_title(inputs)
	return __en.push_high_five_title(inputs)
});
/**
* | output |
* | --- |
* | "On iPhone, add the app to your Home Screen first." |
*
* @param {Push_Ios_FirstInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_ios_first = /** @type {((inputs?: Push_Ios_FirstInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Ios_FirstInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_ios_first(inputs)
	return __en.push_ios_first(inputs)
});
/**
* | output |
* | --- |
* | "Reminders are on" |
*
* @param {Push_OnInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_on = /** @type {((inputs?: Push_OnInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_OnInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_on(inputs)
	return __en.push_on(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "On for {count} device" |
* | * | "On for {count} devices" |
*
* @param {Push_On_DevicesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_on_devices = /** @type {((inputs: Push_On_DevicesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_On_DevicesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_on_devices(inputs)
	return __en.push_on_devices(inputs)
});
/**
* | output |
* | --- |
* | "You did {mine} chores and the household did {total}. Open the app for the full recap." |
*
* @param {Push_Recap_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_recap_body = /** @type {((inputs: Push_Recap_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Recap_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_recap_body(inputs)
	return __en.push_recap_body(inputs)
});
/**
* | output |
* | --- |
* | "You did {mine} chores this week. Open the app for the full recap." |
*
* @param {Push_Recap_Body_SoloInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_recap_body_solo = /** @type {((inputs: Push_Recap_Body_SoloInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Recap_Body_SoloInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_recap_body_solo(inputs)
	return __en.push_recap_body_solo(inputs)
});
/**
* | output |
* | --- |
* | "Your week in the house" |
*
* @param {Push_Recap_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_recap_title = /** @type {((inputs?: Push_Recap_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Recap_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_recap_title(inputs)
	return __en.push_recap_title(inputs)
});
/**
* | output |
* | --- |
* | "Ten minutes and it stays alive." |
*
* @param {Push_Streak_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_streak_body = /** @type {((inputs?: Push_Streak_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Streak_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_streak_body(inputs)
	return __en.push_streak_body(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "You have {count} streak freeze left, but ten minutes keeps it safe." |
* | * | "You have {count} streak freezes left, but ten minutes keeps it safe." |
*
* @param {Push_Streak_Body_FreezesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_streak_body_freezes = /** @type {((inputs: Push_Streak_Body_FreezesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Streak_Body_FreezesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_streak_body_freezes(inputs)
	return __en.push_streak_body_freezes(inputs)
});
/**
* | output |
* | --- |
* | "Your {streak}-day streak ends tonight" |
*
* @param {Push_Streak_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_streak_title = /** @type {((inputs: Push_Streak_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Streak_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_streak_title(inputs)
	return __en.push_streak_title(inputs)
});
/**
* | output |
* | --- |
* | "{chore}, +{xp} XP" |
*
* @param {Push_Team_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_team_body = /** @type {((inputs: Push_Team_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Team_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_team_body(inputs)
	return __en.push_team_body(inputs)
});
/**
* | output |
* | --- |
* | "{chore}, +{xp} XP, and reached level {level}" |
*
* @param {Push_Team_Body_LevelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_team_body_level = /** @type {((inputs: Push_Team_Body_LevelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Team_Body_LevelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_team_body_level(inputs)
	return __en.push_team_body_level(inputs)
});
/**
* | output |
* | --- |
* | "{name} finished a chore" |
*
* @param {Push_Team_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_team_title = /** @type {((inputs: Push_Team_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Team_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_team_title(inputs)
	return __en.push_team_title(inputs)
});
/**
* | output |
* | --- |
* | "This is what your daily reminder will look like." |
*
* @param {Push_Test_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_test_body = /** @type {((inputs?: Push_Test_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Test_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_test_body(inputs)
	return __en.push_test_body(inputs)
});
/**
* | output |
* | --- |
* | "Notifications are on" |
*
* @param {Push_Test_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_test_title = /** @type {((inputs?: Push_Test_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Test_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_test_title(inputs)
	return __en.push_test_title(inputs)
});
/**
* | output |
* | --- |
* | "Clean dishes, ready to put away." |
*
* @param {Push_Timer_Dishwasher_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_dishwasher_body = /** @type {((inputs?: Push_Timer_Dishwasher_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Dishwasher_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_dishwasher_body(inputs)
	return __en.push_timer_dishwasher_body(inputs)
});
/**
* | output |
* | --- |
* | "The dishwasher is done" |
*
* @param {Push_Timer_Dishwasher_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_dishwasher_title = /** @type {((inputs?: Push_Timer_Dishwasher_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Dishwasher_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_dishwasher_title(inputs)
	return __en.push_timer_dishwasher_title(inputs)
});
/**
* | output |
* | --- |
* | "Fold it while it's warm: fewer creases." |
*
* @param {Push_Timer_Dryer_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_dryer_body = /** @type {((inputs?: Push_Timer_Dryer_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Dryer_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_dryer_body(inputs)
	return __en.push_timer_dryer_body(inputs)
});
/**
* | output |
* | --- |
* | "The dryer is done" |
*
* @param {Push_Timer_Dryer_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_dryer_title = /** @type {((inputs?: Push_Timer_Dryer_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Dryer_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_dryer_title(inputs)
	return __en.push_timer_dryer_title(inputs)
});
/**
* | output |
* | --- |
* | "Time's up." |
*
* @param {Push_Timer_Other_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_other_body = /** @type {((inputs?: Push_Timer_Other_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Other_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_other_body(inputs)
	return __en.push_timer_other_body(inputs)
});
/**
* | output |
* | --- |
* | "Your timer is done" |
*
* @param {Push_Timer_Other_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_other_title = /** @type {((inputs?: Push_Timer_Other_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Other_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_other_title(inputs)
	return __en.push_timer_other_title(inputs)
});
/**
* | output |
* | --- |
* | "Take a look before it burns." |
*
* @param {Push_Timer_Oven_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_oven_body = /** @type {((inputs?: Push_Timer_Oven_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Oven_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_oven_body(inputs)
	return __en.push_timer_oven_body(inputs)
});
/**
* | output |
* | --- |
* | "The oven timer is done" |
*
* @param {Push_Timer_Oven_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_oven_title = /** @type {((inputs?: Push_Timer_Oven_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Oven_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_oven_title(inputs)
	return __en.push_timer_oven_title(inputs)
});
/**
* | output |
* | --- |
* | "Time to hang up the laundry before it gets musty." |
*
* @param {Push_Timer_Washer_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_washer_body = /** @type {((inputs?: Push_Timer_Washer_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Washer_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_washer_body(inputs)
	return __en.push_timer_washer_body(inputs)
});
/**
* | output |
* | --- |
* | "The washing machine is done" |
*
* @param {Push_Timer_Washer_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_timer_washer_title = /** @type {((inputs?: Push_Timer_Washer_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Timer_Washer_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_timer_washer_title(inputs)
	return __en.push_timer_washer_title(inputs)
});
/**
* | output |
* | --- |
* | "{name} took the trade" |
*
* @param {Push_Trade_AcceptedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_trade_accepted = /** @type {((inputs: Push_Trade_AcceptedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Trade_AcceptedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_trade_accepted(inputs)
	return __en.push_trade_accepted(inputs)
});
/**
* | output |
* | --- |
* | "Your chore today: {chore}" |
*
* @param {Push_Trade_Accepted_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_trade_accepted_body = /** @type {((inputs: Push_Trade_Accepted_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Trade_Accepted_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_trade_accepted_body(inputs)
	return __en.push_trade_accepted_body(inputs)
});
/**
* | output |
* | --- |
* | "Their {give} for your {get}" |
*
* @param {Push_Trade_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_trade_body = /** @type {((inputs: Push_Trade_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Trade_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_trade_body(inputs)
	return __en.push_trade_body(inputs)
});
/**
* | output |
* | --- |
* | "{name} kept their chore" |
*
* @param {Push_Trade_DeclinedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_trade_declined = /** @type {((inputs: Push_Trade_DeclinedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Trade_DeclinedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_trade_declined(inputs)
	return __en.push_trade_declined(inputs)
});
/**
* | output |
* | --- |
* | "You still have: {chore}" |
*
* @param {Push_Trade_Declined_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_trade_declined_body = /** @type {((inputs: Push_Trade_Declined_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Trade_Declined_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_trade_declined_body(inputs)
	return __en.push_trade_declined_body(inputs)
});
/**
* | output |
* | --- |
* | "{name} wants to trade chores" |
*
* @param {Push_Trade_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_trade_title = /** @type {((inputs: Push_Trade_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Trade_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_trade_title(inputs)
	return __en.push_trade_title(inputs)
});
/**
* | output |
* | --- |
* | "This browser doesn't support notifications." |
*
* @param {Push_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_unsupported = /** @type {((inputs?: Push_UnsupportedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_UnsupportedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_unsupported(inputs)
	return __en.push_unsupported(inputs)
});
/**
* | output |
* | --- |
* | "This browser can't show notifications" |
*
* @param {Push_Unsupported_HereInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_unsupported_here = /** @type {((inputs?: Push_Unsupported_HereInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Unsupported_HereInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.push_unsupported_here(inputs)
	return __en.push_unsupported_here(inputs)
});
/**
* | output |
* | --- |
* | "How many bathrooms?" |
*
* @param {Q_BathroomsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const q_bathrooms = /** @type {((inputs?: Q_BathroomsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Q_BathroomsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.q_bathrooms(inputs)
	return __en.q_bathrooms(inputs)
});
/**
* | output |
* | --- |
* | "What kind of home?" |
*
* @param {Q_Home_TypeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const q_home_type = /** @type {((inputs?: Q_Home_TypeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Q_Home_TypeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.q_home_type(inputs)
	return __en.q_home_type(inputs)
});
/**
* | output |
* | --- |
* | "Any pets?" |
*
* @param {Q_PetsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const q_pets = /** @type {((inputs?: Q_PetsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Q_PetsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.q_pets(inputs)
	return __en.q_pets(inputs)
});
/**
* | output |
* | --- |
* | "Which of these do you have?" |
*
* @param {Q_SpacesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const q_spaces = /** @type {((inputs?: Q_SpacesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Q_SpacesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.q_spaces(inputs)
	return __en.q_spaces(inputs)
});
/**
* | output |
* | --- |
* | "What's in your home?" |
*
* @param {Q_ThingsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const q_things = /** @type {((inputs?: Q_ThingsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Q_ThingsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.q_things(inputs)
	return __en.q_things(inputs)
});
/**
* | output |
* | --- |
* | "Where's the toilet?" |
*
* @param {Q_ToiletInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const q_toilet = /** @type {((inputs?: Q_ToiletInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Q_ToiletInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.q_toilet(inputs)
	return __en.q_toilet(inputs)
});
/**
* | output |
* | --- |
* | "Common" |
*
* @param {Rarity_CommonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rarity_common = /** @type {((inputs?: Rarity_CommonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rarity_CommonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rarity_common(inputs)
	return __en.rarity_common(inputs)
});
/**
* | output |
* | --- |
* | "Epic" |
*
* @param {Rarity_EpicInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rarity_epic = /** @type {((inputs?: Rarity_EpicInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rarity_EpicInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rarity_epic(inputs)
	return __en.rarity_epic(inputs)
});
/**
* | output |
* | --- |
* | "Legendary" |
*
* @param {Rarity_LegendaryInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rarity_legendary = /** @type {((inputs?: Rarity_LegendaryInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rarity_LegendaryInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rarity_legendary(inputs)
	return __en.rarity_legendary(inputs)
});
/**
* | output |
* | --- |
* | "Rare" |
*
* @param {Rarity_RareInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rarity_rare = /** @type {((inputs?: Rarity_RareInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rarity_RareInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rarity_rare(inputs)
	return __en.rarity_rare(inputs)
});
/**
* | output |
* | --- |
* | "Rebalance" |
*
* @param {RebalanceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rebalance = /** @type {((inputs?: RebalanceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RebalanceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rebalance(inputs)
	return __en.rebalance(inputs)
});
/**
* | output |
* | --- |
* | "Rebalance the chore list?" |
*
* @param {Rebalance_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rebalance_confirm_title = /** @type {((inputs?: Rebalance_Confirm_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rebalance_Confirm_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rebalance_confirm_title(inputs)
	return __en.rebalance_confirm_title(inputs)
});
/**
* | output |
* | --- |
* | "Switch starter chores on or off to fit {people}. Your own chores stay as they are." |
*
* @param {Rebalance_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rebalance_sub = /** @type {((inputs: Rebalance_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rebalance_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rebalance_sub(inputs)
	return __en.rebalance_sub(inputs)
});
/**
* | output |
* | --- |
* | "Rebalance chore list" |
*
* @param {Rebalance_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rebalance_title = /** @type {((inputs?: Rebalance_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rebalance_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rebalance_title(inputs)
	return __en.rebalance_title(inputs)
});
/**
* | output |
* | --- |
* | "Household" |
*
* @param {Recap_Household_ChoresInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const recap_household_chores = /** @type {((inputs?: Recap_Household_ChoresInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_Household_ChoresInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.recap_household_chores(inputs)
	return __en.recap_household_chores(inputs)
});
/**
* | output |
* | --- |
* | "{total} chores this week, {mine} by you" |
*
* @param {Recap_RowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const recap_row = /** @type {((inputs: Recap_RowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_RowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.recap_row(inputs)
	return __en.recap_row(inputs)
});
/**
* | output |
* | --- |
* | "{mine} chores this week" |
*
* @param {Recap_Row_SoloInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const recap_row_solo = /** @type {((inputs: Recap_Row_SoloInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_Row_SoloInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.recap_row_solo(inputs)
	return __en.recap_row_solo(inputs)
});
/**
* | output |
* | --- |
* | "The last 7 days, compared with the week before." |
*
* @param {Recap_SubtitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const recap_subtitle = /** @type {((inputs?: Recap_SubtitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_SubtitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.recap_subtitle(inputs)
	return __en.recap_subtitle(inputs)
});
/**
* | output |
* | --- |
* | "Your week" |
*
* @param {Recap_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const recap_title = /** @type {((inputs?: Recap_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.recap_title(inputs)
	return __en.recap_title(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{name} did the most: {count} chore" |
* | * | "{name} did the most: {count} chores" |
*
* @param {Recap_TopInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const recap_top = /** @type {((inputs: Recap_TopInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_TopInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.recap_top(inputs)
	return __en.recap_top(inputs)
});
/**
* | output |
* | --- |
* | "Your chores" |
*
* @param {Recap_Your_ChoresInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const recap_your_chores = /** @type {((inputs?: Recap_Your_ChoresInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_Your_ChoresInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.recap_your_chores(inputs)
	return __en.recap_your_chores(inputs)
});
/**
* | output |
* | --- |
* | "Reload" |
*
* @param {ReloadInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const reload = /** @type {((inputs?: ReloadInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReloadInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.reload(inputs)
	return __en.reload(inputs)
});
/**
* | output |
* | --- |
* | "Remind me at" |
*
* @param {Remind_Me_AtInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const remind_me_at = /** @type {((inputs?: Remind_Me_AtInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remind_Me_AtInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.remind_me_at(inputs)
	return __en.remind_me_at(inputs)
});
/**
* | output |
* | --- |
* | "Get a notification with your chore each day." |
*
* @param {Reminder_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const reminder_body = /** @type {((inputs?: Reminder_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reminder_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.reminder_body(inputs)
	return __en.reminder_body(inputs)
});
/**
* | output |
* | --- |
* | "Get a daily reminder" |
*
* @param {Reminder_CtaInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const reminder_cta = /** @type {((inputs?: Reminder_CtaInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reminder_CtaInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.reminder_cta(inputs)
	return __en.reminder_cta(inputs)
});
/**
* | output |
* | --- |
* | "A notification with your chore each day" |
*
* @param {Reminder_Cta_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const reminder_cta_sub = /** @type {((inputs?: Reminder_Cta_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reminder_Cta_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.reminder_cta_sub(inputs)
	return __en.reminder_cta_sub(inputs)
});
/**
* | output |
* | --- |
* | "Reminder set for {time}" |
*
* @param {Reminder_SetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const reminder_set = /** @type {((inputs: Reminder_SetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reminder_SetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.reminder_set(inputs)
	return __en.reminder_set(inputs)
});
/**
* | output |
* | --- |
* | "Daily reminder" |
*
* @param {Reminder_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const reminder_title = /** @type {((inputs?: Reminder_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reminder_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.reminder_title(inputs)
	return __en.reminder_title(inputs)
});
/**
* | output |
* | --- |
* | "Reminders" |
*
* @param {RemindersInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const reminders = /** @type {((inputs?: RemindersInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RemindersInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.reminders(inputs)
	return __en.reminders(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {RemoveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const remove = /** @type {((inputs?: RemoveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RemoveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.remove(inputs)
	return __en.remove(inputs)
});
/**
* | output |
* | --- |
* | "Repeats" |
*
* @param {RepeatsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const repeats = /** @type {((inputs?: RepeatsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RepeatsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.repeats(inputs)
	return __en.repeats(inputs)
});
/**
* | output |
* | --- |
* | "rescue bonus" |
*
* @param {Rescue_BonusInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rescue_bonus = /** @type {((inputs?: Rescue_BonusInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rescue_BonusInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rescue_bonus(inputs)
	return __en.rescue_bonus(inputs)
});
/**
* | output |
* | --- |
* | "No chore today, and your streak stays safe. Enjoy it." |
*
* @param {Rest_Day_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rest_day_body = /** @type {((inputs?: Rest_Day_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rest_Day_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rest_day_body(inputs)
	return __en.rest_day_body(inputs)
});
/**
* | output |
* | --- |
* | "Rest day" |
*
* @param {Rest_Day_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rest_day_title = /** @type {((inputs?: Rest_Day_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rest_Day_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rest_day_title(inputs)
	return __en.rest_day_title(inputs)
});
/**
* | output |
* | --- |
* | "Review chores first" |
*
* @param {Review_ChoresInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const review_chores = /** @type {((inputs?: Review_ChoresInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Review_ChoresInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.review_chores(inputs)
	return __en.review_chores(inputs)
});
/**
* | output |
* | --- |
* | "Change it" |
*
* @param {Rhythm_ChangeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_change = /** @type {((inputs?: Rhythm_ChangeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_ChangeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_change(inputs)
	return __en.rhythm_change(inputs)
});
/**
* | output |
* | --- |
* | "{chore} is now {freq}" |
*
* @param {Rhythm_ChangedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_changed = /** @type {((inputs: Rhythm_ChangedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_ChangedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_changed(inputs)
	return __en.rhythm_changed(inputs)
});
/**
* | output |
* | --- |
* | "{chore} usually gets done before it's due." |
*
* @param {Rhythm_EarlyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_early = /** @type {((inputs: Rhythm_EarlyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_EarlyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_early(inputs)
	return __en.rhythm_early(inputs)
});
/**
* | output |
* | --- |
* | "Keep as is" |
*
* @param {Rhythm_KeepInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_keep = /** @type {((inputs?: Rhythm_KeepInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_KeepInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_keep(inputs)
	return __en.rhythm_keep(inputs)
});
/**
* | output |
* | --- |
* | "Rhythm tip" |
*
* @param {Rhythm_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_label = /** @type {((inputs?: Rhythm_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_label(inputs)
	return __en.rhythm_label(inputs)
});
/**
* | output |
* | --- |
* | "{chore} usually gets done a good while after it's due." |
*
* @param {Rhythm_LateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_late = /** @type {((inputs: Rhythm_LateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_LateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_late(inputs)
	return __en.rhythm_late(inputs)
});
/**
* | output |
* | --- |
* | "{new} instead of {old}?" |
*
* @param {Rhythm_QuestionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_question = /** @type {((inputs: Rhythm_QuestionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_QuestionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_question(inputs)
	return __en.rhythm_question(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{chore} got skipped once lately." |
* | * | "{chore} got skipped {count} times lately." |
*
* @param {Rhythm_SkippedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const rhythm_skipped = /** @type {((inputs: Rhythm_SkippedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rhythm_SkippedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.rhythm_skipped(inputs)
	return __en.rhythm_skipped(inputs)
});
/**
* | output |
* | --- |
* | "Room" |
*
* @param {RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room = /** @type {((inputs?: RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room(inputs)
	return __en.room(inputs)
});
/**
* | output |
* | --- |
* | "Bathroom" |
*
* @param {Room_BathroomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_bathroom = /** @type {((inputs?: Room_BathroomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_BathroomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_bathroom(inputs)
	return __en.room_bathroom(inputs)
});
/**
* | output |
* | --- |
* | "Bathroom 2" |
*
* @param {Room_Bathroom_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_bathroom_2 = /** @type {((inputs?: Room_Bathroom_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Bathroom_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_bathroom_2(inputs)
	return __en.room_bathroom_2(inputs)
});
/**
* | output |
* | --- |
* | "Bathroom 3" |
*
* @param {Room_Bathroom_3Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_bathroom_3 = /** @type {((inputs?: Room_Bathroom_3Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Bathroom_3Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_bathroom_3(inputs)
	return __en.room_bathroom_3(inputs)
});
/**
* | output |
* | --- |
* | "Bedroom" |
*
* @param {Room_BedroomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_bedroom = /** @type {((inputs?: Room_BedroomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_BedroomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_bedroom(inputs)
	return __en.room_bedroom(inputs)
});
/**
* | output |
* | --- |
* | "{price} coins. It goes straight into {pet}'s room." |
*
* @param {Room_Buy_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_buy_body = /** @type {((inputs: Room_Buy_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Buy_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_buy_body(inputs)
	return __en.room_buy_body(inputs)
});
/**
* | output |
* | --- |
* | "Dining area" |
*
* @param {Room_Dining_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_dining_room = /** @type {((inputs?: Room_Dining_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Dining_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_dining_room(inputs)
	return __en.room_dining_room(inputs)
});
/**
* | output |
* | --- |
* | "Garage" |
*
* @param {Room_GarageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_garage = /** @type {((inputs?: Room_GarageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_GarageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_garage(inputs)
	return __en.room_garage(inputs)
});
/**
* | output |
* | --- |
* | "Guest room" |
*
* @param {Room_Guest_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_guest_room = /** @type {((inputs?: Room_Guest_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Guest_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_guest_room(inputs)
	return __en.room_guest_room(inputs)
});
/**
* | output |
* | --- |
* | "Hallway and stairs" |
*
* @param {Room_HallwayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_hallway = /** @type {((inputs?: Room_HallwayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_HallwayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_hallway(inputs)
	return __en.room_hallway(inputs)
});
/**
* | output |
* | --- |
* | "Save up for furniture. One thing per spot; tap something you own to put it away or back." |
*
* @param {Room_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_intro = /** @type {((inputs?: Room_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_intro(inputs)
	return __en.room_intro(inputs)
});
/**
* | output |
* | --- |
* | "Kitchen" |
*
* @param {Room_KitchenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_kitchen = /** @type {((inputs?: Room_KitchenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_KitchenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_kitchen(inputs)
	return __en.room_kitchen(inputs)
});
/**
* | output |
* | --- |
* | "Laundry room" |
*
* @param {Room_Laundry_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_laundry_room = /** @type {((inputs?: Room_Laundry_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Laundry_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_laundry_room(inputs)
	return __en.room_laundry_room(inputs)
});
/**
* | output |
* | --- |
* | "Living room" |
*
* @param {Room_Living_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_living_room = /** @type {((inputs?: Room_Living_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Living_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_living_room(inputs)
	return __en.room_living_room(inputs)
});
/**
* | output |
* | --- |
* | "Room name" |
*
* @param {Room_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_name = /** @type {((inputs?: Room_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_name(inputs)
	return __en.room_name(inputs)
});
/**
* | output |
* | --- |
* | "Home office" |
*
* @param {Room_OfficeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_office = /** @type {((inputs?: Room_OfficeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_OfficeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_office(inputs)
	return __en.room_office(inputs)
});
/**
* | output |
* | --- |
* | "Outdoors" |
*
* @param {Room_OutdoorsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_outdoors = /** @type {((inputs?: Room_OutdoorsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_OutdoorsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_outdoors(inputs)
	return __en.room_outdoors(inputs)
});
/**
* | output |
* | --- |
* | "Pets" |
*
* @param {Room_PetsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_pets = /** @type {((inputs?: Room_PetsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_PetsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_pets(inputs)
	return __en.room_pets(inputs)
});
/**
* | output |
* | --- |
* | "In the room" |
*
* @param {Room_PlacedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_placed = /** @type {((inputs?: Room_PlacedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_PlacedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_placed(inputs)
	return __en.room_placed(inputs)
});
/**
* | output |
* | --- |
* | "Office" |
*
* @param {Room_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_placeholder = /** @type {((inputs?: Room_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_placeholder(inputs)
	return __en.room_placeholder(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "1 piece of furniture" |
* | * | "{count} pieces of furniture" |
*
* @param {Room_Row_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_row_sub = /** @type {((inputs: Room_Row_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Row_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_row_sub(inputs)
	return __en.room_row_sub(inputs)
});
/**
* | output |
* | --- |
* | "Tap to place" |
*
* @param {Room_Tap_To_PlaceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_tap_to_place = /** @type {((inputs?: Room_Tap_To_PlaceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Tap_To_PlaceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_tap_to_place(inputs)
	return __en.room_tap_to_place(inputs)
});
/**
* | output |
* | --- |
* | "{pet}'s room" |
*
* @param {Room_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_title = /** @type {((inputs: Room_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_title(inputs)
	return __en.room_title(inputs)
});
/**
* | output |
* | --- |
* | "Toilet" |
*
* @param {Room_ToiletInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_toilet = /** @type {((inputs?: Room_ToiletInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_ToiletInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_toilet(inputs)
	return __en.room_toilet(inputs)
});
/**
* | output |
* | --- |
* | "Whole house" |
*
* @param {Room_Whole_HouseInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const room_whole_house = /** @type {((inputs?: Room_Whole_HouseInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Whole_HouseInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.room_whole_house(inputs)
	return __en.room_whole_house(inputs)
});
/**
* | output |
* | --- |
* | "Save" |
*
* @param {SaveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const save = /** @type {((inputs?: SaveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SaveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.save(inputs)
	return __en.save(inputs)
});
/**
* | output |
* | --- |
* | "Save" |
*
* @param {Save_DateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const save_date = /** @type {((inputs?: Save_DateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_DateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.save_date(inputs)
	return __en.save_date(inputs)
});
/**
* | output |
* | --- |
* | "Saved" |
*
* @param {SavedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const saved = /** @type {((inputs?: SavedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SavedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.saved(inputs)
	return __en.saved(inputs)
});
/**
* | output |
* | --- |
* | "Tap a day to switch between 1 chore, 2 chores and a rest day. Rest days never break your streak." |
*
* @param {Schedule_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const schedule_hint = /** @type {((inputs?: Schedule_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Schedule_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.schedule_hint(inputs)
	return __en.schedule_hint(inputs)
});
/**
* | output |
* | --- |
* | "Week saved" |
*
* @param {Schedule_SavedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const schedule_saved = /** @type {((inputs?: Schedule_SavedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Schedule_SavedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.schedule_saved(inputs)
	return __en.schedule_saved(inputs)
});
/**
* | output |
* | --- |
* | "Seasonal" |
*
* @param {SeasonalInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const seasonal = /** @type {((inputs?: SeasonalInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SeasonalInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.seasonal(inputs)
	return __en.seasonal(inputs)
});
/**
* | output |
* | --- |
* | "Only suggest in certain months" |
*
* @param {Seasonal_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const seasonal_sub = /** @type {((inputs?: Seasonal_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seasonal_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.seasonal_sub(inputs)
	return __en.seasonal_sub(inputs)
});
/**
* | output |
* | --- |
* | "Sections" |
*
* @param {SectionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sections = /** @type {((inputs?: SectionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SectionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sections(inputs)
	return __en.sections(inputs)
});
/**
* | output |
* | --- |
* | "See all {count}" |
*
* @param {See_AllInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const see_all = /** @type {((inputs: See_AllInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<See_AllInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.see_all(inputs)
	return __en.see_all(inputs)
});
/**
* | output |
* | --- |
* | "Pick all that apply" |
*
* @param {Select_All_That_ApplyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const select_all_that_apply = /** @type {((inputs?: Select_All_That_ApplyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_All_That_ApplyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.select_all_that_apply(inputs)
	return __en.select_all_that_apply(inputs)
});
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {SettingsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const settings = /** @type {((inputs?: SettingsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SettingsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.settings(inputs)
	return __en.settings(inputs)
});
/**
* | output |
* | --- |
* | "For a household of {people}, {active} chores are switched on. That's about {perDay} a day to share. {more} more are there to switch on whenever you like." |
*
* @param {Setup_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const setup_body = /** @type {((inputs: Setup_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.setup_body(inputs)
	return __en.setup_body(inputs)
});
/**
* | output |
* | --- |
* | "For just you, {active} chores are switched on. That's about {perDay} a day. {more} more are there to switch on whenever you like." |
*
* @param {Setup_Body_SoloInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const setup_body_solo = /** @type {((inputs: Setup_Body_SoloInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Body_SoloInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.setup_body_solo(inputs)
	return __en.setup_body_solo(inputs)
});
/**
* | output |
* | --- |
* | "Your chore list is ready" |
*
* @param {Setup_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const setup_title = /** @type {((inputs?: Setup_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.setup_title(inputs)
	return __en.setup_title(inputs)
});
/**
* | output |
* | --- |
* | "Share invite" |
*
* @param {Share_InviteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const share_invite = /** @type {((inputs?: Share_InviteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_InviteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.share_invite(inputs)
	return __en.share_invite(inputs)
});
/**
* | output |
* | --- |
* | "Every chore earns coins. Dress {pet} up, one thing per spot." |
*
* @param {Shop_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const shop_intro = /** @type {((inputs: Shop_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.shop_intro(inputs)
	return __en.shop_intro(inputs)
});
/**
* | output |
* | --- |
* | "Outfits" |
*
* @param {Shop_OutfitsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const shop_outfits = /** @type {((inputs?: Shop_OutfitsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_OutfitsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.shop_outfits(inputs)
	return __en.shop_outfits(inputs)
});
/**
* | output |
* | --- |
* | "Tap to wear" |
*
* @param {Shop_OwnedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const shop_owned = /** @type {((inputs?: Shop_OwnedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_OwnedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.shop_owned(inputs)
	return __en.shop_owned(inputs)
});
/**
* | output |
* | --- |
* | "Outfits and streak freezes" |
*
* @param {Shop_Row_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const shop_row_sub = /** @type {((inputs?: Shop_Row_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Row_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.shop_row_sub(inputs)
	return __en.shop_row_sub(inputs)
});
/**
* | output |
* | --- |
* | "Companion shop" |
*
* @param {Shop_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const shop_title = /** @type {((inputs?: Shop_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.shop_title(inputs)
	return __en.shop_title(inputs)
});
/**
* | output |
* | --- |
* | "{count} to go" |
*
* @param {Shop_To_GoInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const shop_to_go = /** @type {((inputs: Shop_To_GoInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_To_GoInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.shop_to_go(inputs)
	return __en.shop_to_go(inputs)
});
/**
* | output |
* | --- |
* | "Wearing" |
*
* @param {Shop_WearingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const shop_wearing = /** @type {((inputs?: Shop_WearingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_WearingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.shop_wearing(inputs)
	return __en.shop_wearing(inputs)
});
/**
* | output |
* | --- |
* | "Show earned" |
*
* @param {Show_EarnedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const show_earned = /** @type {((inputs?: Show_EarnedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_EarnedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.show_earned(inputs)
	return __en.show_earned(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Show {count} switched-off chore" |
* | * | "Show {count} switched-off chores" |
*
* @param {Show_InactiveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const show_inactive = /** @type {((inputs: Show_InactiveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_InactiveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.show_inactive(inputs)
	return __en.show_inactive(inputs)
});
/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Show_MoreInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const show_more = /** @type {((inputs?: Show_MoreInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_MoreInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.show_more(inputs)
	return __en.show_more(inputs)
});
/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Sign_InInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_in = /** @type {((inputs?: Sign_InInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_InInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sign_in(inputs)
	return __en.sign_in(inputs)
});
/**
* | output |
* | --- |
* | "Sign out this device" |
*
* @param {Sign_Out_DeviceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_out_device = /** @type {((inputs?: Sign_Out_DeviceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_Out_DeviceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sign_out_device(inputs)
	return __en.sign_out_device(inputs)
});
/**
* | output |
* | --- |
* | "Sign out on this device" |
*
* @param {Sign_Out_HereInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_out_here = /** @type {((inputs?: Sign_Out_HereInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_Out_HereInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sign_out_here(inputs)
	return __en.sign_out_here(inputs)
});
/**
* | output |
* | --- |
* | "Signed in" |
*
* @param {Signed_InInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const signed_in = /** @type {((inputs?: Signed_InInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signed_InInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.signed_in(inputs)
	return __en.signed_in(inputs)
});
/**
* | output |
* | --- |
* | "{name} has earned it and may now go and get:" |
*
* @param {Slip_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const slip_body = /** @type {((inputs: Slip_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slip_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.slip_body(inputs)
	return __en.slip_body(inputs)
});
/**
* | output |
* | --- |
* | "Enjoy!" |
*
* @param {Slip_OkInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const slip_ok = /** @type {((inputs?: Slip_OkInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slip_OkInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.slip_ok(inputs)
	return __en.slip_ok(inputs)
});
/**
* | output |
* | --- |
* | "Signed, {pet}" |
*
* @param {Slip_SignedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const slip_signed = /** @type {((inputs: Slip_SignedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slip_SignedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.slip_signed(inputs)
	return __en.slip_signed(inputs)
});
/**
* | output |
* | --- |
* | "Permission slip" |
*
* @param {Slip_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const slip_title = /** @type {((inputs?: Slip_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slip_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.slip_title(inputs)
	return __en.slip_title(inputs)
});
/**
* | output |
* | --- |
* | "Someone" |
*
* @param {SomeoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const someone = /** @type {((inputs?: SomeoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SomeoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.someone(inputs)
	return __en.someone(inputs)
});
/**
* | output |
* | --- |
* | "Start break" |
*
* @param {Start_BreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const start_break = /** @type {((inputs?: Start_BreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_BreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.start_break(inputs)
	return __en.start_break(inputs)
});
/**
* | output |
* | --- |
* | "Chores" |
*
* @param {Stat_ChoresInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const stat_chores = /** @type {((inputs?: Stat_ChoresInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stat_ChoresInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.stat_chores(inputs)
	return __en.stat_chores(inputs)
});
/**
* | output |
* | --- |
* | "Freezes" |
*
* @param {Stat_FreezesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const stat_freezes = /** @type {((inputs?: Stat_FreezesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stat_FreezesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.stat_freezes(inputs)
	return __en.stat_freezes(inputs)
});
/**
* | output |
* | --- |
* | "Streak · best {best}" |
*
* @param {Stat_StreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const stat_streak = /** @type {((inputs: Stat_StreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stat_StreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.stat_streak(inputs)
	return __en.stat_streak(inputs)
});
/**
* | output |
* | --- |
* | "Add a step" |
*
* @param {Step_AddInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_add = /** @type {((inputs?: Step_AddInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_AddInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_add(inputs)
	return __en.step_add(inputs)
});
/**
* | output |
* | --- |
* | "Delete {name}" |
*
* @param {Step_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_delete = /** @type {((inputs: Step_DeleteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_DeleteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_delete(inputs)
	return __en.step_delete(inputs)
});
/**
* | output |
* | --- |
* | "Done by {name}" |
*
* @param {Step_Done_ByInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_done_by = /** @type {((inputs: Step_Done_ByInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_Done_ByInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_done_by(inputs)
	return __en.step_done_by(inputs)
});
/**
* | output |
* | --- |
* | "Step {n}" |
*
* @param {Step_NInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_n = /** @type {((inputs: Step_NInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_NInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_n(inputs)
	return __en.step_n(inputs)
});
/**
* | output |
* | --- |
* | "Step {step} of {total}" |
*
* @param {Step_OfInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_of = /** @type {((inputs: Step_OfInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_OfInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_of(inputs)
	return __en.step_of(inputs)
});
/**
* | output |
* | --- |
* | "Sort the shelves" |
*
* @param {Step_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_placeholder = /** @type {((inputs?: Step_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_placeholder(inputs)
	return __en.step_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Remove step {n}" |
*
* @param {Step_RemoveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_remove = /** @type {((inputs: Step_RemoveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_RemoveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_remove(inputs)
	return __en.step_remove(inputs)
});
/**
* | output |
* | --- |
* | "Up next · {minutes} min" |
*
* @param {Step_Up_NextInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const step_up_next = /** @type {((inputs: Step_Up_NextInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_Up_NextInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.step_up_next(inputs)
	return __en.step_up_next(inputs)
});
/**
* | output |
* | --- |
* | "Early Bird" |
*
* @param {Sticker_BirdInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_bird = /** @type {((inputs?: Sticker_BirdInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_BirdInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_bird(inputs)
	return __en.sticker_bird(inputs)
});
/**
* | output |
* | --- |
* | "Trusty Bucket" |
*
* @param {Sticker_BucketInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_bucket = /** @type {((inputs?: Sticker_BucketInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_BucketInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_bucket(inputs)
	return __en.sticker_bucket(inputs)
});
/**
* | output |
* | --- |
* | "Supervisor Cat" |
*
* @param {Sticker_CatInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_cat = /** @type {((inputs?: Sticker_CatInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_CatInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_cat(inputs)
	return __en.sticker_cat(inputs)
});
/**
* | output |
* | --- |
* | "Crown of Tidiness" |
*
* @param {Sticker_CrownInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_crown = /** @type {((inputs?: Sticker_CrownInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_CrownInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_crown(inputs)
	return __en.sticker_crown(inputs)
});
/**
* | output |
* | --- |
* | "Tidy Tank" |
*
* @param {Sticker_FishInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_fish = /** @type {((inputs?: Sticker_FishInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_FishInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_fish(inputs)
	return __en.sticker_fish(inputs)
});
/**
* | output |
* | --- |
* | "Fresh Flowers" |
*
* @param {Sticker_FlowerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_flower = /** @type {((inputs?: Sticker_FlowerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_FlowerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_flower(inputs)
	return __en.sticker_flower(inputs)
});
/**
* | output |
* | --- |
* | "{rarity} sticker" |
*
* @param {Sticker_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_label = /** @type {((inputs: Sticker_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_label(inputs)
	return __en.sticker_label(inputs)
});
/**
* | output |
* | --- |
* | "Cozy Lamp" |
*
* @param {Sticker_LampInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_lamp = /** @type {((inputs?: Sticker_LampInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_LampInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_lamp(inputs)
	return __en.sticker_lamp(inputs)
});
/**
* | output |
* | --- |
* | "Lemon Fresh" |
*
* @param {Sticker_LemonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_lemon = /** @type {((inputs?: Sticker_LemonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_LemonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_lemon(inputs)
	return __en.sticker_lemon(inputs)
});
/**
* | output |
* | --- |
* | "Happy Plant" |
*
* @param {Sticker_PlantInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_plant = /** @type {((inputs?: Sticker_PlantInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_PlantInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_plant(inputs)
	return __en.sticker_plant(inputs)
});
/**
* | output |
* | --- |
* | "Streak-Free Rainbow" |
*
* @param {Sticker_RainbowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_rainbow = /** @type {((inputs?: Sticker_RainbowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_RainbowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_rainbow(inputs)
	return __en.sticker_rainbow(inputs)
});
/**
* | output |
* | --- |
* | "Robo Vacuum" |
*
* @param {Sticker_RobotInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_robot = /** @type {((inputs?: Sticker_RobotInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_RobotInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_robot(inputs)
	return __en.sticker_robot(inputs)
});
/**
* | output |
* | --- |
* | "Fresh Laundry" |
*
* @param {Sticker_ShirtInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_shirt = /** @type {((inputs?: Sticker_ShirtInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_ShirtInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_shirt(inputs)
	return __en.sticker_shirt(inputs)
});
/**
* | output |
* | --- |
* | "Hand Soap" |
*
* @param {Sticker_SoapInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_soap = /** @type {((inputs?: Sticker_SoapInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_SoapInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_soap(inputs)
	return __en.sticker_soap(inputs)
});
/**
* | output |
* | --- |
* | "Sparkles" |
*
* @param {Sticker_SparklesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_sparkles = /** @type {((inputs?: Sticker_SparklesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_SparklesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_sparkles(inputs)
	return __en.sticker_sparkles(inputs)
});
/**
* | output |
* | --- |
* | "Bubble Bath" |
*
* @param {Sticker_SpongeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_sponge = /** @type {((inputs?: Sticker_SpongeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_SpongeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_sponge(inputs)
	return __en.sticker_sponge(inputs)
});
/**
* | output |
* | --- |
* | "Spray Bottle" |
*
* @param {Sticker_SprayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_spray = /** @type {((inputs?: Sticker_SprayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_SprayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_spray(inputs)
	return __en.sticker_spray(inputs)
});
/**
* | output |
* | --- |
* | "Well-Earned Tea" |
*
* @param {Sticker_TeaInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_tea = /** @type {((inputs?: Sticker_TeaInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_TeaInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_tea(inputs)
	return __en.sticker_tea(inputs)
});
/**
* | output |
* | --- |
* | "Magic Wand" |
*
* @param {Sticker_WandInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_wand = /** @type {((inputs?: Sticker_WandInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_WandInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_wand(inputs)
	return __en.sticker_wand(inputs)
});
/**
* | output |
* | --- |
* | "Spin Cycle" |
*
* @param {Sticker_WasherInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sticker_washer = /** @type {((inputs?: Sticker_WasherInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sticker_WasherInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.sticker_washer(inputs)
	return __en.sticker_washer(inputs)
});
/**
* | output |
* | --- |
* | "Stickers" |
*
* @param {StickersInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const stickers = /** @type {((inputs?: StickersInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<StickersInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.stickers(inputs)
	return __en.stickers(inputs)
});
/**
* | output |
* | --- |
* | "{owned} of {total} found" |
*
* @param {Stickers_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const stickers_found = /** @type {((inputs: Stickers_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stickers_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.stickers_found(inputs)
	return __en.stickers_found(inputs)
});
/**
* | output |
* | --- |
* | "Finished chores sometimes drop a sticker, and bonus chores drop them more often." |
*
* @param {Stickers_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const stickers_hint = /** @type {((inputs?: Stickers_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stickers_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.stickers_hint(inputs)
	return __en.stickers_hint(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count}-day streak" |
* | * | "{count}-day streak" |
*
* @param {Streak_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const streak_days = /** @type {((inputs: Streak_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Streak_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.streak_days(inputs)
	return __en.streak_days(inputs)
});
/**
* | output |
* | --- |
* | "Supplies" |
*
* @param {SuppliesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies = /** @type {((inputs?: SuppliesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SuppliesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies(inputs)
	return __en.supplies(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Supplies_AddInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_add = /** @type {((inputs?: Supplies_AddInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_AddInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_add(inputs)
	return __en.supplies_add(inputs)
});
/**
* | output |
* | --- |
* | "Added by {name}" |
*
* @param {Supplies_Added_ByInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_added_by = /** @type {((inputs: Supplies_Added_ByInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_Added_ByInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_added_by(inputs)
	return __en.supplies_added_by(inputs)
});
/**
* | output |
* | --- |
* | "Bought" |
*
* @param {Supplies_BoughtInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_bought = /** @type {((inputs?: Supplies_BoughtInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_BoughtInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_bought(inputs)
	return __en.supplies_bought(inputs)
});
/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Supplies_ClearInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_clear = /** @type {((inputs?: Supplies_ClearInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_ClearInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_clear(inputs)
	return __en.supplies_clear(inputs)
});
/**
* | output |
* | --- |
* | "Nothing on the list. Add what's running low." |
*
* @param {Supplies_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_empty = /** @type {((inputs?: Supplies_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_empty(inputs)
	return __en.supplies_empty(inputs)
});
/**
* | output |
* | --- |
* | "Dish soap, bin bags…" |
*
* @param {Supplies_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_placeholder = /** @type {((inputs?: Supplies_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_placeholder(inputs)
	return __en.supplies_placeholder(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} thing to buy" |
* | * | "{count} things to buy" |
*
* @param {Supplies_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_sub = /** @type {((inputs: Supplies_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_sub(inputs)
	return __en.supplies_sub(inputs)
});
/**
* | output |
* | --- |
* | "Running low on something?" |
*
* @param {Supplies_Sub_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const supplies_sub_empty = /** @type {((inputs?: Supplies_Sub_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplies_Sub_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.supplies_sub_empty(inputs)
	return __en.supplies_sub_empty(inputs)
});
/**
* | output |
* | --- |
* | "Swap" |
*
* @param {SwapInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const swap = /** @type {((inputs?: SwapInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SwapInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.swap(inputs)
	return __en.swap(inputs)
});
/**
* | output |
* | --- |
* | "Swapped" |
*
* @param {SwappedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const swapped = /** @type {((inputs?: SwappedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SwappedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.swapped(inputs)
	return __en.swapped(inputs)
});
/**
* | output |
* | --- |
* | "These are never picked. Switch one on and it joins the rotation." |
*
* @param {Switched_Off_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const switched_off_body = /** @type {((inputs?: Switched_Off_BodyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switched_Off_BodyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.switched_off_body(inputs)
	return __en.switched_off_body(inputs)
});
/**
* | output |
* | --- |
* | "Everything is switched on." |
*
* @param {Switched_Off_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const switched_off_empty = /** @type {((inputs?: Switched_Off_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switched_Off_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.switched_off_empty(inputs)
	return __en.switched_off_empty(inputs)
});
/**
* | output |
* | --- |
* | "Switched-off chores" |
*
* @param {Switched_Off_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const switched_off_title = /** @type {((inputs?: Switched_Off_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Switched_Off_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.switched_off_title(inputs)
	return __en.switched_off_title(inputs)
});
/**
* | output |
* | --- |
* | "Chores" |
*
* @param {Tab_ChoresInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_chores = /** @type {((inputs?: Tab_ChoresInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_ChoresInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.tab_chores(inputs)
	return __en.tab_chores(inputs)
});
/**
* | output |
* | --- |
* | "House" |
*
* @param {Tab_HouseInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_house = /** @type {((inputs?: Tab_HouseInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_HouseInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.tab_house(inputs)
	return __en.tab_house(inputs)
});
/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Tab_ProfileInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_profile = /** @type {((inputs?: Tab_ProfileInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_ProfileInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.tab_profile(inputs)
	return __en.tab_profile(inputs)
});
/**
* | output |
* | --- |
* | "Today" |
*
* @param {Tab_TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_today = /** @type {((inputs?: Tab_TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.tab_today(inputs)
	return __en.tab_today(inputs)
});
/**
* | output |
* | --- |
* | "Take on a bonus chore" |
*
* @param {Take_BonusInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const take_bonus = /** @type {((inputs?: Take_BonusInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Take_BonusInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.take_bonus(inputs)
	return __en.take_bonus(inputs)
});
/**
* | output |
* | --- |
* | "Take a break" |
*
* @param {Take_BreakInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const take_break = /** @type {((inputs?: Take_BreakInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Take_BreakInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.take_break(inputs)
	return __en.take_break(inputs)
});
/**
* | output |
* | --- |
* | "Vacation or sick: no chores, streak kept" |
*
* @param {Take_Break_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const take_break_sub = /** @type {((inputs?: Take_Break_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Take_Break_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.take_break_sub(inputs)
	return __en.take_break_sub(inputs)
});
/**
* | output |
* | --- |
* | "Takes about" |
*
* @param {Takes_AboutInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const takes_about = /** @type {((inputs?: Takes_AboutInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Takes_AboutInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.takes_about(inputs)
	return __en.takes_about(inputs)
});
/**
* | output |
* | --- |
* | "Tap to continue" |
*
* @param {Tap_To_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const tap_to_continue = /** @type {((inputs?: Tap_To_ContinueInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tap_To_ContinueInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.tap_to_continue(inputs)
	return __en.tap_to_continue(inputs)
});
/**
* | output |
* | --- |
* | "Test" |
*
* @param {TestInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const test = /** @type {((inputs?: TestInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TestInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.test(inputs)
	return __en.test(inputs)
});
/**
* | output |
* | --- |
* | "No devices reached. Try turning notifications on again." |
*
* @param {Test_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_none = /** @type {((inputs?: Test_NoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_NoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.test_none(inputs)
	return __en.test_none(inputs)
});
/**
* | output |
* | --- |
* | "Test notification sent" |
*
* @param {Test_SentInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_sent = /** @type {((inputs?: Test_SentInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_SentInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.test_sent(inputs)
	return __en.test_sent(inputs)
});
/**
* | output |
* | --- |
* | "(this device)" |
*
* @param {This_DeviceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const this_device = /** @type {((inputs?: This_DeviceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_DeviceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.this_device(inputs)
	return __en.this_device(inputs)
});
/**
* | output |
* | --- |
* | "Timer" |
*
* @param {TimerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer = /** @type {((inputs?: TimerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TimerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer(inputs)
	return __en.timer(inputs)
});
/**
* | output |
* | --- |
* | "Emptied" |
*
* @param {Timer_ClearInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_clear = /** @type {((inputs?: Timer_ClearInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_ClearInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_clear(inputs)
	return __en.timer_clear(inputs)
});
/**
* | output |
* | --- |
* | "Done at {time}" |
*
* @param {Timer_Done_AtInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_done_at = /** @type {((inputs: Timer_Done_AtInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Done_AtInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_done_at(inputs)
	return __en.timer_done_at(inputs)
});
/**
* | output |
* | --- |
* | "Finished at {time}" |
*
* @param {Timer_Finished_AtInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_finished_at = /** @type {((inputs: Timer_Finished_AtInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Finished_AtInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_finished_at(inputs)
	return __en.timer_finished_at(inputs)
});
/**
* | output |
* | --- |
* | "{minutes} minutes. Go." |
*
* @param {Timer_GoInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_go = /** @type {((inputs: Timer_GoInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_GoInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_go(inputs)
	return __en.timer_go(inputs)
});
/**
* | output |
* | --- |
* | "How long" |
*
* @param {Timer_How_LongInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_how_long = /** @type {((inputs?: Timer_How_LongInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_How_LongInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_how_long(inputs)
	return __en.timer_how_long(inputs)
});
/**
* | output |
* | --- |
* | "Everyone at home sees it, and you get a notification when it's done." |
*
* @param {Timer_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_intro = /** @type {((inputs?: Timer_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_intro(inputs)
	return __en.timer_intro(inputs)
});
/**
* | output |
* | --- |
* | "Everyone at home sees it. Turn on notifications in Settings to get a ping when it's done." |
*
* @param {Timer_Intro_No_PushInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_intro_no_push = /** @type {((inputs?: Timer_Intro_No_PushInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Intro_No_PushInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_intro_no_push(inputs)
	return __en.timer_intro_no_push(inputs)
});
/**
* | output |
* | --- |
* | "Dishwasher" |
*
* @param {Timer_Kind_DishwasherInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_kind_dishwasher = /** @type {((inputs?: Timer_Kind_DishwasherInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Kind_DishwasherInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_kind_dishwasher(inputs)
	return __en.timer_kind_dishwasher(inputs)
});
/**
* | output |
* | --- |
* | "Dryer" |
*
* @param {Timer_Kind_DryerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_kind_dryer = /** @type {((inputs?: Timer_Kind_DryerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Kind_DryerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_kind_dryer(inputs)
	return __en.timer_kind_dryer(inputs)
});
/**
* | output |
* | --- |
* | "Something else" |
*
* @param {Timer_Kind_OtherInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_kind_other = /** @type {((inputs?: Timer_Kind_OtherInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Kind_OtherInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_kind_other(inputs)
	return __en.timer_kind_other(inputs)
});
/**
* | output |
* | --- |
* | "Oven" |
*
* @param {Timer_Kind_OvenInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_kind_oven = /** @type {((inputs?: Timer_Kind_OvenInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Kind_OvenInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_kind_oven(inputs)
	return __en.timer_kind_oven(inputs)
});
/**
* | output |
* | --- |
* | "Washing machine" |
*
* @param {Timer_Kind_WasherInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_kind_washer = /** @type {((inputs?: Timer_Kind_WasherInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Kind_WasherInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_kind_washer(inputs)
	return __en.timer_kind_washer(inputs)
});
/**
* | output |
* | --- |
* | "Machine" |
*
* @param {Timer_MachineInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_machine = /** @type {((inputs?: Timer_MachineInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_MachineInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_machine(inputs)
	return __en.timer_machine(inputs)
});
/**
* | output |
* | --- |
* | "Minutes" |
*
* @param {Timer_MinutesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_minutes = /** @type {((inputs?: Timer_MinutesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_MinutesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_minutes(inputs)
	return __en.timer_minutes(inputs)
});
/**
* | output |
* | --- |
* | "Laundry timer" |
*
* @param {Timer_NewInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_new = /** @type {((inputs?: Timer_NewInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_NewInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_new(inputs)
	return __en.timer_new(inputs)
});
/**
* | output |
* | --- |
* | "Washing machine, dryer, dishwasher: a ping when it's done" |
*
* @param {Timer_New_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_new_sub = /** @type {((inputs?: Timer_New_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_New_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_new_sub(inputs)
	return __en.timer_new_sub(inputs)
});
/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Timer_PauseInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_pause = /** @type {((inputs?: Timer_PauseInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_PauseInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_pause(inputs)
	return __en.timer_pause(inputs)
});
/**
* | output |
* | --- |
* | "Restart" |
*
* @param {Timer_RestartInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_restart = /** @type {((inputs?: Timer_RestartInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_RestartInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_restart(inputs)
	return __en.timer_restart(inputs)
});
/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Timer_ResumeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_resume = /** @type {((inputs?: Timer_ResumeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_ResumeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_resume(inputs)
	return __en.timer_resume(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Timer_StartInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_start = /** @type {((inputs?: Timer_StartInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_StartInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_start(inputs)
	return __en.timer_start(inputs)
});
/**
* | output |
* | --- |
* | "Start · done at {time}" |
*
* @param {Timer_Start_AtInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_start_at = /** @type {((inputs: Timer_Start_AtInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Start_AtInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_start_at(inputs)
	return __en.timer_start_at(inputs)
});
/**
* | output |
* | --- |
* | "Stop timer" |
*
* @param {Timer_StopInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timer_stop = /** @type {((inputs?: Timer_StopInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_StopInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timer_stop(inputs)
	return __en.timer_stop(inputs)
});
/**
* | output |
* | --- |
* | "Machines" |
*
* @param {Timers_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const timers_title = /** @type {((inputs?: Timers_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timers_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.timers_title(inputs)
	return __en.timers_title(inputs)
});
/**
* | output |
* | --- |
* | "Time's up." |
*
* @param {Times_UpInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const times_up = /** @type {((inputs?: Times_UpInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Times_UpInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.times_up(inputs)
	return __en.times_up(inputs)
});
/**
* | output |
* | --- |
* | "Today" |
*
* @param {TodayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const today = /** @type {((inputs?: TodayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TodayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.today(inputs)
	return __en.today(inputs)
});
/**
* | output |
* | --- |
* | "In the bathroom" |
*
* @param {Toilet_In_BathroomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toilet_in_bathroom = /** @type {((inputs?: Toilet_In_BathroomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toilet_In_BathroomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.toilet_in_bathroom(inputs)
	return __en.toilet_in_bathroom(inputs)
});
/**
* | output |
* | --- |
* | "Separate room" |
*
* @param {Toilet_SeparateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toilet_separate = /** @type {((inputs?: Toilet_SeparateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toilet_SeparateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.toilet_separate(inputs)
	return __en.toilet_separate(inputs)
});
/**
* | output |
* | --- |
* | "Trade" |
*
* @param {TradeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade = /** @type {((inputs?: TradeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TradeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade(inputs)
	return __en.trade(inputs)
});
/**
* | output |
* | --- |
* | "Trade" |
*
* @param {Trade_AcceptInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_accept = /** @type {((inputs?: Trade_AcceptInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_AcceptInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_accept(inputs)
	return __en.trade_accept(inputs)
});
/**
* | output |
* | --- |
* | "Ask {name}" |
*
* @param {Trade_AskInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_ask = /** @type {((inputs: Trade_AskInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_AskInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_ask(inputs)
	return __en.trade_ask(inputs)
});
/**
* | output |
* | --- |
* | "No thanks" |
*
* @param {Trade_DeclineInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_decline = /** @type {((inputs?: Trade_DeclineInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_DeclineInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_decline(inputs)
	return __en.trade_decline(inputs)
});
/**
* | output |
* | --- |
* | "Traded! Enjoy your new chore." |
*
* @param {Trade_DoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_done = /** @type {((inputs?: Trade_DoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_DoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_done(inputs)
	return __en.trade_done(inputs)
});
/**
* | output |
* | --- |
* | "{name} wants to trade" |
*
* @param {Trade_IncomingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_incoming = /** @type {((inputs: Trade_IncomingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_IncomingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_incoming(inputs)
	return __en.trade_incoming(inputs)
});
/**
* | output |
* | --- |
* | "Asked {name}" |
*
* @param {Trade_SentInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_sent = /** @type {((inputs: Trade_SentInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_SentInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_sent(inputs)
	return __en.trade_sent(inputs)
});
/**
* | output |
* | --- |
* | "Theirs" |
*
* @param {Trade_TheirsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_theirs = /** @type {((inputs?: Trade_TheirsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_TheirsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_theirs(inputs)
	return __en.trade_theirs(inputs)
});
/**
* | output |
* | --- |
* | "Trade with {name}?" |
*
* @param {Trade_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_title = /** @type {((inputs: Trade_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_title(inputs)
	return __en.trade_title(inputs)
});
/**
* | output |
* | --- |
* | "Waiting for {name}" |
*
* @param {Trade_WaitingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_waiting = /** @type {((inputs: Trade_WaitingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_WaitingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_waiting(inputs)
	return __en.trade_waiting(inputs)
});
/**
* | output |
* | --- |
* | "You get" |
*
* @param {Trade_You_GetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_you_get = /** @type {((inputs?: Trade_You_GetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_You_GetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_you_get(inputs)
	return __en.trade_you_get(inputs)
});
/**
* | output |
* | --- |
* | "You give" |
*
* @param {Trade_You_GiveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_you_give = /** @type {((inputs?: Trade_You_GiveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_You_GiveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_you_give(inputs)
	return __en.trade_you_give(inputs)
});
/**
* | output |
* | --- |
* | "Yours" |
*
* @param {Trade_YoursInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const trade_yours = /** @type {((inputs?: Trade_YoursInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trade_YoursInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.trade_yours(inputs)
	return __en.trade_yours(inputs)
});
/**
* | output |
* | --- |
* | "Add treat" |
*
* @param {Treat_AddInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treat_add = /** @type {((inputs?: Treat_AddInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treat_AddInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treat_add(inputs)
	return __en.treat_add(inputs)
});
/**
* | output |
* | --- |
* | "Treat" |
*
* @param {Treat_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treat_name_label = /** @type {((inputs?: Treat_Name_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treat_Name_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treat_name_label(inputs)
	return __en.treat_name_label(inputs)
});
/**
* | output |
* | --- |
* | "New plant" |
*
* @param {Treat_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treat_name_placeholder = /** @type {((inputs?: Treat_Name_PlaceholderInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treat_Name_PlaceholderInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treat_name_placeholder(inputs)
	return __en.treat_name_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Coins" |
*
* @param {Treat_Price_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treat_price_label = /** @type {((inputs?: Treat_Price_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treat_Price_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treat_price_label(inputs)
	return __en.treat_price_label(inputs)
});
/**
* | output |
* | --- |
* | "Treat yourself" |
*
* @param {Treat_RedeemInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treat_redeem = /** @type {((inputs?: Treat_RedeemInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treat_RedeemInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treat_redeem(inputs)
	return __en.treat_redeem(inputs)
});
/**
* | output |
* | --- |
* | "Earned" |
*
* @param {Treats_EarnedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treats_earned = /** @type {((inputs?: Treats_EarnedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treats_EarnedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treats_earned(inputs)
	return __en.treats_earned(inputs)
});
/**
* | output |
* | --- |
* | "No treats yet. What would you like to earn?" |
*
* @param {Treats_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treats_empty = /** @type {((inputs?: Treats_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treats_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treats_empty(inputs)
	return __en.treats_empty(inputs)
});
/**
* | output |
* | --- |
* | "Things you'd like to earn, paid for with coins. When you can afford one, you get a permission slip." |
*
* @param {Treats_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treats_intro = /** @type {((inputs?: Treats_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treats_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treats_intro(inputs)
	return __en.treats_intro(inputs)
});
/**
* | output |
* | --- |
* | "Real-life rewards for your coins" |
*
* @param {Treats_Row_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treats_row_sub = /** @type {((inputs?: Treats_Row_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treats_Row_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treats_row_sub(inputs)
	return __en.treats_row_sub(inputs)
});
/**
* | output |
* | --- |
* | "Treats" |
*
* @param {Treats_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const treats_title = /** @type {((inputs?: Treats_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Treats_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.treats_title(inputs)
	return __en.treats_title(inputs)
});
/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Try_AgainInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const try_again = /** @type {((inputs?: Try_AgainInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_AgainInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.try_again(inputs)
	return __en.try_again(inputs)
});
/**
* | output |
* | --- |
* | "Turn on" |
*
* @param {Turn_OnInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const turn_on = /** @type {((inputs?: Turn_OnInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Turn_OnInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.turn_on(inputs)
	return __en.turn_on(inputs)
});
/**
* | output |
* | --- |
* | "Turn on reminders" |
*
* @param {Turn_On_RemindersInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const turn_on_reminders = /** @type {((inputs?: Turn_On_RemindersInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Turn_On_RemindersInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.turn_on_reminders(inputs)
	return __en.turn_on_reminders(inputs)
});
/**
* | output |
* | --- |
* | "Reminders use {tz}." |
*
* @param {Tz_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const tz_note = /** @type {((inputs: Tz_NoteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tz_NoteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.tz_note(inputs)
	return __en.tz_note(inputs)
});
/**
* | output |
* | --- |
* | "Switch to {tz}" |
*
* @param {Tz_SwitchInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const tz_switch = /** @type {((inputs: Tz_SwitchInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tz_SwitchInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.tz_switch(inputs)
	return __en.tz_switch(inputs)
});
/**
* | output |
* | --- |
* | "Balanced" |
*
* @param {Verdict_BalancedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const verdict_balanced = /** @type {((inputs?: Verdict_BalancedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verdict_BalancedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.verdict_balanced(inputs)
	return __en.verdict_balanced(inputs)
});
/**
* | output |
* | --- |
* | "Tight" |
*
* @param {Verdict_TightInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const verdict_tight = /** @type {((inputs?: Verdict_TightInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verdict_TightInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.verdict_tight(inputs)
	return __en.verdict_tight(inputs)
});
/**
* | output |
* | --- |
* | "Too much" |
*
* @param {Verdict_Too_MuchInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const verdict_too_much = /** @type {((inputs?: Verdict_Too_MuchInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verdict_Too_MuchInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.verdict_too_much(inputs)
	return __en.verdict_too_much(inputs)
});
/**
* | output |
* | --- |
* | "Weather" |
*
* @param {WeatherInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather = /** @type {((inputs?: WeatherInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WeatherInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather(inputs)
	return __en.weather(inputs)
});
/**
* | output |
* | --- |
* | "Windows, the balcony and the garden are saved for a dry day. The forecast comes from Open-Meteo, and only your town is used." |
*
* @param {Weather_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather_intro = /** @type {((inputs?: Weather_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weather_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather_intro(inputs)
	return __en.weather_intro(inputs)
});
/**
* | output |
* | --- |
* | "No places found." |
*
* @param {Weather_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather_none = /** @type {((inputs?: Weather_NoneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weather_NoneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather_none(inputs)
	return __en.weather_none(inputs)
});
/**
* | output |
* | --- |
* | "Don't use the weather" |
*
* @param {Weather_RemoveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather_remove = /** @type {((inputs?: Weather_RemoveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weather_RemoveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather_remove(inputs)
	return __en.weather_remove(inputs)
});
/**
* | output |
* | --- |
* | "Town or city" |
*
* @param {Weather_SearchInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather_search = /** @type {((inputs?: Weather_SearchInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weather_SearchInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather_search(inputs)
	return __en.weather_search(inputs)
});
/**
* | output |
* | --- |
* | "Save outdoor chores for dry days" |
*
* @param {Weather_Sub_OffInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather_sub_off = /** @type {((inputs?: Weather_Sub_OffInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weather_Sub_OffInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather_sub_off(inputs)
	return __en.weather_sub_off(inputs)
});
/**
* | output |
* | --- |
* | "{place}: outdoor chores on dry days" |
*
* @param {Weather_Sub_OnInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather_sub_on = /** @type {((inputs: Weather_Sub_OnInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weather_Sub_OnInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather_sub_on(inputs)
	return __en.weather_sub_on(inputs)
});
/**
* | output |
* | --- |
* | "Where do you live?" |
*
* @param {Weather_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const weather_title = /** @type {((inputs?: Weather_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weather_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.weather_title(inputs)
	return __en.weather_title(inputs)
});
/**
* | output |
* | --- |
* | "Create a household" |
*
* @param {Welcome_CreateInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const welcome_create = /** @type {((inputs?: Welcome_CreateInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_CreateInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.welcome_create(inputs)
	return __en.welcome_create(inputs)
});
/**
* | output |
* | --- |
* | "Join with an invite code" |
*
* @param {Welcome_JoinInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const welcome_join = /** @type {((inputs?: Welcome_JoinInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_JoinInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.welcome_join(inputs)
	return __en.welcome_join(inputs)
});
/**
* | output |
* | --- |
* | "Sign in with a device code" |
*
* @param {Welcome_LinkInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const welcome_link = /** @type {((inputs?: Welcome_LinkInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_LinkInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.welcome_link(inputs)
	return __en.welcome_link(inputs)
});
/**
* | output |
* | --- |
* | "Who does it" |
*
* @param {Who_Does_ItInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const who_does_it = /** @type {((inputs?: Who_Does_ItInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Who_Does_ItInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.who_does_it(inputs)
	return __en.who_does_it(inputs)
});
/**
* | output |
* | --- |
* | "Pick someone to make this their chore. They'll be the only one who gets it." |
*
* @param {Who_Does_It_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const who_does_it_hint = /** @type {((inputs?: Who_Does_It_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Who_Does_It_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.who_does_it_hint(inputs)
	return __en.who_does_it_hint(inputs)
});
/**
* | output |
* | --- |
* | "{xp} / {next} XP until {name} grows" |
*
* @param {Xp_Until_GrowsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const xp_until_grows = /** @type {((inputs: Xp_Until_GrowsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xp_Until_GrowsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.xp_until_grows(inputs)
	return __en.xp_until_grows(inputs)
});
/**
* | output |
* | --- |
* | "Yay!" |
*
* @param {YayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const yay = /** @type {((inputs?: YayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<YayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.yay(inputs)
	return __en.yay(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "on {count} day" |
* | * | "on {count} different days" |
*
* @param {Year_DaysInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_days = /** @type {((inputs: Year_DaysInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_DaysInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_days(inputs)
	return __en.year_days(inputs)
});
/**
* | output |
* | --- |
* | "No chores yet this year. The story starts with your first one!" |
*
* @param {Year_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_empty = /** @type {((inputs?: Year_EmptyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_EmptyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_empty(inputs)
	return __en.year_empty(inputs)
});
/**
* | output |
* | --- |
* | "Here's to next year" |
*
* @param {Year_EndInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_end = /** @type {((inputs?: Year_EndInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_EndInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_end(inputs)
	return __en.year_end(inputs)
});
/**
* | output |
* | --- |
* | "Your signature move" |
*
* @param {Year_FavInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_fav = /** @type {((inputs?: Year_FavInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_FavInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_fav(inputs)
	return __en.year_fav(inputs)
});
/**
* | output |
* | --- |
* | "high-fives from housemates" |
*
* @param {Year_High_FivesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_high_fives = /** @type {((inputs?: Year_High_FivesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_High_FivesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_high_fives(inputs)
	return __en.year_high_fives(inputs)
});
/**
* | output |
* | --- |
* | "{year}, in chores" |
*
* @param {Year_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_intro = /** @type {((inputs: Year_IntroInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_IntroInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_intro(inputs)
	return __en.year_intro(inputs)
});
/**
* | output |
* | --- |
* | "Tap to see how it went" |
*
* @param {Year_Intro_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_intro_sub = /** @type {((inputs?: Year_Intro_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_Intro_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_intro_sub(inputs)
	return __en.year_intro_sub(inputs)
});
/**
* | output |
* | --- |
* | "Busiest month: {month}" |
*
* @param {Year_MonthInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_month = /** @type {((inputs: Year_MonthInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_MonthInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_month(inputs)
	return __en.year_month(inputs)
});
/**
* | output |
* | --- |
* | "{pet} grew into a {stage}" |
*
* @param {Year_PetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_pet = /** @type {((inputs: Year_PetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_PetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_pet(inputs)
	return __en.year_pet(inputs)
});
/**
* | output |
* | --- |
* | "Your room" |
*
* @param {Year_RoomInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_room = /** @type {((inputs?: Year_RoomInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_RoomInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_room(inputs)
	return __en.year_room(inputs)
});
/**
* | output |
* | --- |
* | "Your {year}" |
*
* @param {Year_RowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_row = /** @type {((inputs: Year_RowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_RowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_row(inputs)
	return __en.year_row(inputs)
});
/**
* | output |
* | --- |
* | "Your year in chores" |
*
* @param {Year_Row_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_row_sub = /** @type {((inputs?: Year_Row_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_Row_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_row_sub(inputs)
	return __en.year_row_sub(inputs)
});
/**
* | output |
* | --- |
* | "days in a row" |
*
* @param {Year_RunInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_run = /** @type {((inputs?: Year_RunInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_RunInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_run(inputs)
	return __en.year_run(inputs)
});
/**
* | output |
* | --- |
* | "Your longest run" |
*
* @param {Year_Run_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_run_sub = /** @type {((inputs?: Year_Run_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_Run_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_run_sub(inputs)
	return __en.year_run_sub(inputs)
});
/**
* | output |
* | --- |
* | "of everything done at home" |
*
* @param {Year_ShareInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_share = /** @type {((inputs?: Year_ShareInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_ShareInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_share(inputs)
	return __en.year_share(inputs)
});
/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} time" |
* | * | "{count} times" |
*
* @param {Year_TimesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_times = /** @type {((inputs: Year_TimesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_TimesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_times(inputs)
	return __en.year_times(inputs)
});
/**
* | output |
* | --- |
* | "chores done" |
*
* @param {Year_TotalInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const year_total = /** @type {((inputs?: Year_TotalInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Year_TotalInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.year_total(inputs)
	return __en.year_total(inputs)
});
/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {YesterdayInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const yesterday = /** @type {((inputs?: YesterdayInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<YesterdayInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.yesterday(inputs)
	return __en.yesterday(inputs)
});
/**
* | output |
* | --- |
* | "You" |
*
* @param {YouInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const you = /** @type {((inputs?: YouInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<YouInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.you(inputs)
	return __en.you(inputs)
});
/**
* | output |
* | --- |
* | "(you)" |
*
* @param {You_SuffixInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const you_suffix = /** @type {((inputs?: You_SuffixInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<You_SuffixInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.you_suffix(inputs)
	return __en.you_suffix(inputs)
});
/**
* | output |
* | --- |
* | "Your colour" |
*
* @param {Your_ColourInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_colour = /** @type {((inputs?: Your_ColourInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_ColourInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_colour(inputs)
	return __en.your_colour(inputs)
});
/**
* | output |
* | --- |
* | "Your companion" |
*
* @param {Your_CompanionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_companion = /** @type {((inputs?: Your_CompanionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_CompanionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_companion(inputs)
	return __en.your_companion(inputs)
});
/**
* | output |
* | --- |
* | "Your devices" |
*
* @param {Your_DevicesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_devices = /** @type {((inputs?: Your_DevicesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_DevicesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_devices(inputs)
	return __en.your_devices(inputs)
});
/**
* | output |
* | --- |
* | "Your home" |
*
* @param {Your_HomeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_home = /** @type {((inputs?: Your_HomeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_HomeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_home(inputs)
	return __en.your_home(inputs)
});
/**
* | output |
* | --- |
* | "Rooms, pets and appliances" |
*
* @param {Your_Home_SubInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_home_sub = /** @type {((inputs?: Your_Home_SubInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Home_SubInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_home_sub(inputs)
	return __en.your_home_sub(inputs)
});
/**
* | output |
* | --- |
* | "Answer a few questions for a better list" |
*
* @param {Your_Home_UnsetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_home_unset = /** @type {((inputs?: Your_Home_UnsetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Home_UnsetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_home_unset(inputs)
	return __en.your_home_unset(inputs)
});
/**
* | output |
* | --- |
* | "Your name" |
*
* @param {Your_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_name = /** @type {((inputs?: Your_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_name(inputs)
	return __en.your_name(inputs)
});
/**
* | output |
* | --- |
* | "Your week" |
*
* @param {Your_WeekInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_week = /** @type {((inputs?: Your_WeekInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_WeekInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return __nl.your_week(inputs)
	return __en.your_week(inputs)
});